const messagesAR = {
    code: "ar",
    messages: {
        zoho: {
            SETTING_GROUP: "الإعدادات",
            usermapping: "تعيين المستخدمين",
        },
        chatWindow: {
            thereIsNoChatContent: "لا يوجد محتوى للدردشة.",
            thereIsNoChatContentDsc: "يمكنك عرض محتوى الدردشة وإرسال الرسائل هنا.",
            interactions: "التفاعلات:",
            departments: "الأقسام",
            channels: "القنوات",
            date: "التاريخ",
            lastChatStatus: "آخر حالة للدردشة",
            all: "الكل",
            queued: "في الانتظار",
            open: "مفتوح",
            closed: "مغلق",
            private: "خاص",
            chatbot: "روبوت الدردشة",
            lostMissed: "مفقود / غير مستجاب",
            interaction: "التفاعل",
            myActiveInbox: "بريدي الوارد النشط",
            activeQueueInbox: "البريد الوارد النشط + الانتظار",
            chatbotActiveInbox: "البريد الوارد النشط لروبوت الدردشة",
            myDepartmentsActiveInbox: "البريد الوارد النشط لأقسامى",
            notInteractedYesterday: "لا تفاعلات بالأمس",
            queueInbox: "البريد الوارد في الانتظار",
            whatsappActiveInbox: "البريد الوارد النشط لـ WhatsApp",
            socialMediaActiveInbox: "البريد الوارد النشط لوسائل التواصل الاجتماعي",
            missedThisMonth: "الدردشات الفائتة هذا الشهر",
            chooseAFileOrDragItHere: "اختر ملفًا أو اسحبه هنا!",
            watching: "مشاهدة",
            selectFilter: "اختر مرشحًا",
            clearAll: "مسح الكل",
            me: "أنا",
            today: "اليوم",
            yesterday: "أمس",
            thisWeek: "هذا الأسبوع",
            lastWeek: "الأسبوع الماضي",
            last7Days: "آخر 7 أيام",
            last30Days: "آخر 30 يومًا",
            thisMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            last24h: "آخر 24 ساعة",
            custom: "مخصص",
            startMessage: "بدء الرسالة",
            goToAgentReport: "اذهب إلى تقرير الوكيل",
            agentDetail: "تفاصيل الوكيل",
            agentList: "قائمة الوكلاء",
            selectedFilter: "عامل التصفية المحدد",
            groupBy: "تجميع",
            none: "لا توجد مجموعة",
            agent: "ممثل",
            department: "قسم",
            tag: "التسمية",
            website: "الموقع الإلكتروني",
            channel: "القناة",
            platform: "المنصة",
            answerStatus: "حالة الإجابة",
            sortBy: "ترتيب",
            lastPostAbove: "آخر منشور في الأعلى",
            newChatsAbove: "الدردشات الجديدة في الأعلى",
            oldChatsAbove: "الدردشات القديمة في الأعلى",
            live: "يعيش",
            systemStatus: "حالة النظام",
            refresh: "تحديث",
            close: "إغلاق",
            totalCustomers: "إجمالي العملاء",
            totalAnswered: "إجمالي الردود",
            waitingAnswer: "بانتظار الرد",
            totalAgentInChat: "إجمالي الوكلاء في الدردشة",
            onlineAgentCount: "عدد الوكلاء المتصلين",
            totalCustomer: "إجمالي العميل",
            answered: "تم الرد",
            unanswered: "لم يتم الرد",
            noContactWasFoundMatchingTheCurrentFilters: "لم يتم العثور على أي جهة اتصال مطابقة للمرشحات الحالية.",
            you: "أنت",
            others: "الآخرون",
            queue: "قائمة الانتظار",
            chatbotContact: "شات بوت",
            closedContact: "مغلق",
            myInteractions: "تفاعلاتي",
            special: "خاص",
            allInteractions: "جميع جهات الاتصال",
            waiting: "قيد الانتظار",
            departmentToWhichItIsAffiliated: "القسم التابع له",
        },
        form: {
            title: {
                titleSettings: "إعدادات العنوان",
                fullNameSettings: "إعدادات الاسم الكامل",
                emailSettings: "إعدادات البريد الإلكتروني",
                addressSettings: "إعدادات العنوان",
                phoneSettings: "إعدادات الهاتف",
                datePickerSettings: "إعدادات منتقي التاريخ",
                shortTextSettings: "إعدادات النص القصير",
                longTextSettings: "إعدادات النص الطويل",
                dropDownListSettings: "إعدادات القائمة المنسدلة",
                singleChoiceSettings: "إعدادات الخيار الفردي",
                multipleSelectionSettings: "إعدادات التحديد المتعدد",
                numberSettings: "إعدادات الأرقام",
                hourSettings: "إعدادات الساعة",
                spinnerSettings: "إعدادات الدوار",
                sendSettings: "إعدادات الإرسال",
                starRatingSettings: "إعدادات التقييم بالنجوم",
                ratingScaleSettings: "إعدادات مقياس التقييم",
                separationElementSettings: "إعدادات عنصر الفصل",
                fileUploadSettings: "إعدادات تحميل الملفات",
                imageSettings: "إعدادات الصورة"
            },
            lineColor: "لون الخط",
            separatorColorInfo: "اختر أو أدخل لون الفاصل (مثل #RRGGBB)",
            separatorHeight: "ارتفاع الفاصل",
            separatorHeightInfo: "أدخل ارتفاع الفاصل",
            bottomSpace: "المسافة السفلية",
            bottomSpaceInfo: "أضف مسافة أسفل الفاصل",
            topSpace: "المسافة العلوية",
            topSpaceInfo: "أضف مسافة فوق الفاصل",
            sideSpace: "المسافة الجانبية",
            sideSpaceInfo: "أضف مسافة على اليسار واليمين من الفاصل",
            onlyImageUpload: "يمكنك تحميل صورة فقط!",
            imageSizeLimit: "يجب ألا يتجاوز حجم صورتك 5 ميجابايت!",
            image: "صورة",
            size: "حجم",
            width: "عرض",
            height: "ارتفاع",
            imageAlignment: "محاذاة الصورة",
            wide: "عريض",
            small: "صغير",
            textAlignment: "محاذاة النص",
            chooseHorizontalAlignment: "اختر كيفية محاذاة هذا العنوان أفقيًا.",
            headerSize: "حجم العنوان",
            addSmallTextBelowHeader: "أضف نصًا أصغر أسفل العنوان",
            subHeaderText: "نص العنوان الفرعي",
            subLabel1: "التسمية الفرعية(1)",
            subLabel2: "التسمية الفرعية(2)",
            validPhoneNumber: "الرجاء إدخال رقم هاتف صالح",
            masked: "مقنع",
            copyField: "نسخ الحقل",
            copyFieldDescription: "أنشئ نسخة من هذا الحقل مع الحفاظ على جميع إعداداته المسجلة",
            enterQuestion: "أدخل سؤالا",
            notRequired: "غير مطلوب",
            addDescriptionBelowField: "أضف وصفًا قصيرًا أسفل الحقل",
            setDefault: "تعيين كإفتراضي",
            pleaseSelect: "يرجى الاختيار",
            placeholder: "نص توضيحي",
            required: "إلزامي",
            fieldEmptyError: "لا تسمح بإرسال النموذج إذا كان هذا الحقل فارغًا",
            subLabels: "التسميات الفرعية",
            addressLine1: "العنوان - السطر 1",
            addressLine2: "العنوان - السطر 2",
            postalCode: "الرمز البريدي",
            stateProvince: "الولاية / المقاطعة",
            chooseLabelAlignment: "اختر كيفية محاذاة نص التسمية أفقيًا",
            right: "يمين",
            left: "يسار",
            top: "أعلى",
            labelAlignment: "محاذاة التسمية",
            fieldLabel: "تسمية الحقل",
            read: "تمت القراءة",
            itemsPerPage: "عنصر/صفحة",
            downloadAllDataAsPDF: "تنزيل كل البيانات بصيغة PDF",
            downloadAllDataAsExcel: "تنزيل كل البيانات بصيغة Excel",
            downloadSelectedDataAsPDF: "تنزيل البيانات المحددة بصيغة PDF",
            downloadSelectedDataAsExcel: "تنزيل البيانات المحددة بصيغة Excel",
            selectItemToViewDetails: "اختر عنصرًا لعرض التفاصيل.",
            deleteFormConfirm:
                "إذا قمت بحذف هذا النموذج، سيتم حذف جميع البيانات المرتبطة به بشكل دائم. هل أنت متأكد أنك تريد المتابعة؟",
            redicetFormAnswer: "إعادة توجيه إجابات النموذج",
            redicetFormAnswerDesc:
                "عند إعادة توجيه إجابات النموذج إلى نظام التذاكر، تأكد من طلب رقم هاتف أو عنوان بريد إلكتروني من المستخدم في النموذج. هذه المعلومات مهمة للتواصل بشكل أسرع وأكثر فعالية مع المستخدم.",
            redicetFormAnswerDesc2: "يتم توجيه إجابات النموذج إلى النظام كتذاكر.",
            rediectAnswersToTicket: "إعادة توجيه الإجابات الواردة إلى تذكرة.",
            errorTicketMode: "خطأ في تحديث وضع التذكرة:",
            formView: "عرض النموذج",
            formEdit: "نموذج التحديث",
            totalResponse: "إجمالي الاستجابة",
            totalUnreadResponse: "إجمالي الردود غير المقروءة",
            totalReadResponse: "إجمالي الاستجابة للقراءة",
            totalArchivedResponse: "إجمالي الاستجابة المحفوظة في الأرشيف",
            singleChoice: "خيار واحد",
            _delete: "حذف",
            inbox: "صندوق الوارد",
            edit: "تحرير",
            forms: "النماذج",
            formsDesc: "يمكنك إدارة النماذج الخاصة بك هنا.",
            createaForm: "إنشاء نموذج",
            allForms: "جميع الأشكال",
            formPublish: {
                shareFast: "شارك بسرعة",
                shareFastDesc: "رابط النموذج المباشر والمشاركة الاجتماعية",
                add: "الإضافة",
                addDesc: "خيارات تضمين صفحات الويب المختلفة",
                assignForm: "نموذج التعيين",
                assignFormDesc: "تعيين النماذج الخاصة بك للآخرين",
                emails: "الرسائل الإلكترونية",
                emailsDesc: "التذكيرات والمشاركة الفورية",
                prefill: "الملء المسبق",
                prefillDesc: "تعبئة النماذج مسبقاً",
                pdf: "PDF",
                pdfDesc: "تنزيل ملف PDF قابل للتعبئة",
                platforms: "المنصات",
                platformsDesc: "خيارات النشر للجهات الخارجية",
                linkToYour: "عنوان رابط النموذج الخاص بك",
                linkToYourDesc: "تم نشر النموذج الخاص بك بشكل آمن وهو جاهز للاستخدام على هذا العنوان.",
                shareWithLink: "المشاركة مع الرابط",
                publicForm: "النموذج العام",
                copyLink: "رابط النسخ",
                openInNewTab: "فتح في علامة تبويب جديدة",
                linkCopied: "تم نسخ الرابط",
                codeCopied: "تم نسخ الرمز",
                iframe: "إطار IFRAME",
                iframeDesc: "أضف النموذج إلى صفحتك باستخدام iFrame",
                openWindow: "نافذة مفتوحة",
                openWindowDesc: "رابط إلى نموذج منبثق",
                formAddDesc:
                    "انسخ هذا المقتطف والصقه في التعليمات البرمجية الخاصة بك، ثم ضع النموذج على موقعك الإلكتروني.",
            },
            formSettings: {
                enterNameForm: "أدخل اسماً لهذا النموذج",
                selectStatusForm: "حدد حالة النموذج الخاص بك",
                disabled: "معاق",
                disableSpecifiedTime: "تعطيل في وقت محدد",
                disableFormResponse: "تعطيل عند الوصول إلى حد استجابة النموذج",
                pageShownAfterForm: "الصفحة التي تظهر بعد إرسال النموذج",
                formNotFound: "النموذج غير موجود.",
                errorLoadingform: "حدث خطأ أثناء تحميل النموذج.",
                formUpdated: "تم تحديث عنوان النموذج بنجاح.",
                formErrorUpdated: "حدث خطأ أثناء تحديث عنوان النموذج",
                formSettings: "إعدادات النموذج",
                changeFormStateAndProperties: "تغيير حالة النموذج والخصائص",
                title: "العنوان",
                newFormSettings: "إعدادات النموذج الجديد",
                formStatus: "حالة النموذج",
                activateOrDeactivate: "تنشيط النموذج الخاص بك أو إلغاء تنشيطه أو تنشيطه بشكل مشروط",
                effective: "فعّال",
                yourFromIsVisible: "أصبح النموذج الخاص بك الآن مرئيًا ويمكنه تلقي ردود النموذج",
                emails: "الرسائل الإلكترونية",
                emailsDesc:
                    "إرسال رسائل البريد الإلكتروني الخاصة بالرد الآلي ورسائل البريد الإلكتروني الخاصة بالإشعارات",
                conditions: "الشروط",
                conditionsDesc: "قسم المنطق الشرطي الذي يقوم بتشغيل الإجراءات بناءً على مدخلات النموذج",
                thankYouPage: "صفحة شكرًا لك",
                thankYouPageDesc: "الصفحة التي تظهر بعد إرسال النموذج",
                integretions: "الاندماجات",
                integretionsDesc: "ربط النموذج الخاص بك بالتطبيقات الأخرى",
            },
            clickToDeleteYourLogo: "انقر لحذف شعارك",
            create: "إنشاء",
            settings: "الإعدادات",
            load: "التحميل",
            insertFormField: "إدراج حقل النموذج",
            addYourLogo: "أضف شعارك",
            surveyElements: {
                surveyElements: "عناصر المسح",
                dataTable: "جدول البيانات",
                starRating: "تصنيف النجوم",
                evaluationScale: "مقياس التقييم",
            },
            pageElements: {
                pageElements: "عناصر الصفحة",
                separationElement: "عنصر الفصل",
                partitionCollapse: "انهيار التقسيم",
                pageBreak: "نهاية الصفحة",
            },
            basicElements: {
                basicElements: "العناصر الأساسية",
                shortText: "نص قصير",
                longText: "نص طويل",
                paragraph: "الفقرة",
                dropDownList: "القائمة المنسدلة",
                singleChoice: "خيار واحد",
                multipleSelection: "اختيار متعدد",
                number: "العدد",
                image: "الصورة",
                fileUpload: "تحميل الملفات",
                hour: "ساعة",
                spinner: "سبينر",
                send: "إرسال",
            },
            formElements: {
                formElements: "عناصر النموذج",
                title: "العنوان",
                fullName: "الاسم الكامل",
                email: "البريد الإلكتروني",
                address: "العنوان",
                phone: "الهاتف",
                datePicker: "منتقي التواريخ",
                appointment: "التعيين",
                signature: "التوقيع",
                productList: "قائمة المنتجات",
            },
            startWithaBlankForm: "ابدأ بنموذج فارغ",
            startFromScratch: "ابدأ من الصفر",
            createOrTransferaForm: "إنشاء أو نقل نموذج لبدء جمع البيانات",
            createForm: "إنشاء نموذج",
        },
        automation: {
            calendarEventCreated: "تم إنشاء الحدث في التقويم",
            calendarEventUpdated: "تم تحديث الحدث في التقويم",
            calendarEventDeleted: "تم حذف الحدث من التقويم",
            reservationCreated: "تم إنشاء الحجز",
            reservationDateChanged: "تم تغيير تاريخ الحجز",
            reservationDeleted: "تم حذف الحجز",
            chatLost: "عندما يتم فقدان الدردشة",
            webchatCompleted: "عندما تكتمل الدردشة من الويب",
            instagramCompleted: "عندما تكتمل الدردشة من قناة إنستغرام",
            messengerCompleted: "عندما تكتمل الدردشة من قناة ماسنجر",
            whatsappCompleted: "عندما تكتمل الدردشة من قناة واتساب",
            telegramCompleted: "عندما تكتمل الدردشة من قناة تيليجرام",
            chatAssignedToAgent: "عندما يتم تعيين الدردشة لوكيل",
            profileButtonClicked: "عندما يتم النقر على زر الأتمتة من الملف الشخصي",
            operatedTask: "مهمة قيد التنفيذ",
            tableSelection: "تحديد الجدول",
            selectTable: "تحديد الجدول",
            whichTableAutomationAddRecords: "أي جدول تريد تشغيل الأتمتة عند إضافة سجل؟ الرجاء التحديد.",
            whichTableAutomationUpdateRecords: "هل تريد تشغيل الأتمتة عندما يتم تحديث سجل في أي جدول؟ الرجاء التحديد.",
            whichTableAutomationDeletedRecords: "من أي جدول تريد تشغيل الأتمتة عند حذف سجل؟ الرجاء التحديد.",
            whichTableAutomationClickRecords:
                "من أي جدول تريد تشغيل الأتمتة عند النقر على زر الأتمتة في سجل؟ الرجاء التحديد.",
            planStatus: "حالة الخطة",
            scheduled: "مجدول",
            completed: "مكتمل",
            cancelled: "تم الإلغاء",
            startTest: "بدء الاختبار",
            unpublish: "إلغاء النشر",
            whenMessagePicked: "عند تحديد رسالة عبر واجهة المحادثة",
            whenTaskCompleted: "عند اكتمال مهمة",
            whenTaskDeleted: "عند حذف مهمة",
            whenTaskAssigneeChanged: "عندما يتم تغيير المُعيَّن للمهمة",
            whenTaskPriorityChanged: "عند تغيير أولوية المهمة",
            whenTaskDueDateChanged: "عند تغيير تاريخ استحقاق المهمة",
            whenTaskStatusChanged: "عند تغيير حالة المهمة",
            whenTaskArchived: "عند أرشفة مهمة",
            whenTagAdded: "عند إضافة علامة إلى المهمة",
            whenTagRemovedTask: "عند إزالة علامة من مهمة",
            whenTagChecklist: "عند اكتمال قائمة التحقق من المهمة",
            whenReminderActivated: "عند تنشيط التذكير",
            whenTicketCreated: "عند إنشاء تذكرة",
            whenTicketStageChanged: "عند تغيير مرحلة التذكرة",
            whenTicketAssigneeChanged: "عندما يتم تغيير المُعيَّن للتذكرة",
            whenTicketClosed: "عندما يتم إغلاق التذكرة",
            whenTicketUpdated: "عندما يتم تحديث التذكرة",
            autoPlanAndTaskHistory: "خطة الأتمتة وسجل المهام",
            automation: "الأتمتة",
            botScenario: "سيناريو الروبوت",
            nameSurname: "الاسم واللقب",
            phone164: "*أدخله بتنسيق E164. على سبيل المثال: 905396667744",
            whichWpChannels: "أي قنوات واتساب تريد إضافتها؟",
            findContact: "البحث عن جهة اتصال",
            findContacts: "البحث عن جهات الاتصال",
            offsetDesc: "تخطي أول N من جهات الاتصال. القيمة الافتراضية هي '0'. استخدم هذا للتمرير عبر جهات الاتصال.",
            limitDesc:
                "الحد الأقصى لعدد جهات الاتصال المراد إرجاعها بعد الإزاحة. القيمة الافتراضية هي '10'. استخدم هذا لترقيم الصفحات",
            contact: "جهة الاتصال",
            selectAction: "تحديد الإجراء",
            addMethod: "طريقة الإضافة",
            selectField: "تحديد حقل",
            schedulerRunningPlanEx: "مثال على خطة تشغيل المجدول",
            schedulerPlanner: "مخطط المجدول",
            taskCreated: "تم إنشاء المهمة؟",
            taskStatus: "حالة المهمة",
            terminateReason: "سبب الإنهاء",
            taskDuration: "مدة المهمة",
            taskWakeUpCount: "عدد استيقاظ المهمة",
            completedAt: "مكتمل",
            cancelledAt: "تم الإلغاء",
            nextRunAt: "التشغيل التالي",
            configSchedulerAuto: "تكوين المؤقِّت للأتمتة",
            saveChanges: "حفظ التغييرات",
            catchAllWebhooks: "التقاط جميع خطافات الويب من عنوان URL هذا",
            webhookDataExPreview: "معاينة نموذج بيانات خطاف الويب (سيتم عرضها بعد إرسال الطلب)",
            webhookUrlCopied: "نسخ عنوان URL لخطاف الويب إلى الحافظة",
            selectAnBlock: "تحديد كتلة",
            dataFormats: "تنسيقات البيانات",
            whenRecordCreated: "عند إنشاء سجل",
            whenRecordUpdated: "عندما يتم تحديث سجل",
            whenRecordDelete: "عندما يتم حذف سجل",
            whenRecordAutomation: "عندما يتم النقر على زر أتمتة السجل",
            whenWebhookTriggered: "عندما يتم تشغيل خطاف الويب",
            whenChatCreated: "عندما يتم إنشاء دردشة",
            whenChatClosed: "عندما يتم إغلاق الدردشة",
            whenChatRated: "عندما يتم تصنيف دردشة",
            whenNewContactCreated: "عند إنشاء جهة اتصال جديدة",
            whenContactUpdate: "عند تحديث جهة اتصال",
            whenContactPropUpdate: "عند تحديث خاصية جهة اتصال",
            whenNewTagAdded: "عند إضافة علامة جديدة",
            whenTagRemoved: "عند إزالة علامة",
            whenNewEmailReceived: "عند استلام بريد إلكتروني جديد",
            whenNewTaskCreated: "عند إنشاء مهمة جديدة",
            whenNewMetaleadCreated: "عند إنشاء عميل تعريف جديد",
            whenNewAgentCreated: "عند إنشاء وكيل جديد",
            whenNewInvoiceCreated: "عند إنشاء فاتورة جديدة",
            whenNewWpReceived: "عند استلام رسالة واتساب جديدة",
            whenNewReservationCreated: "عند إنشاء حجز جديد",
            whenNewChatbotReceived: "عند استلام رسالة دردشة جديدة",
            chatWebhookAutomation: "التقاط خطاف ويب وتشغيل الأتمتة",
            automationName: "اسم الأتمتة",
            supsisObject: "كائن سوبسيس",
            selectModule: "تحديد النموذج",
            bodyType: "نوع الجسم",
            selectBodyType: "تحديد نوع الجسم",
            selectMethod: "تحديد طريقة",
            trigger: "الزناد",
            published: "منشور",
            createdAt: "تم الإنشاء في",
            action: "الإجراء",
            type: "النوع",
            view: "عرض",
            createTimerAutomation: "إنشاء أتمتة المؤقِّت",
            createEventBasedAutomation: "إنشاء أتمتة قائمة على الأحداث",
            createWebhookAutomation: "إنشاء أتمتة خطاف الويب",
            automationsDeletedSuccessfully: "تم حذف الأتمتة بنجاح",
            automationsCouldNotBeDeleted: "تعذر حذف الأتمتة",
            timerAutomationCreatedSuccessfully: "تم إنشاء أتمتة المؤقت بنجاح",
            eventAutomationCreatedSuccessfully: "إنشاء أتمتة الأحداث بنجاح",
            webhookAutomationCutomationCreatedSuccessfully: "تم إنشاء أتمتة خطاف الويب بنجاح",
            automationsCouldNouldNotBeFetched: "تعذر ضبط الأتمتة",
            automationPublishedStateUpdatedSupdatedSuccessfully: "تم تحديث حالة الأتمتة المنشورة بنجاح",
            automations: "الأتمتة",
            allAutomations: "جميع الأتمتة",
            scheduledAutomations: "الأتمتة المجدولة",
            eventBasedAutomations: "الأتمتة المستندة إلى الحدث",
            buttonAutomations: "أتمتة الأزرار",
            webhookAutomations: "أتمتة خطاف الويب",
            blocks: {
                START_POINT: "نقطة البداية",
                AI_ASSISTANT: "مساعد الذكاء الاصطناعي",
                BOT_RESPONSE: "استجابة الروبوت",
                AI_BOT_RESPONSE: "استجابة الذكاء الاصطناعي (GPT-4o)",
                AI_CLASSIFICATION: "تصنيف الذكاء الاصطناعي",
                AI_MENU_FLOW: "قائمة الذكاء الاصطناعي",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "otp sms",
                OTP_MAIL_FLOW: "بريد otp",
                AI_INSTAGRAM_FLOW: "ai instagram comment",
                PLATFORM_FLOW: "النظام الأساسي",
                DEFAULT_FALLBACK: "الاحتياطي الافتراضي",
                DEFAULT_TIMEOUT: "المهلة الافتراضية",
                AI_FUNCTIONS: "وظائف الذكاء الاصطناعي",
                FILTER: "مرشح",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "مدخلات المرفقات",
                USER_INPUT: "إدخال المستخدم",
                GO_TO_STEP: "الانتقال إلى الخطوة",
                WEBHOOK: "خطاف الويب",
                SET_ATTRIBUTE: "تعيين السمة",
                QUESTION: "سؤال",
                CLOSE_CHAT: "إغلاق الدردشة",
                CREATE_TICKET: "إنشاء تذكرة",
                TRANSFER_CHAT: "نقل الدردشة",
                TRANSFER_TO_CHATBOT: "إعادة توجيه إلى روبوت الدردشة",
                TAG_CHAT: "إضافة وسم",
                REMOVE_TAG: "إزالة وسم",
                SET_DEPARTMENT: "تعيين قسم",
                SEND_TRANSCRIPT: "إرسال نص",
                SEND_SMS: "إرسال رسائل قصيرة",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "إنشاء حدث",
                CREATE_RESERVATION: "إنشاء حجز",
                RESERVATION_OPEN_URL: "عنوان URL لفتح الحجز",
                RESERVATION_SELECT_DAY: "تحديد يوم الحجز",
                RESERVATION_EVENT_LIST: "زائر قائمة الحجز",
                RESERVATION_SELECT_TIME: "تحديد وقت الحجز",
                CREATE_TASK: "إنشاء مهمة",
                SHOPIFY_SHOW_PRODUCTS: "عرض منتجات SHOPIFY",
                SHOPIFY_PRODUCT_AVAILABILITY: "توفر المنتج من SHOPIFY",
                SHOPIFY_ORDER_STATUS: "حالة الطلب من SHOPIFY",
                AKINON_SHOW_PRODUCTS: "عرض منتجات AKINON",
                AKINON_FIND_PRODUCT: "العثور على منتج AKINON",
                AKINON_ORDER_STATUS: "حالة الطلب من AKINON",
                AKINON_SELECT_ORDER: "تحديد طلب AKINON",
                AKINON_SELECT_SIZE: "تحديد الحجم من AKINON",
                AKINON_FIND_NEAREST_STOCK: "إظهار مخزون المتجر",
                AKINON_FIND_NEAREST_STORES: "إظهار أقرب المتاجر",
                AKINON_SHOW_DISCOUNT_CODES: "إظهار رموز الخصم",
                SUPPRESSION_ADD: "حظر جهة الاتصال",
                SUPPRESSION_REMOVE: "إلغاء حظر جهة الاتصال",
                IDEASOFT_SELECT_ORDER: "تحديد الطلب",
                IDEASOFT_ORDER_STATUS: "الحصول على حالة الطلب",
                IDEASOFT_GET_MEMBER_INFO: "تعبئة معلومات الأعضاء",
                TICKET_UPDATE: "تحديث التذاكر",

                GET_LOCATION: "الحصول على الموقع",
                FALLBACK: "حالة الطوارئ",
                TIMEOUT: "مهلة",
                SUCCESS: "ناجح",
                FAILURE: "FAIL",

                PROBEL_SELECT_BRANCH: "تحديد فرع",
                PROBEL_SELECT_CLINIC: "تحديد مستوصف",
                PROBEL_SELECT_DAY: "حدد يوم الموعد",
                PROBEL_SELECT_HOUR: "حدد وقت الموعد",
                PROBEL_MAKE_APPOINTMENT: "تحديد موعد",
                PROBEL_CANCEL_APPOINTMENT: "إلغاء الموعد",
                PROBEL_GET_PATIENT_TOKEN: "الحصول على الرمز المميز للمريض",
                PROBEL_FILL_INFO: "الحصول على معلومات MERNIS",
                PROBEL_SELECT_APPOINTMENT: "تحديد موعد",

                SEND_WP_BUSINESS_MESSAGE: "إرسال رسالة واتساب",
                INSTAGRAM_COMMENT_REPLY: "الرد على تعليق",
                INSTAGRAM_COMMENT_DELETE: "حذف تعليق",
                INSTAGRAM_COMMENT_SHOW: "إظهار التعليق",
                INSTAGRAM_COMMENT_HIDE: "إخفاء التعليق",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "الرد كخاص",
                LOOP: "حلقة",
                LOOP_NEXT: "حلقة العنصر التالي",
                LOOP_BREAK: "كسر الحلقة",
                LOOP_CONTINUE: "متابعة الحلقة التالية",
                LOOP_FINISH: "إنهاء الحلقة",
                SLEEP: "النوم",
                NOOP: "Noop",
                CATCH_WEBHOOK: "CATCH_WEBHOOK",
                TERMINATE_AUTOMATION: "إنهاء الأتمتة",
                CREATE_CONTACT: "إنشاء جهة اتصال",
                UPDATE_CONTACT: "تحديث جهة الاتصال",
                FIND_CONTACTS: "البحث عن جهات الاتصال",
                FIND_CONTACT: "البحث عن جهة اتصال",
                FIND_CHATS: "البحث عن الدردشات",
                FIND_CHAT: "البحث عن دردشة",
                WAIT_FOR: "انتظار",
                STRING_FORMAT: "تنسيق سلسلة",
                NUMBER_FORMAT: "تنسيق رقم",
                DATE_FORMAT: "تنسيق التاريخ",
                RECORDS_FROM_CSV: "السجلات من CSV",
                MESSAGE_RECEIVED: "تم استلام الرسالة",

                ASK_AI: "الذكاء الاصطناعي",

                TABLE_CREATE_RECORD: "إنشاء سجل",
                TABLE_DELETE_RECORD: "حذف سجل",
                TABLE_UPDATE_RECORD: "تحديث سجل",
                TABLE_FIND_RECORD: "البحث عن سجل",
                TABLE_FIND_RECORDS: "قائمة السجلات",

                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho البحث عن سجل (بواسطة الهاتف)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho إضافة ملف إلى السجل",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho تحميل صورة إلى حقل مخصص",
                ZOHO_CREATE_RECORD: "Zoho إنشاء سجل",

                GET_SUPSIS_RECORD_BY_ID: "Supsis البحث عن سجل (بواسطة المعرف)",
            },
        },
        modules: {
            createFailed: "فشل إنشاء الوحدة",
            createSuccess: "تم إنشاء الوحدة بنجاح",
            moduleDeletedSuccessfully: "تم حذف الوحدة بنجاح",
            deleteModuleTitle: "حذف الوحدة",
            deleteModuleContent: "هل أنت متأكد أنك تريد حذف هذه الوحدة؟",
            modules: "الوحدات",
            modulesSettings: "إعدادات الوحدات",
            displayName: "اسم العرض",
            description: "الوصف",
            table: "الجدول",
            menuApiSettings: "إعدادات القائمة وواجهة برمجة التطبيقات",
            icon: "أيقونة",
            save: "حفظ",
            exampleIcon: "مثال: extension, home",
            newModule: "وحدة جديدة",
            moduleName: "اسم الوحدة",
            apiName: "اسم واجهة برمجة التطبيقات",
            type: "نوع",
            apiAccess: "وصول واجهة برمجة التطبيقات",
            actions: "الإجراءات",
            module: "وحدة",
            relation: "علاقة",
            moduleRelationName: "اسم الوحدة / العلاقة",
            moduleRelationTable: "جدول الوحدة / العلاقة",
            showInMainMenu: "إظهار في القائمة الرئيسية",
            apiEnabled: "واجهة برمجة التطبيقات مفعلة",
            settings: "إعدادات",
            createModule: "إنشاء وحدة",
            relationType: "نوع العلاقة",
            standartModule: "وحدة قياسية",
            customTable: "جدول خاص",
            localField: "حقل محلي",
            showingRemoteFieldInList: "إظهار حقل منعزل في القائمة",
            relationSettings: "إعدادات العلاقة",
            remoteField: "حقل منعزل",
            localFieldType: "نوع حقل محلي",
            standart: "قياسي",
            custom: "خاص",
            contact: "إتصال",
            viewRecord: "عرض السجل",
            recordDetail: "تفاصيل السجل",
            recordNotFound: "السجل أو معلومات الجدول غير موجودة",
            relatedLists: "القائمة المتعلقة",
            recordViewer: "عارض السجلات",
        },
        tables: {
            today: "اليوم",
            month: "شهر",
            week: "أسبوع",
            day: "يوم",
            table: "جدول",
            kanban: "كانبان",
            calendar: "تقويم",
            calendarSettings: "إعدادات التقويم",
            colorBy: "اللون حسب",
            startDateField: "حقل تاريخ البدء",
            endDateField: "حقل تاريخ الانتهاء (اختياري)",
            eventCardFields: "حقول بطاقة الحدث",
            selectColorField: "اختر حقل اللون",
            selectStartDateField: "اختر حقل تاريخ البدء",
            selectEndDateField: "اختر حقل تاريخ الانتهاء",
            cancel: "إلغاء",
            save: "حفظ",
            kanbanNotAvailable: "عرض كانبان غير متاح",
            needDropdownField:
                "لاستخدام عرض كانبان، تحتاج إلى حقل قائمة منسدلة ثابت واحد على الأقل في جدولك. يمكنك إضافة حقل جديد أو تعديل حقل موجود من إعدادات الجدول.",
            notAvailable: "عرض التقويم غير متاح",
            needDateField:
                "تحتاج إلى حقل تاريخ واحد على الأقل في جدولك لاستخدام عرض التقويم. يمكنك إضافة حقل جديد أو تعديل حقل موجود من إعدادات الجدول.",
            switchToTable: "التبديل إلى عرض الجدول",
            operator: "المشغل",
            conditionalColor: "لون مخصص",
            groupField: "حقل المجموعة",
            selectDirection: "إختيار الاتجاه",
            showEmptyGroups: "إظهار المجموعات الفارغة",
            clearGrouping: "تفريغ المجموعة",
            applyGrouping: "تطبيق المجموعة",
            sortDirection: "إختيار الاتجاه",
            downloadSelectedRecords: "تنزيل السجلات المحددة",
            viewName: "اسم العرض",
            enterViewName: "أدخل اسم العرض",
            enterDesc: "أدخل الوصف",
            viewNameRequired: "اسم العرض مطلوب",
            runWebhookAutomation: "تشغيل أتمتة خطاف الويب",
            downloadAllRecords: "تنزيل جميع السجلات",
            deleteRecords: "حذف السجلات",
            editRecords: "تحديث السجلات",
            duplicateRecords: "تكرار السجلات",
            selected: "محدد",
            sureDeleteRecords: "هل أنت متأكد أنك تريد حذف السجلات؟",
            selectedRecordSucs: "تم حذف السجلات المحددة بنجاح",
            errorDeletingRecords: "حدث خطأ أثناء حذف السجلات.",
            sureCopyRecords: "هل تريد بالتأكيد نسخ السجلات؟",
            copyRecords: "نسخ السجلات",
            recordsCopiedSucs: "تم نسخ السجلات المحددة بنجاح.",
            recordsCopiedError: "حدث خطأ أثناء نسخ السجلات المحددة.",
            viewSucsCreated: "تم إنشاء طريقة العرض بنجاح.",
            editMultipleRecords: "تحرير سجلات متعددة",
            importRecords: "استيراد السجلات",
            importHasStarted: "بدأ الاستيراد. قد يستغرق الأمر بضع دقائق حسب حجم بياناتك. الرجاء الانتظار...",
            anErrorImport: "حدث خطأ أثناء الاستيراد.",
            recordCreated: "إنشاء سجل",
            recordUpdated: "تحديث السجل",
            recordDeleted: "حذف السجل",
            noAutomationDefined: "لم يتم تعريف الأتمتة بعد",
            nameTheAutomationAdd: "اسم الأتمتة التي سيتم تشغيلها عند إضافة سجل إلى هذا الجدول:",
            nameTheAutomationUpdate: "قم بتسمية الأتمتة التي سيتم تشغيلها عند تحديث سجل في هذا الجدول:",
            nameTheAutomationDelete: "قم بتسمية الأتمتة التي سيتم تشغيلها عند حذف سجل من هذا الجدول:",
            editField: "تحرير الحقل",
            sort: "فرز",
            ascending: "تصاعدي",
            descending: "تنازلي",
            createField: "إنشاء حقل",
            insertBefore: "إدراج قبل",
            insertAfter: "إدراج بعد",
            goToRelatedAuto: "الانتقال إلى الأتمتة ذات الصلة",
            permission: "إذن",
            lockField: "قفل الحقل",
            hideField: "إخفاء الحقل",
            deleteField: "حذف الحقل",
            watchVideo: "مشاهدة الفيديو",
            uploadError: "خطأ في التحميل",
            updateError: "خطأ في التحديث",
            invalidValue: "قيمة غير صالحة. الرجاء استخدام التنسيق الصحيح.",
            errorUpdatingRecord: "حدث خطأ أثناء تحديث السجل.",
            errorCreatingView: "حدث خطأ أثناء إنشاء طريقة العرض.",
            datetimeOptions: "خيارات التاريخ والوقت",
            numberOptions: "خيارات الأرقام",
            currencyOptions: "خيارات العملة",
            dropdownOptions: "خيارات القائمة المنسدلة",
            automationButtonOptions: "خيارات زر التشغيل الآلي",
            defaultLabel: "التسمية الافتراضية",
            disableWhenClicked: "تعطيل عند النقر",
            fieldSucsCreate: "تم إنشاء الحقل بنجاح",
            fieldCreatingFailed: "حدث خطأ أثناء إنشاء الحقل",
            fieldSucsUpdate: "تم تحديث الحقل بنجاح",
            fieldUpdatingFailed: "حدث خطأ أثناء تحديث الحقل",
            showAll: "إظهار الكل",
            hideAll: "إخفاء الكل",
            searchFields: "البحث عن الحقول",
            firstRowHeader: "الصف الأول يحتوي على رأس",
            separatorCharacter: "حرف فاصل",
            comma: "فاصلة",
            semicolon: "فاصلة منقوطة",
            tableFieldOrFileColumns: "تعيين حقل الجدول / أعمدة الملف",
            exampleResultPreview: "مثال على معاينة النتائج",
            newView: "عرض جديد",
            createViewaFiltering: "إنشاء طرق عرض لمتابعة تصفية الحقول وفرزها وإخفائها دون تغيير الجدول الرئيسي.",
            pleaseUpdateSelected: "الرجاء تحديد الحقل الذي تريد تحديثه للسجلات المحددة.",
            pleaseSelectedNewValue: "الرجاء إدخال القيمة الجديدة للحقل المحدد.",
            selectedMenuItem: "عنصر القائمة المحدد:",
            deleteTable: "حذف الجدول",
            sureDeleteTable: "هل أنت متأكد من رغبتك في حذف هذا الجدول؟",
            deleteTableSucs: "تم حذف الجدول بنجاح.",
            deleteTableError: "خطأ في حذف الجدول:",
            editTable: "تحرير الجدول",
            createNewField: "إنشاء حقل جديد",
            tables: "الجداول",
            tableName: "اسم الجدول",
            description: "الوصف",
            createTable: "إنشاء جدول",
            createNewTable: "إنشاء جدول جديد",
            allTables: "كل الجداول",
            myTables: "الجداول الخاصة بي",
            myFavorites: "مفضلاتي",
            errorCreatingTable: "خطأ في إنشاء جدول:",
            customerTable: "جدول العملاء",
            customerTableDesc: "جدول العملاء الافتراضي",
            leadTracking: "تتبع العملاء المحتملين",
            leadTrackingDesc: "جدول تتبع العملاء المحتملين",
            todoList: "قائمة المهام",
            todoListDesc: "قائمة لتتبع المهام",
            approvalReq: "طلب الموافقة",
            approvalReqDesc: "إدارة طلبات الموافقة",
            eventSchedule: "تقويم الأحداث",
            eventScheduleDesc: "جدولة الأحداث القادمة",
            inventoryList: "قائمة الجرد",
            inventoryListDesc: "تتبع مخزون المنتجات",
            bookingForm: "نموذج الحجز",
            bookingFormDesc: "تتبع الحجوزات",
            bugTracker: "تعقب الأخطاء",
            bugTrackerDesc: "تتبع أخطاء البرامج",
            employeeDirectory: "دليل الموظف",
            employeeDirectoryDesc: "يحتوي على معلومات الموظف",
            errorPullTable: "خطأ في سحب بيانات الجدول",
            newRecordSucs: "تم إنشاء سجل جديد بنجاح.",
            failedNewRecord: "فشل إنشاء سجل جديد:",
            newRecordCreateError: "حدث خطأ أثناء إنشاء سجل جديد.",
            recordCount: "عدد السجلات",
            increaseLimit: "زيادة الحد",
            newRecord: "سجل جديد",
            imports: "استيراد",
            exports: "تصدير",
            download: "تنزيل",
            automateYourData: "أتمتة بياناتك",
            recordUpdatedSucs: "تم تحديث السجل بنجاح",
            failToUpdateRecord: "فشل تحديث السجل",
            recordUpdatingError: "خطأ في تحديث السجل",
            mainTable: "الجدول الرئيسي",
            filter: "عامل التصفية",
            hideFields: "إخفاء الحقول",
            saveAsView: "حفظ كطريقة عرض",
            search: "بحث",
            create: "إنشاء",
            left: "يسار",
            center: "متوسط",
            right: "يمين",
            selectTimezone: "تحديد المنطقة الزمنية",
            createFieldSucs: "تم إنشاء الحقل بنجاح.",
            failCreateField: "فشل إنشاء الحقل:",
            createFieldError: "حدث خطأ أثناء إنشاء الحقل.",
            addCondition: "إضافة شرط",
            applyFilter: "تطبيق عامل التصفية",
            fieldType: "نوع الحقل",
            alignment: "محاذاة",
            blankTable: "جدول فارغ",
            templates: "قوالب",
            timezone: "المنطقة الزمنية",
            timeFormat: "تنسيق الوقت",
            includeTime: "تضمين الوقت",
            decimalFormat: "التنسيق العشري",
            currencySymbol: "رمز العملة",
            mode: "الوضع",
            statics: "ثابت",
            dynamic: "ديناميكي",
            multipleSelection: "اختيار متعدد",
            addOption: "إضافة خيار",
            text: "نص",
            longText: "نص طويل",
            number: "رقم",
            currency: "عملة",
            datetime: "التاريخ والوقت",
            dropdown: "قائمة منسدلة",
            checkbox: "خانة اختيار",
            email: "البريد الإلكتروني",
            phone: "هاتف",
            file: "ملف",
            image: "صورة",
            video: "فيديو",
            audio: "صوت",
            colour: "لون",
            automationButton: "زر التشغيل الآلي",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "أسبوع",
            readyContents: "المحتويات الجاهزة",
            webhookIntegration: "تكامل ويب هوك",
            businessChannel: "قناة واتساب للأعمال",
            confirmationFeature: "ميزة التأكيد",
            specialReporting: "تقارير خاصة",
            aiAssistant: "مساعد الذكاء الاصطناعي",
            flexibleBilling: "الفوترة المرنة",
            automaticReservation: "الحجز التلقائي",
            taskManagement: "إدارة المهام",
            calendarIntegration: "تكامل التقويم",
            activeChatbot: "الشات بوت النشط",
            smsIntegration: "تكامل الرسائل القصيرة",
            mailIntegration: "تكامل البريد",
            startChatWithVisitor: "بدء محادثة مع الزائر",
            whatsappManaging: "إدارة الواتساب",
            automaticChatbotButton: "زر / روبوت دردشة تلقائي",
            personalizedBroadcasts: "البث المخصص",
            chatWithNonContacts: "الدردشة مع غير المتصلين",
            broadcastMessaging: "الرسائل الجماعية",
            perBroadcast: "لكل بث",
            extraPricePerMessage: "سعر إضافي لكل رسالة",
            smartTrigger: "زنة ذكية",
            telegramIntegration: "تكامل تلغرام",
            instagramIntegration: "تكامل إنستجرام",
            ticketFeature: "ميزة التذاكر",
            storage: "تخزين",
            onePanelManagement: "إدارة لوحة واحدة",
            isolatedDatabaseConnection: "اتصال قاعدة بيانات معزول",
            removeLogo: "إزالة شعار Supsis",
            chatBaloonCustomization: "تخصيص بالون الدردشة",
            chatAndNotifications: "الدردشة والإشعارات",
            unlimited: "غير محدود",
            specialCustomerSupport: "دعم العملاء الخاص",
            softwareSupport: "دعم البرمجيات",
            standardSupport: "الدعم القياسي",
            teamChatIntegration: "تكامل دردشة الفريق",
            fileAndVoiceShare: "مشاركة الملفات والصوت",
            instantVisitor: "تتبع الزائر الفوري",
            detailedReporting: "تقارير مفصلة",
            normalreporting: "تقارير عادية",
            noExtraCosts: "لا تكاليف إضافية",
            accessibleToAllAgents: "يمكن الوصول إليها من قبل جميع الوكلاء",
            dataSecurity: "أمان البيانات",
            autoTranslate: "الترجمة التلقائية",
            chatbotVersionHistory: "سجل إصدارات الدردشة الآلية",
            chatbotStory: "قصة الدردشة الآلية",
            freeAgent: "العميل المجاني",
            stableAgentCount: "عدد الوكلاء الثابتة",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "خطط بأسعار معقولة",
            generalPlan: "خطة عامة",
            specialPlan: "خطة خاصة",
            currentPlan: "الخطة الحالية",
            selected: "مختار",
            popular: "شائع",
            trialPkg: "حزمة تجريبية",
            support: "الدعم على مدار الساعة",
            flexiblePricing: "تسعير مرن",
            rightToCancel: "الحق في الإلغاء في أي وقت",
            unlimitedCBScenario: "سيناريوهات الدردشة غير المحدودة",
            freeFirstScenario: "السيناريو الأول مجانًا",
            unlimitedLearn: "تدريب الدردشة غير المحدود",
            allPlatformIntegration: "التكامل مع جميع البنيات التحتية",
            detailedReports: "تقارير مفصلة",
            aiSupport: "دعم الذكاء الصناعي",
            creativeAI: "مساعد دردشة ذكاء اصطناعي سريع وواقعي",
            unlimitedSession: "جلسات غير محدودة في نفس الوقت",
            assistantFromWebsite: "إنشاء مساعد من الموقع الإلكتروني",
            assistantFromDoc: "إنشاء Chatbot من المستند",
            mobileApp: "تطبيق الجوال",
        },
        messenger: {
            channel: "قناة المسنجر",
            manageChannel: "إدارة القناة",
            channelDetail: "تفاصيل القناة",
            integrationTitle: "تكامل Messenger",
            deleteDesc: "هل أنت متأكد أنك تريد حذف قناة Messenger؟",
            channels: "قنوات المراسل",
            connectMessenger: "الاتصال بالمراسل",
            detail: "تفصيل",
            visibility: "رؤية",
            settings_group: "الإعدادات",
            commentsettings: "إدارة التعليقات",
            commentSettingsTitle: "إدارة تعليقات الماسنجر",
            commentSettingsDesc: "إدارة تعليقاتك على Messenger",
        },
        instagram: {
            channel: "قناة إنستجرام",
            detail: "تفصيل",
            visibility: "رؤية",
            settings_group: "الإعدادات",
            commentsettings: "إدارة التعليقات",
            commentSettingsTitle: "إدارة التعليقات على إنستغرام",
            commentSettingsDesc: "إدارة تعليقاتك على إنستغرام",
            commentSettingsTicket: "يضمن تسجيل التعليقات الواردة في النظام كتذاكر.",
            commentSettingsChatbot: "حدد سيناريو شات بوت الذي يجب توجيه التعليقات الواردة إليه.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "عرض كل Instagram القنوات",
        },
        calendar: {
            calendarsDesc: "تجنب تعارضات الجداول الزمنية.",
            generalAvailability: "التوفر العام",
            generalAvailabilityDesc: "تحديد الأوقات التي تكون متاحًا فيها بانتظام للمواعيد.",
            appointmentDuration: "مدة الموعد",
            appointDurationDesc: "كم من الوقت يجب أن يستمر كل موعد؟",
            customDuration: "المدة المخصصة",
            descriptionDesc:
                "إضافة ملاحظة تصف خدمتك. ستظهر الملاحظة التي تضيفها في صفحة الحجز وفي رسائل البريد الإلكتروني للتأكيد.",
            resForm: "نموذج الحجز",
            resFormDesc: "تخصيص النموذج الذي سيستخدمه الأشخاص لحجز موعد.",
            addField: "إضافة حقل",
            addAnItem: "إضافة عنصر",
            saveItem: "حفظ عنصر",
            planningTimeframe: "تخطيط الإطار الزمني",
            planningTimeframeDesc: "تحديد الإطار الزمني الذي يمكن فيه تحديد موعد.",
            availableAtMoment: "متاح الآن",
            startAndEndDate: "تواريخ البدء والانتهاء",
            maxNumberAppoint: "الحد الأقصى لعدد الأيام التي يمكن تحديد موعد بعدها",
            howLongMinAppoint: "المدة التي يمكن حجز الموعد بعدها",
            planningIntervalStartEnd: "تواريخ بدء فترة التخطيط وانتهائها",
            startTime: "وقت البدء",
            done: "تم",
            receivedAppointInterval: "الفاصل الزمني للمواعيد المستلمة",
            receivedAppointIntervalDesc: "إدارة المواعيد المستلمة لتظهر في التقويم الخاص بك",
            interimTime: "الوقت المؤقت",
            interimTimeDesc: "إضافة وقت بين فترات الاجتماعات",
            dayMaxRes: "الحد الأقصى لعدد الحجوزات في اليوم الواحد",
            dayMaxResDesc: "تحديد عدد المواعيد المحجوزة التي يمكن قبولها في يوم واحد",
            customise: "تعيين مخصص",
            noAvatar: "لا توجد صورة رمزية",
            organizationName: "اسم المنظمة",
            enterFullAdress: "أدخل العنوان الكامل",
            noCoverPhoto: "لا توجد صورة غلاف",
            enterAboutInfo: "أدخل معلومات عن",
            service: "الخدمة",
            deleteService: "حذف الخدمة",
            enterGoogleMapsUrl: "أدخل عنوان URL لخرائط Google",
            enterLatitude: "أدخل خط العرض",
            enterLongitude: "أدخل خط الطول",
            enterNumber: "أدخل رقم الهاتف",
            uploadAvatar: "تحميل صورة رمزية",
            teamMemberDeleteError: "خطأ في حذف عضو الفريق:",
            setupBookingWebsite: "إعداد موقع الحجز على الويب",
            bookingLandingPageBuilder: "منشئ صفحة الحجز",
            coverPhoto: "صورة الغلاف",
            enterOrganisationName: "أدخل اسم المؤسسة",
            about: "حول",
            services: "الخدمات",
            deleteServices: "حذف الخدمة",
            selectReservationPlan: "تحديد خطة الحجز",
            addNewService: "إضافة خدمة جديدة",
            addNewMember: "إضافة عضو جديد",
            fullAddress: "العنوان الكامل",
            latitude: "خط العرض",
            longitude: "خط الطول",
            contactDetails: "تفاصيل جهة الاتصال",
            emailAddress: "عنوان البريد الإلكتروني",
            enterEmail: "أدخل عنوان البريد الإلكتروني",
            websiteURL: "عنوان URL للموقع الإلكتروني",
            enterWebsiteURL: "أدخل عنوان URL للموقع الإلكتروني",
            reservationPolicy: "سياسة الحجز",
            enterResPolicy: "أدخل سياسة الحجز",
            workingHours: "ساعات العمل",
            selectEndHour: "تحديد وقت الانتهاء",
            addNewHour: "إضافة ساعة جديدة",
            updateMemberInfo: "تحديث معلومات العضو",
            errorRecevingData: "خطأ في استرداد البيانات:",
            anonymService: "خدمة مجهولة",
            unknownPlan: "خطة غير معروفة",
            errorCreatingMockPage: "خطأ في إنشاء صفحة وهمية:",
            failedToCreateBookingPage: "فشل في إنشاء صفحة الحجز",
            fileSizeToolLarge: "حجم الملف كبير جدًا",
            errorLoadingTheLogo: "خطأ في تحميل الشعار:",
            failedToLoadLogo: "فشل تحميل الشعار",
            errorUpdating: "خطأ في التحديث:",
            failedToUpdate: "فشل في التحديث",
            newMember: "عضو جديد",
            errorLoadingAvatar: "خطأ في تحميل الصورة الرمزية:",
            avatarFailedToLoad: "فشل تحميل الصورة الرمزية",
            teamMemberSuccessfullyDeleted: "تم حذف عضو الفريق بنجاح",
            teamMemberNotDelete: "فشل حذف عضو الفريق",
            yesDelete: "نعم، حذف",
            sureResDelete: "هل أنت متأكد من رغبتك في حذف هذا الحجز؟",
            resDetails: "تفاصيل الحجز",
            infoPersonMakingRes: "معلومات الشخص الذي قام بالحجز",
            appointmentProgram: "جدول المواعيد",
            goToAppointSettings: "الانتقال إلى إعدادات برنامج الموعد",
            resPlanCreateSuccess: "تم إنشاء خطة الحجز بنجاح",
            pleaseEnterTitle: "الرجاء إدخال العنوان",
            sureContinueSaving: "هل أنت متأكد من رغبتك في المتابعة بدون حفظ؟",
            appointProgram: "برنامج الحجز",
            everyMonth: "كل شهر",
            firstEveryMonth: "أول كل شهر",
            dayOf: "اليوم",
            notRepeat: "عدم التكرار",
            daily: "يومياً",
            weekly: "مرة في الأسبوع",
            monthly: "شهرياً",
            annually: "سنوي",
            custom: "مخصص",
            eventSaved: "حدث محفوظ",
            createAppoint: "إنشاء موعد",
            calendarSetting: "إعدادات التقويم",
            notAuthezord: "غير مصرح لك بإجراء هذه العملية",
            reservationWebPage: "صفحة الحجز على الويب",
            reservationPrograms: "برامج الحجز",
            addReservationProgram: "إضافة برنامج حجز",
            resPlanError: "خطأ في استلام خطط الحجز:",
            resDeleteSure: "هل أنت متأكد من أنك تريد حذف برنامج الحجز هذا؟",
            resDeleteSuccess: "تم حذف برنامج الحجز بنجاح.",
            resDeleteError: "خطأ في حذف برنامج الحجز:",
            unkownUser: "مستخدم غير معروف",
            eventNotFound: "لم يتم العثور على الحدث",
            reservations: "الحجوزات",
            events: "الفعاليات",
            upcoming: "القادم",
            past: "الماضي",
            setting: "الإعدادات",
            delete: "حذف",
            cancel: "إلغاء",
            save: "حفظ",
            close: "إغلاق",
            deleteRepeatEvent: "حذف الحدث المتكرر",
            thisEvent: "هذا الحدث",
            thisAndOtherEvent: "هذا الحدث والأحداث التالية",
            allEvent: "جميع الأحداث",
            ok: "موافق",
            googleCalendarLink: "إضافة إلى تقويم Google",
            yahooCalendarLink: "إضافة إلى تقويم Yahoo",
            subject: "الموضوع",
            visitor: "الزائر",
            allDay: "طوال اليوم",
            title: "العنوان",
            deleteEvent: "حذف الحدث",
            deleteEvents: "حذف الأحداث",
            deleteEventsSure: "هل أنت متأكد من أنك تريد حذف الأحداث من هذا التقويم؟",
            deleteEventConfirm: "هل أنت متأكد من أنك تريد حذف هذا الحدث؟",
            notEmptyTitle: "لا يمكن ترك العنوان فارغًا!",
            tasks: "المهام",
            googleConnect: "دمج Google",
            googleDisconnect: "إلغاء دمج Google",
            sure: "هل أنت متأكد؟",
            disconnectGoogleSure: "هل أنت متأكد من أنك تريد إلغاء دمج Google؟",
            yes: "نعم",
            no: "لا",
            customRepeat: "تكرار مخصص",
            recurrenceFrequency: "تكرار الحدوث",
            repeatDays: "تكرار في الأيام:",
            never: "أبدًا",
            thisDate: "في هذا التاريخ:",
            recurrenceCount: "عدد مرات التكرار:",
            end: "النهاية",
            event: "الحدث",
            calendars: "التقاويم",
            newCalendar: "إنشاء تقويم جديد",
            changeColor: "تغيير اللون",
            addCalendar: "إضافة تقويم",
            nameCalendar: "اسم التقويم",
            description: "الوصف",
            change: "تغيير",
            deleteCalendar: "حذف التقويم",
            deleteCalendarSure: "هل أنت متأكد من أنك تريد حذف هذا التقويم؟",
            notEmptyCalendarName: "لا يمكن أن يكون اسم التقويم فارغًا",
            myEvents: "أحداثي",
            everyoneEvents: "جميع الأحداث",
            haveEvent: "أحداث الوكيل",
            goCalendar: "اذهب إلى التقويم",
            goReservation: "إنشاء حجز",
            agents: "الوكلاء",
            today: "اليوم",
            month: "شهر",
            week: "أسبوع",
            day: "يوم",
            list: "قائمة",
        },
        ticimax: {
            segment: "قطاع",
            settings_group: "مجموعة الإعدادات",
            waitDayFromLastSend: "يوم الانتظار منذ آخر رسالة تم إرسالها",
            automationRuleName: "اسم قاعدة الأتمتة",
            time: "زمن",
            year: "سنة",
            month: "شهر",
            dayOfMonth: "يوم الشهر",
            day: "يوم",
            bySecond: "لكل ثانية",
            byMinute: "لكل دقيقة",
            byHour: "لكل ساعة",
            byWeekNo: "لكل رقم أسبوع",
            byYearDay: "لكل يوم في السنة",
            byMonthDay: "لكل يوم في الشهر",
            byMonth: "لكل شهر",
            december: "ديسمبر",
            november: "نوفمبر",
            october: "أكتوبر",
            september: "سبتمبر",
            august: "أغسطس",
            july: "يوليو",
            june: "يونيو",
            may: "مايو",
            april: "أبريل",
            march: "مارس",
            february: "فبراير",
            january: "يناير",
            byWeekDay: "لكل يوم في الأسبوع",
            interval: "فاصل زمني",
            seconds: "ثواني",
            minutes: "دقائق",
            hourly: "كل ساعة",
            daily: "يوميًا",
            weekly: "أسبوعيًا",
            monthly: "شهريًا",
            yearly: "سنويًا",
            frequency: "تكرار",
            attributes: {
                vip: "VIP",
                segment: "قطاع",
                province: "مقاطعة",
                country: "بلد",
                phone: "هاتف",
                email: "البريد الإلكتروني",
                fullname: "الاسم الكامل",
                couponPercent: "% من القسيمة",
                lastOrderDate: "آخر طلب",
                firstOrderDate: "أول طلب",
                county: "مقاطعة",
                lastSource: "آخر مصدر",
                firstSource: "أول مصدر",
                lastPaymentType: "آخر طريقة دفع",
                firstPaymentType: "أول طريقة دفع",
                maxOrderAmount: "الحد الأقصى لمبلغ الطلب",
                minOrderAmount: "الحد الأدنى لمبلغ الطلب",
                totalOrderAmount: "إجمالي مبلغ الطلب",
                totalOrderCount: "إجمالي عدد الطلبات",
                usedCouponAmount: "مبلغ القسيمة المستخدمة",
                usedCouponCount: "عدد القسائم المستخدمة",
                tookDayFromLastOrder: "أيام منذ آخر طلب",
                isCouponUser: "هل هو مستخدم قسيمة؟",
            },
            createAutomation: "إنشاء التلقائي",
            previous: "سابق",
            createAutomationDesc: "إنشاء وإدارة الأتمتة الرسائل",
            newTicimaxChannel: "قناة Ticimax الجديدة",
            connextToTicimaxXml: "الاتصال بخدمة XML Ticimax",
            connectTicimax: "الاتصال بـ Ticimax",
            examplePreview: "معاينة المثال",
            completeAutomationRule: "قاعدة الأتمتة الكاملة",
            configureMessage: "تكوين الرسالة",
            automationTimer: "المؤقت الآلي",
            findTargetMembers: "العثور على الأعضاء المستهدفين",
            createAutomationRule: "إنشاء قاعدة الأتمتة",
            action: "عمل",
            status: "الحالة",
            triggeredUserCount: "عدد المستخدمين المفعلين",
            nextScheduled: "المقررة التالية",
            timerRule: "قاعدة المؤقت",
            automationRules: "قواعد الأتمتة",
            apply: "تطبيق",
            searchAMember: "البحث عن عضو",
            segmentedMembersDesc: "قائمة وأتمتة الأعضاء المجزأين",
            manageVisibilityDesc: "إدارة رؤية القناة",
            xmlOrderListURL: "عنوان URL لقائمة الطلبات XML",
            manageIntegrationDesc: "إدارة تكامل Ticimax الخاص بك",
            detail: "التفاصيل",
            ticimaxChannelsTitle: "قنوات Ticimax",
            ticimaxDetail: "تفاصيل Ticimax",
            settingsGroup: "الإعدادات",
            visibility: "الرؤية",
            members: "الأعضاء",
            automation: "الأتمتة",
            integrationChannel: "قناة التكامل",
            channelUpdated: "تم تحديث القناة بنجاح",
            channelUpdateFailed: "فشل تحديث القناة",
        },
        notification: {
            contactOwner: "تغيير مالك الدردشة، تعيين مالك وإزالة مالك",
            mobileApp: "التطبيق المحمول",
            webPanel: "لوحة الويب",
            notifications: "الإشعارات",
            whatsappActions: "إجراءات الواتساب",
            chatbotActions: "إجراءات الدردشة الآلية",
            companyActions: "إجراءات الشركة",
            crmActions: "إجراءات CRM SUPSIS",
            basicActions: "الإجراءات الأساسية",
            notificationSettingsDesc: "اختر الإشعارات التي تريد تلقيها وأين تريد تلقيها.",
            noNotificationDesc2:
                "هنا سترى جميع الإشعارات المتعلقة بالوظائف والمرشحين وحمامات المواهب التي تتابعها. يمكنك تخصيص الإشعارات عن طريق ضبط الإعدادات.",
            noNotificationTitle2: "لا يوجد إشعارات بعد.",
            noNotificationTitle1: "لا توجد إشعارات. استمتع بالسكون.",
            adjustSettings: "ضبط الإعدادات",
            showAll: "إظهار الكل",
            showOnlyUnread: "عرض فقط غير المقروءة",
            mailWasSent: "تم إرسال البريد الإلكتروني.",
            mailAdressRemoved: "تمت إزالة عنوان البريد الإلكتروني.",
            chatbotPublished: "تم نشر الإصدار <b>{version}</b> من الدردشة الآلية بواسطة <b>{user}</b>.",
            chatbotDeleted: "تم حذف الدردشة الآلية <b>{chatbot}</b> بواسطة <b>{user}</b>.",
            settingsUpdatedWoDetail: "تم تحديث الإعدادات بواسطة <b>{user}</b>.",
            noActivityDesc: "لا توجد حاليًا أي أنشطة في النظام. يجب أن تحدث بعض الأحداث",
            noActivityTitle: "لا يوجد نشاط بعد",
            actionType: "نوع الحركة",
            dateBetween: "تاريخ بين",
            selectActor: "اختر المستخدم",
            activities: "أنشطة",
            chatbotCreated: "تم إنشاء الدردشة الآلية ذات الاسم <b>{chatbot}</b> بواسطة <b>{user}</b>.",
            taskStageChanged:
                "تم تغيير مرحلة المهمة <b>{task}</b> من <b>{oldStage}</b> إلى <b>{newStage}</b> بواسطة <b>{user}</b>.",
            taskCreated: "تم إنشاء المهمة <b>{task}</b> بواسطة <b>{user}</b>.",
            contactPropRemoved: "تمت إزالة خاصية الزائر <b>{prop}</b> بواسطة <b>{user}</b>.",
            contactPropAdded: "تمت إضافة خاصية الزائر <b>{prop}</b> بواسطة <b>{user}</b>.",
            userRemoved: "تمت إزالة المستخدم <b>{oldUser}</b> بواسطة <b>{user}</b>.",
            loginFormUpdated: "تم تحديث نموذج تسجيل الدخول للزائر بواسطة <b>{user}</b>.",
            loginFormDeactivated: "تم تعطيل نموذج تسجيل الدخول بواسطة <b>{user}</b>.",
            loginFormActivated: "تم تنشيط نموذج تسجيل الدخول بواسطة <b>{user}</b>.",
            invoiceRefunded: "تمت عملية الاسترداد بواسطة <b>{user}</b>.",
            paymentMethodAdded: "تمت إضافة طريقة دفع جديدة بواسطة <b>{user}</b>.",
            invoicePaymentFailed: "لم يتم قبول دفع الفاتورة من قبل <b>{user}</b>.",
            invoicePaymentReceived: "تم قبول دفع الفاتورة بواسطة <b>{user}</b>.",
            planStarted: "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{details} مندوب</b>).",
            planStartedChatbot:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} جلسة</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} قنوات واتساب</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} قنوات واتساب للأعمال</b>).",
            PlanCanceled: "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{details} مندوب</b>).",
            planCanceledChatbot:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} جلسة</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} قنوات واتساب</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} قنوات واتساب للأعمال</b>).",
            invoiceCreated: "تم إنشاء الفاتورة بواسطة <b>{user}</b>.",
            billingAddressUpdated: "تم تحديث معلومات العنوان بواسطة <b>{user}</b>.",
            taskWorkflowDeleted: "تم حذف سير العمل <b>{workflow}</b> بواسطة <b>{user}</b>.",
            whatsappBroadcastFailed: "فشل إرسال رسالة البث ذات العنوان <b>{title}</b>.",
            whatsappBroadcastCancelled: "تم إلغاء إرسال رسالة البث ذات العنوان <b>{title}</b>.",
            whatsappBroadcastCompleted: "تم إرسال رسالة بث بعنوان <b>{title}</b> بنجاح إلى <b>{numbers}</b> مستلمين.",
            whatsappBroadcastCreated:
                "تم إرسال رسالة بث بعنوان <b>{title}</b> إلى <b>{numbers}</b> مستلمين بواسطة <b>{user}</b>.",
            ticketAssigned: "تم تعيين تذكرة لـ <b>{user2}</b> بواسطة <b>{user1}</b>.",
            userLoggedIn: "قام <b>{user}</b> بتسجيل الدخول إلى SUPSIS.",
            chatJoined: "انضم <b>{agent}</b> إلى المحادثة مع <b>{visitor}</b>.",
            chatForwarded: "تم تحويل المحادثة مع <b>{visitor}</b> إلى <b>{agent}</b> بواسطة <b>{user}</b>.",
            chatAssigned: "تم تعيين الدردشة مع <b>{visitor}</b> إلى <b>{agent}</b> من قبل النظام.",
            customerGroupUpdated: "تم تحديث المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            customerGroupRemoved: "تمت إزالة المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            customerGroupAdded: "تم إنشاء المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            contentRemoved: "تمت إزالة المحتوى الجاهز <b>{content}</b> بواسطة <b>{user}</b>.",
            contentAdded: "تمت إضافة المحتوى الجاهز <b>{content}</b> بواسطة <b>{user}</b>.",
            channelVisibilityChanged: "تم تغيير رؤية قناة التكامل <b>{channel}</b> بواسطة <b>{user}</b>.",
            taskDeleted: "تم حذف المهمة <b>{task}</b> بواسطة <b>{user}</b>.",
            userRemovedToDepartment:
                "تمت إزالة المستخدم <b>{user2}</b> من قسم <b>{department}</b> بواسطة <b>{user1}</b>.",
            userAddedToDepartment:
                "تمت إضافة المستخدم <b>{user2}</b> إلى قسم <b>{department}</b> بواسطة <b>{user1}</b>.",
            mailAddressAdded: "تمت إضافة عنوان البريد الإلكتروني <b>{email}</b> بواسطة <b>{user}</b>",
            settingUpdate: "تم التحديث بواسطة <b>{user}</b>:",
            taskWFlowCreated: "تم إنشاء تدفق العمل للمهام <b>{Wflow}</b> بواسطة <b>{user}</b>.",
            bannedWordRemoved: "تمت إزالة الكلمة المحظورة <b>{bWord}</b> بواسطة <b>{user}</b>.",
            bannedWordCreated: "تم إنشاء الكلمة المحظورة <b>{bWord}</b> بواسطة <b>{user}</b>.",
            welcomeMessageRemoved: "تمت إزالة رسالة الترحيب <b>{welcome}</b> بواسطة <b>{user}</b>.",
            welcomeMessageAdded: "تم إنشاء رسالة ترحيب <b>{welcome}</b> بواسطة <b>{user}</b>.",
            tagRemoved: "تمت إزالة العلامة <b>{tag}</b> بواسطة <b>{user}</b>.",
            tagAdded: "تمت إضافة العلامة <b>{tag}</b> بواسطة <b>{user}</b>.",
            roleRemoved: "تمت إزالة الدور <b>{role}</b> بواسطة <b>{user}</b>.",
            roleAdded: "تمت إضافة الدور <b>{role}</b> بواسطة <b>{user}</b>.",
            departmentRemoved: "تمت إزالة القسم <b>{department}</b> بواسطة <b>{user}</b>.",
            departmentAdded: "تمت إضافة القسم <b>{department}</b> بواسطة <b>{user}</b>.",
            triggerUpdated: "تم تحديث المشغل بواسطة <b>{user}</b>.",
            triggerRemoved: "تمت إزالة المشغل بواسطة <b>{user}</b>.",
            triggerAdded: "تم إنشاء مشغل جديد بواسطة <b>{user}</b>.",
            webhookRemoved: "تمت إزالة webhook <b>{user1}</b> بواسطة <b>{user2}</b>",
            webhookAdded: "تمت إضافة Webhook بواسطة <b>{user1}</b>, تمت إضافتها بواسطة <b>{user2}</b>.",
            chatClosed: "تم إنهاء المحادثة مع <b>{visitor}</b> بواسطة <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> بدأ دردشة <b>{platform}</b> مع <b>{visitor}</b>.",
            chatOpenedByVisitor: "دردشة <b>{platform}</b> تم بدءها بواسطة <b>{visitor}</b>.",
            channelRemoved: "تمت إزالة القناة <b>{channel}</b> بواسطة <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> أنشأ ممثلاً يدعى <b>{newAgent}</b>.",
            visitorUnblocked: "الزائر <b>{visitor}</b> تم إلغاء حظره بواسطة المستخدم <b>{agent}</b>.",
            visitorBlocked: "تم حظر الزائر <b>{visitor}</b> بواسطة <b>{agent}</b>.",
            userStatusChanged: "قام المستخدم <b>{name}</b> بتغيير الحالة من <b>{oldStatus}</b> إلى <b>{newStatus}</b>.",
            channelCreated: "تم إنشاء القناة <b>{channel}</b> بواسطة <b>{name}</b>.",
            reservationCreatedPlan: "قام <b>{name}</b> بجدولة الموعد بعنوان <b>{title}</b> لتاريخ <b>{date}</b>.",
            chatOwnerUpdated: "<b>{agent}</b> أعاد تعيين <b>{visitor}</b> من <b>{oldOwner}</b> إلى <b>{newOwner}</b>.",
            customerOwnershipRemoved:
                "<b>{actor}</b> أزال ملكية <b>{visitor}</b> من <b>{oldOwner}</b> وتركه دون مالك.",
            customerOwnershipAssigned:
                "<b>{actor}</b> قام بتعيين ملكية <b>{visitor}</b> من دون مالك إلى <b>{newOwner}</b>.",
            customerOwnershipReassigned:
                "<b>{actor}</b> أعاد تعيين ملكية <b>{visitor}</b> من <b>{oldOwner}</b> إلى <b>{newOwner}</b>.",
            reservationUpdatedPlan: "قام <b>{name}</b> بتحديث الموعد بعنوان <b>{title}</b>.",
            reservationDeletedPlan: "قام <b>{name}</b> بحذف الموعد بعنوان <b>{title}</b>.",
            reservationCreated: "تم إنشاء حجز للمستخدم <b>{name}</b> والزائر <b>{visitor}</b> في تاريخ <b>{date}</b>.",
            reservationDeleted:
                "تم إلغاء الموعد المقرر بين المستخدم <b>{name}</b> والزائر <b>{visitor}</b> في تاريخ <b>{date}</b>.",
            chatAssignedMe: "عندما يتم تعيين محادثة لي",
            ticketAssignedMe: "عندما يتم تعيين تذكرة لي",
            taskAssignedMe: "عندما يتم تعيين مهمة لي",
            myChatClosed: "عند إغلاق الدردشة التي أمتلكها",
            tagActionsToVisitor: "تمت إضافة أو إزالة الوسوم من جهة اتصال",
            ticketCreated:
                "تم إنشاء التذكرة من قبل الزائر أو الروبوت الدردشة. كما يتم إرسال رسالة دون اتصال عند إرسالها من عنصر واجهة محادثة",
            notesActions: "تمت إضافة ملاحظة أو إزالتها من عميل.",
            visitorProfileUpdated: "تم تحديث ملف الزائر",
            chatStartedByAnyPlatform: "يتم بدء الدردشة على أي منصة من قبل جهة الاتصال أو الوكيل",
            userActions: "المستخدم تم إنشاؤه أو تحديثه أو حذفه",
            departmentActions: "القسم تم إنشاؤه أو تحديثه أو حذفه",
            settingsActions: "الإعدادات تم إنشاؤها أو تحديثها أو حذفها",
            integrationsActions: "تم إنشاء القناة المتكاملة أو تحديثها أو حذفها",
            loginFormActions: "تم تحديث نموذج تسجيل الدخول أو تنشيطه أو إلغاء تنشيطه",
            bannedWordActions: "تم إنشاء كلمة محظورة أو تحديثها أو حذفها",
            emailActions: "تم إنشاء حساب البريد الإلكتروني أو حذفه",
            preparedContentActions: "تم إنشاء المحتوى المعد أو حذفه",
            roleActions: "تم إنشاء الدور أو تحديثه أو حذفه",
            tagActions: "تم إنشاء العلامة أو تحديثها أو حذفها",
            welcomeMessageActions: "تم إنشاء رسالة الترحيب أو تحديثها أو حذفها",
            webhookActions: "تم إنشاء webhook أو تحديثه أو حذفه",
            billingEvents: "أحداث الفوترة",
            workflowCreated: "عند إنشاء سير العمل",
            workflowDeleted: "عند حذف سير العمل",
            createdTask: "عند إنشاء المهمة",
            taskStatusChanged: "عند تغيير حالة المهمة",
            deletedTask: "عند حذف المهمة",
            taskWorkflowCrud: "تم إنشاء سير عمل المهمة أو تحديثه أو حذفه",
            taskCrud: "تم إنشاء المهمة أو تحديثها أو حذفها",
            systemStatus: "تغيرات حالة النظام عبر الإنترنت أو دون اتصال",
            chatbotStoryCrud: "تم إنشاء قصة الروبوت الدردشة أو تحديثها أو حذفها",
            chatbotForwardAgent: "الروبوت الدردشة يحيل دردشة إلى وكيل",
            userSegmentCrud: "تم إنشاء قطاع المستخدم أو تحديثه أو حذفه",
            chatbotCreditLow: "عندما يكون رصيد الدردشة منخفضًا",
            wpCreditLow: "عندما يكون رصيد واتساب منخفضًا",
            wpCustomerGroupCrud: "عند إنشاء مجموعة عملاء واتساب أو تحديثها أو حذفها",
            wpBroadcastMessageStatus: "عند إرسال رسالة بث واتساب أو إكمالها أو إلغائها",
            wpTemplateMesssageCrud: "عند إنشاء رسالة قالب واتساب أو تحديثها أو حذفها",
            reservationMessageCrud: "تم إنشاء الحجز وتحديثه وإلغاؤه",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "جديد",
                visitor: "شخص",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "الأتمتة",
                table: "طاولة",
                module: "وحدة",
                message: "رسالة",
            },
            calendar: "التقويم",
            audioSettings: "إعدادات الصوت",
            allNotificationSettings: "إعدادات الإشعارات",
            allAuditLogs: "جميع سجلات التدقيق",
            allNotifications: "جميع الإعلامات",
            allActivities: "جميع الأنشطة",
            workflow: "سير العمل",
            editTask: "تحرير مهمة",
            tasks: "المهام",
            todo: "أشياء يجب القيام بها",
            tapTo: "اضغط على ⇥ لـ '{البداية}",
            newUsers: "مستخدم جديد ⇥ مستخدم جديد",
            newTags: "علامة جديدة ⇥ علامة جديدة",
            newRole: "دور جديد",
            newTrigger: "مشغل جديد",
            newSection: "قسم جديد",
            newTicket: "تذكرة جديدة",
            jumpSettings: "إعدادات القفز",
            jumpIntegrations: "التكاملات",
            jumpTeam: "فريق",
            jumpUsers: "المستخدمون",
            jumpReport: "تقرير",
            timingSettings: "إعدادات التوقيت",
            exampleVisitorMail: "البريد الإلكتروني للزائر@example.com",
            languageAndRegion: "اللغة والمنطقة",
            theme: "السمة",
            appearance: "المظهر",
            color: "اللون",
            background: "الخلفية",
            smart: "ذكي",
            teamChat: "دردشة الفريق",
            chatbot: "روبوت الدردشة",
            chatbotTraining: "تدريب روبوت الدردشة الآلية",
            chatbotUserSegments: "شرائح مستخدم روبوت الدردشة الآلية",
            chatbotIntegration: "تكامل روبوت الدردشة الآلية",
            chatbotEntities: "كيانات روبوت الدردشة الآلية",
            chatbotIntegrationWebHook: "تكامل خطاف الويب لروبوت الدردشة الآلي",
            chatbotArchive: "أرشيف روبوت الدردشة الآلية",
            chatbotTemplatesAI: "قوالب الذكاء الاصطناعي لروبوت الدردشة الآلية",
            chatbotTemplates: "قوالب روبوت الدردشة الآلية",
            chatbotReportsOverall: "التقارير الإجمالية لروبوت الدردشة الآلية",
            chatbotReportsAllChats: "تقارير روبوت الدردشة الآلية جميع الدردشات",
            chatbotReportsRatingDistribution: "توزيع تصنيف تقارير روبوت الدردشة الآلية",
            chatbotReportsPaidChats: "تقارير روبوت الدردشة الآلية للمحادثات المدفوعة",
            chatbotReportsBusiestPeriod: "الفترة الأكثر انشغالاً في روبوت الدردشة الآلية",
            chatbotTemplatesAllMessages: "قوالب جميع رسائل روبوت الدردشة الآلية",
            chatbotTemplatesAverage: "متوسط قوالب روبوت الدردشة الآلية",
            chatbotTemplatesPopularity: "شعبية قوالب روبوت الدردشة الآلية",
            chatbotTemplatesAllUser: "قوالب جميع مستخدمي روبوت الدردشة الآلية",
            ticket: "طلبات الدعم",
            archives: "الأرشيفات",
            tags: "الوسوم",
            offlineSupportRequests: "طلبات الدعم غير المتصلة بالإنترنت",
            roles: "الأدوار",
            users: "المستخدمون",
            topics: "الموضوعات",
            contents: "المحتويات",
            welcomeMessages: "رسائل الترحيب",
            catalog: "كتالوج",
            forbiddenWords: "الكلمات المحظورة",
            bannedVisitors: "الزائرون المحظورون",
            application: "التطبيق",
            mailMessages: "رسائل البريد",
            visitors: "الزائرون",
            webhookIntegration: "تكامل خطاف الويب",
            invoices: "الفاتورة",
            newReport: "تقرير جديد",
            integrationOperations: "عمليات التكامل",
            chatbotStory: "قصص روبوت المحادثة",
            searchPlaceHolder: "بحث أو انتقال أو إضافة...",
            searchAreaTitle: "بحث سوبسيس",
            searchAreaDesc1: "يمكنك البحث عن أي شيء. فقط",
            searchAreaDesc2: "أو",
            searchAreaDesc3: "اكتب أو ابحث عن أي شيء.",
            navigation: "التنقل",
            selectBtn: "تحديد",
            cancelBtn: "إلغاء",
            integration: {
                shouldByInstaPack:
                    "يجب عليك شراء حزمة Instagram لإنشاء قناة Instagram. يمكنك الوصول إلى الباقات بأسعار معقولة على الفور.",
                createInstaInstaLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة Instagram. الحد الأقصى.",
                createInstaContinue:
                    "يمكنك إنشاء قناة على Instagram. للمتابعة، قم بترقية الحزمة الخاصة بك أو احذف بعض قنوات Instagram الخاصة بك.",
                privatePolicy: "سياسة خاصة.",
                termsAndCondition: "الشروط والأحكام.",
                readAndAgree: "لقد قرأت وأوافق.",
                shouldByByMessengerPack:
                    "يجب عليك شراء باقة ماسنجر لإنشاء قناة ماسنجر. يمكنك الوصول إلى الباقات بأسعار معقولة على الفور.",
                createMessengerMessengerLimitMax: "لقد وصلت إلى الحد الأقصى لإنشاء قناة مسنجر. الحد الأقصى.",
                createMessengerContinue:
                    "يمكنك إنشاء قناة مسنجر. للمتابعة، قم بترقية الحزمة الخاصة بك أو احذف بعض قنوات المسنجر الخاصة بك.",
                selectMessengerAccount: "تحديد حساب مسنجر.",
                directClientsForward: "👉 وكلاء مباشرون إلى الأمام",
                allSections: "جميع الأقسام",
                deleteAll: "حذف الكل",
                wpBusinessAPI: "عمليات التكامل - قنوات واجهة برمجة تطبيقات واتساب للأعمال",
                wpV1: "التكاملات - قنوات واتساب المتعددة",
                instagram: "التكاملات - إنستغرام",
                instagramContactList: "التكاملات - قائمة جهات اتصال إنستغرام",
                mail: "التكاملات - البريد",
                whatsapp: "التكاملات - واتساب",
                whatsappContactList: "التكاملات - قائمة جهات اتصال واتساب",
                wpBCRequests: "عمليات التكامل - طلبات رسائل واتساب المجمعة",
                wpBCCustomerGroups: "عمليات التكامل - مجموعات عملاء واتساب المجمعة",
                wpBCTemplates: "عمليات التكامل - قوالب الرسائل المجمعة على واتساب",
                chatbot: "التكاملات - روبوت الدردشة",
            },
            settings: {
                settings: "الإعدادات",
                features: "الإعدادات - الميزات",
                languageAndRegion: "الإعدادات - اللغة والمنطقة",
                bubbleSettings: "الإعدادات - إعدادات الفقاعة",
                bubbleActions: "الإعدادات - إجراءات الفقاعة",
                themeSettings: "الإعدادات - إعدادات السمة",
                visitorLoginForm: "الإعدادات - نموذج تسجيل دخول الزائر",
                visitorAttribute: "الإعدادات - سمات الزائر",
                talkSettings: "الإعدادات - إعدادات المحادثة",
                autoAssign: "الإعدادات - تعيين تلقائي",
                chatTimingSettings: "الإعدادات - إعدادات وقت الدردشة",
                availability: "الإعدادات - التوفر",
                websiteIntegration: "الإعدادات - تكامل موقع الويب",
                developer: "الإعدادات - المطور",
            },
        },
        mail: {
            broadcastCreatedSuccess: "تم إنشاء البث بنجاح",
            confirmArchive: "هل أنت متأكد أنك تريد أرشفة هذا البث؟",
            archive: "أرشفة",
            cancel: "إلغاء",
            archiveSuccess: "تم أرشفة البث بنجاح",
            archiveError: "خطأ أثناء أرشفة البث",
            empty: "فارغ",
            summerDiscounts: "خصومات الصيف",
            opportunities: "فرص",
            newMailTemplateCreated: "إنشاء قالب بريد إلكتروني جديد",
            dateRange: "نطاق التاريخ",
            templateName: "اسم القالب",
            category: "الفئة",
            templateUpdateSucs: "تم تحديث القالب بنجاح.",
            templateUpdateError: "حدث خطأ أثناء تحديث القالب.",
            marketing: "تسويق",
            operational: "تشغيلي",
            custom: "خاص",
            pleaseEnterTemplateName: "الرجاء إدخال اسم القالب",
            pleaseEnterTemplateSubject: "الرجاء إدخال موضوع القالب",
            pleaseSelectTemplateCategories: "الرجاء تحديد فئات القالب",
            representMails: "رسائل تمثيلية",
            otherRepresentMails:
                "يمكنك تتبع رسائل البريد الإلكتروني الواردة والصادرة من وإلى عناوين البريد الإلكتروني للممثلين الآخرين.",
            signatureAutoAdd: "تم تغيير حالة الإضافة التلقائية للتوقيع بنجاح",
            autoAdd: "إضافة تلقائية",
            forwardEmailAddSucs: "تمت إضافة عنوان بريد إلكتروني لإعادة التوجيه بنجاح",
            errorAddingForwardEmail: "حدث خطأ أثناء إضافة عنوان بريد إلكتروني معاد توجيهه.",
            mailAddForward: "تمت الإضافة اليدوية (تمت إعادة التوجيه)",
            mailAddForwarding: "إضافة يدوية (اكتملت إعادة التوجيه)",
            broadcast: "منشورات",
            templates: "قوالب",
            newMailArrived: "وصل بريد جديد",
            mailSentSucs: "تم إرسال البريد بنجاح.",
            representativeMails: "بريد تمثيلي",
            createNewEmail: "إنشاء بريد إلكتروني جديد",
            canNotUserMail: "تعذر إرسال بريد إلكتروني لعدم وجود بريد مستخدم",
            mailAddressReq: "عنوان البريد مطلوب",
            emailAddressInvalid: "عنوان البريد غير صالح",
            departmentIsNotValid: "القسم غير صالح",
            mailSendNotValid: "غير صالح من عنوان البريد",
            routingSteps: "خطوات التوجيه",
            owner: "المالك",
            whereHeDirected: "إلى أين وجه",
            forwardingEmailAddress: "إعادة توجيه عنوان البريد الإلكتروني",
            deleteMailDesc: "لا يمكن التراجع عن هذا الإجراء.",
            deleteMailTitle: "هل أنت متأكد أنك تريد حذف عنوان البريد الإلكتروني هذا؟",
            gmailForwardMail: "إعادة توجيه البريد الإلكتروني في Gmail",
            senderMailAddressDesc: "يرجى إدخال عنوان بريد الإلكتروني للمرسل",
            verified: "تم التحقق",
            notForwarded: "غير معاد توجيهه",
            notVerified: "غير مؤكد",
            default: "افتراضي",
            isVerified: "تم التحقق",
            forwarding: "إعادة التوجيه",
            mailAdress: "عنوان البريد الإلكتروني",
            addSenderAddress: "إضافة عنوان المُرسِل",
            outlookForward: "توجيه Microsoft (Outlook/Exchange)",
            gmailForward: "توجيه Google (Gmail)",
            senderMail: "بريد المُرسِل",
            mailDetail: "تفاصيل البريد",
            mailNotFound: "البريد غير موجود",
            mailSelecting: "اختيار البريد",
            newMail: "بريد جديد",
            myMails: "رسائلي البريدية",
            inbox: "صندوق الوارد",
            sent: "تم الإرسال",
            departmentMails: "رسائل البريد الإلكتروني للقسم",
            newTemplate: "قالب جديد",
            unread: "غير مقروء",
            unreply: "Unanswered",
            ly: "الرد",
            attachments: "مرفقات البريد",
            To: "إلى",
            From: "من",
            placeHolders: "عناصر البديل",
            attacheFiles: "إرفاق الملفات",
            replyAll: "الرد على الجميع",
            forward: "إعادة توجيه",
            deleteThread: "حذف المحادثة",
            markAsRead: "وضع علامة كمقروء",
            markAsAllRead: "وضع علامة على الكل كمقروء",
            emailEditor: "محرر البريد الإلكتروني",
            integrateYourMail: "ادمج بريدك الإلكتروني",
            connect: "اتصل",
            departmentMail: "البريد الإلكتروني للقسم",
            createMailAddress: "إنشاء عنوان بريد إلكتروني",
            createNewMail: "إنشاء بريد جديد",
        },
        visitor: {
            downloadAll: "تحميل الكل",
            saveAsCustomerGroup: "الحفظ كمجموعة عملاء",
            saveSearchFavorite: "حفظ البحث كمفضلة",
            mail: "بريد",
            visitorDetail: "تفاصيل الزائر",
            selectedUser: "{selectedUser} من بين {totalUsers} مستخدم محدد",
            uncheck: "إلغاء تحديد الكل",
            checkAll: "تحديد الكل",
            matchedUsers: "{checkedCount} مستخدم مطابق",
            more: "المزيد",
            exportUsers: "تصدير المستخدمين المحددين",
            exportAllUsers: "تصدير جميع المستخدمين",
            addSegment: "إضافة قطاع",
            deleteCheckedUser: "حذف المستخدمين المحددين",
            deleteAllUser: "حذف جميع المستخدمين",
            matchedFilter: "مطابقة جميع الفلاتر",
            visitor: "الزائر",
            deleteUser: "حذف المستخدم",
            userData: "بيانات المستخدم",
            lastSession: "الجلسة الأخيرة",
            notUserData: "لا توجد بيانات مستخدم",
            segments: "الأقسام",
            tags: "العلامات",
            addTag: "إضافة علامة",
            userChats: "محادثات المستخدم",
            seeAll: "عرض الكل",
            confirm: "تأكيد",
            manageSegments: "إدارة الأقسام",
            search: "بحث",
            manageTags: "إدارة العلامات",
            allAttributes: "عرض جميع الخصائص",
            noData: "لا توجد بيانات",
            noEmail: "لا يوجد بريد إلكتروني",
            noIpAddress: "العنوان IP غير موجود.",
            noWpNumber: "الرقم غير موجود.",
            filterName: "اسم الفلتر..",
            matchedContacts: "{chechkedCount} الاتصالات المتطابقة",
        },
        chatbotv2: {
            typeStoryTitle: "أكتب عنوان القصة",
            setUpUpYourChatbot: "إعداد روبوت الدردشة الآلي الخاص بك",
            setUpUpYourChatbotDesc:
                "تدريب روبوت الدردشة الآلي الخاص بك باستخدام البيانات، استخدم قوالبنا الجاهزة للاستخدام أو ابدأ من الصفر.",
            blankBot: "روبوت فارغ",
            blankBotDesc: "إنشاء روبوت محادثة فارغ يمكنك تدريبه وتخصيصه لاحقًا.",
            websiteDesc: "فحص محتوى موقعك الإلكتروني للحصول على إجابات لأسئلة المستخدمين الشائعة.",
            yourNeedEnterEnterYourOpenAi:
                "تحتاج إلى إدخال مفتاح OpenAI API الخاص بك لإنشاء روبوت دردشة آلي عن طريق الزحف إلى موقعك الإلكتروني.",
            createOpenAiKey: "إنشاء مفتاح واجهة برمجة التطبيقات",
            aiKnowledge: "معرفة الذكاء الاصطناعي",
            modalUsage: "استخدام مشروط",
            usedContentSources: "مصادر المحتوى المستخدمة",
            websites: "مواقع الويب",
            articles: "المقالات",
            faq: "الأسئلة الشائعة",
            files: "الملفات",
            functions: "الوظائف",
            settings: "الإعدادات",
            disableAi: "تعطيل الذكاء الاصطناعي",
            enableAi: "تمكين الذكاء الاصطناعي",
            lastEdited: "آخر تعديل",
            state: "الحالة",
            frequentlyAskedQuestions: "الأسئلة المتداولة (FAQ)",
            faqIsCreated: "الأسئلة الشائعة التي تم إنشاؤها",
            selectKnowEnabled: "تمكين قواعد المعرفة المحددة...",
            selectKnowDisabled: "تم تعطيل قواعد المعرفة المحددة...",
            selectKnowNotEnabled: "قواعد المعرفة المحددة غير ممكّنة...",
            selectKnowNotDisabled: "قواعد المعرفة المحددة غير معطلة.",
            answered: "تمت الإجابة",
            answer: "تمت الإجابة",
            addFile: "إضافة ملف",
            fileDeleted: "تم حذف الملفات",
            fileDeletedFailed: "كانت هناك مشكلة في حذف الملفات",
            noFileAdded: "لم تتم إضافة أي ملف",
            aiFunctions: "وظائف الذكاء الاصطناعي",
            addFunction: "إضافة دالة",
            parameterCount: "عدد المعلمات",
            auto: "تلقائي",
            usedByAI: "يستخدمه الذكاء الاصطناعي",
            usedByAi: "مستخدم من قبل الذكاء الاصطناعي",
            notUsed: "غير مستخدم",
            saveAndClose: "حفظ وإغلاق",
            contentPreview: "معاينة المحتوى",
            addContent: "إضافة محتوى",
            populerUserQuestion: "مسح محتوى موقع الويب الخاص بك للحصول على إجابات لأسئلة المستخدم الشائعة",
            enterUrlAddress: "أدخل عنوان URL",
            sharingYourUrl: "من خلال مشاركة عنوان URL الخاص بك، فإنك تؤكد أن لديك الحقوق اللازمة لمشاركة محتواه.",
            pageSelected: "الصفحات المحددة",
            trainChatbot: "تدريب روبوت الدردشة",
            thereAreOnePages: "توجد صفحة واحدة بالداخل",
            categoryDesc: "الفئة. اختر الفئة التي تريد استخدامها لتدريب نموذج الذكاء الاصطناعي الخاص بك.",
            scarpOrAddContent: "قص أو إضافة محتوى، يمكن لمساعد الذكاء الاصطناعي استخدامه للرد على استفسارات عملائك",
            noContentAdded: "لا يوجد محتوى مضاف",
            howItWorks: "كيف يعمل",
            editEntries: "تحرير الإدخالات",
            newEntries: "إدخالات جديدة",
            chatbotManagement: "إدارة روبوت المحادثة",
            chatbotScenarioList: "قائمة شينيريو الدردشة الآلية",
            exportDiagramToClipboard: "تصدير الرسم البياني إلى الحافظة",
            selectedStory: "{count} قصة محددة",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "تمت إزالة القمع",
            suppressionAdded: "تمت إضافة القمع",
            didntSuppression: "لم تقم بأي قمع.",
            whatsappIntegrationTitle: "تكامل واتساب V1 وواتساب V2",
            whatsappApiIntegrationTitle: "تكامل واجهة برمجة تطبيقات واتساب للأعمال",
            ReadyTemplateBadge: "قالب جاهز",
            readyTemplates: "قوالب جاهزة",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "شعار الدردشة الآلية",
            chatbotName: "اسم الدردشة الآلية",
            allSecnario: "قائمة سيناريوهات Chatbot",
            ChatbotScenarioList: "قائمة سيناريوهات Chatbot",
            Scenario: "سيناريو",
            filters: {
                equal: "مساوي ل",
                not_equal: "ليس متساويًا",
                contain: "يحتوي",
                not_contain: "لا تحتوي",
                starts_with: "ابدا ب",
                ends_with: "ينتهي",
                empty: "فارغ",
                non_empty: "غير فارغ",
                longer_than: "اطول من",
                shorter_than: "اقصر من",
                less_than: "أقل من",
                less_or_equal: "أقل أو متساوية",
                greater_than: "أكثر من",
                greater_or_equal: "أكبر من أو يساوي",
            },
            planRequired: "{integratable} الخطة المطلوبة",
            noDefaultStoryTitle: "قصة افتراضية",
            noDefaultStory: "لا توجد قصة افتراضية.",
            noMessage: "لا توجد رسالة",
            loading: "تحميل",
            loadMore: "تحميل المزيد",
            hostname: "اسم المضيف",
            goToStory: "اذهب إلى القصة",
            noResultFound: "لم يتم العثور على نتائج",
            checkYourFilterCombination: "تحقق من مزيج المرشح الخاص بك",
            clearYourSearch: "امسح بحثك",
            andTryAgain: "وحاول مرة أخرى",
            allTemplates: "جميع القوالب",
            allAITemplates: "جميع قوالب الذكاء الاصطناعي",
            templatesFromTheIndustry: "قوالب من الصناعة",
            basicTemplate: "القالب الأساسي",
            proTemplate: "قالب متقدم",
            withBot: "& bot",
            userWithBot: "المستخدم والوبوت",
            chatDetail: "تفاصيل الدردشة",
            allUserDetail: "انظر كل تفاصيل المستخدم",
            sessionData: "بيانات الجلسة",
            supsisChatWidget: "supsis دردشة القطعة",
            integratedWith: "تتكامل مع :",
            botStory: "قصة الروبوت",
            integration: "اندماج",
            Users: "مستخدم",
            user_id: "معرف المستخدم",
            categories: "فئات",
            worksWith: "يعمل مع",
            importBot: "استيراد روبوت",
            keyFeatures: "دلائل الميزات",
            importing: "الاستيراد",
            comingSoon: "قريباً",
            pickStory: "اختر قصة",
            conversationId: "معرف المحادثة",
            integrateStoryWithSupsisWidget: "دمج أداة Supsis مع قصة chatbot",
            integrateStoryWithWhatsapp: "دمج WhatsApp مع قصة chatbot",
            integrateStoryWithInstagram: "دمج Instagram مع قصة chatbot",
            selectIntegratingStory: "حدد القصة التي سيتم دمجها",
            install: "ثَبَّتَ",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "بريد إلكتروني",
                phone: "هاتف",
                language: "لغة",
                timezone: "وحدة زمنية",
                gender: "جنس",
                country: "دولة",
                referrer: "المرجع",
                department: "قسم",
                url: "عنوان URL",
                ip: "IP",
                last_seen: "اخر ظهور",
                name: "اسم",
                user_id: "معرف المستخدم",
                message: "رسالة",
                akinon_brand: "ماركة",
                akinon_order_id: "رقم التعريف الخاص بالطلب",
                akinon_product_id: "معرف المنتج",
                akinon_user_id: "معرف المستخدم",
                akinon_user_name: "اسم المستخدم",
                akinon_user_email: "البريد الالكتروني للمستخدم",
                akinon_invoice_url: "عنوان URL فاتورة",
                akinon_order_status: "حالة الطلب",
                akinon_order_price: "سعر الطلب",
                akinon_shipper_name: "أسم المورد",
                akinon_product_size: "حجم المنتج",
                akinon_sku: "SKU",
                akinon_product_url: "عنوان URL للمنتج",
                akinon_product_title: "عنوان المنتج",
                akinon_product_image: "صورة المنتج",
                akinon_product_stock: "مخزون المنتج",
                akinon_order_date: "تاريخ الطلب",
                akinon_track_number: "رقم الشاحنة",
                akinon_track_url: "تتبع عنوان URL",
                akinon_latitude: "خط العرض",
                akinon_longitude: "خط الطول",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                visitor_trigger_type: "نوع مشغل الزائر",
                visitor_trigger_name: "اسم مشغل الزائر",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "وضع غير متصل بالشبكة",
                available_agents: "الوكلاء المتاحين",
                probel_sube_kodu: "كود الفرع",
                probel_brans_adi: "اسم الفرع",
                probel_brans_kodu: "كود الفرع",
                probel_doktor_adi: "اسم الطبيب",
                probel_doktor_kodu: "كود الطبيب",
                probel_poliklinik_adi: "اسم العيادة",
                probel_poliklinik_kodu: "كود العيادة",
                probel_randevu_tarihi: "تاريخ الموعد",
                probel_date: "تاريخ الموعد",
                probel_randevu_saati: "وقت الموعد",
                probel_randevu_id: "معرف الموعد",
                probel_hasta_token: "رمز المريض",
                probel_kimlik_tipi: "نوع الهوية",
                probel_kimlik_no: "رقم الهوية",
                probel_hasta_adi: "اسم المريض",
                probel_hasta_soyadi: "لقب المريض",
                probel_hasta_cinsiyet: "الجنس",
                probel_hasta_dogum_tarihi: "تاريخ الميلاد",
                probel_hasta_telefon: "الهاتف",
                platform: "منصة",
                hour: "ساعة",
                segments: "Segments",
                tags: "الوسوم",
                ticket: "تذكرة",
                metaReferrals: "إحالات ميتا",
            },
            storyList: "قائمة القصة",
            douYouWannaDeleteItem: "هل تريد حذف هذا البند؟",
            douYouWannaDeleteWithChildren: "هل تريد حذف هذا العنصر مع أطفاله؟",
            stories: "قصص",
            templates: "قوالب",
            aitemplates: "قوالب الذكاء الاصطناعي",
            integrations: "التكامل",
            all: "الجميع",
            installed: "المثبتة",
            installationOK: "المثبتة",
            uninstall: "الغاء التثبيت",
            remainingMessageDesc: "الرسائل المجانية المتبقية:",
            openAISiteRoutingDescStart: "يمكنك النقر على الرابط",
            openAISiteRoutingDescEnd: "للحصول على مفتاح API.",
            integrationOK: "مدمج",
            chatWidget: "supsis دردشة القطعة",
            artificialIntelligence: "الذكاء الاصطناعي",
            integratePlatform: "يمكن دمج chatbot مع {integretable}.",
            integrateOpenAIWithChatbot: "دمج الدردشة GPT-4 مع chatbot",
            integrateChatBotWithChatGPT3: "تكامل chatbot مع الدردشة GPT-4",
            integrateStoryWithTelegram: "دمج القصة مع Telegram",
            webhooks: "Webhooks",
            archive: "أرشيف",
            reports: "التقارير",
            uncheckAll: "الغاءالكل",
            userSegments: "شرائح المستخدم",
            addSegment: "إضافة الجزء",
            addToSegment: "أضف إلى المقطع",
            removeFromSegment: "ترفع من الجزء",
            plansVTippyContent:
                "سيتم الفوترة لهذه الحزمة في بداية كل شهر ، وفي حالة رغبتك في الإلغاء ، سيتم فرض رسوم على استخدامك حتى بداية الشهر وستنتهي حزمتك.<br><br>سعر الحزمة هو سعر خارجي لضريبة القيمة المضافة.<br><br>تظهر التغييرات في الحزمة في الفاتورة في اليوم التالي.",
            segmentName: "اسم الجزء",
            sameSegment: "هناك قطاع بنفس الاسم!",
            usersInSegment: "المستخدمون في المقطع",
            noUsersAdded: "لم يضف أي مستخدمين",
            updateSegment: "تحديث الجزء",
            newSegment: "شريحة جديدة",
            selectAll: "اختر الكل",
            queriesSelected: "الاستعلامات المحددة",
            noBlocksFound: "لم يتم العثور على كتل!",
            userQuery: "استعلام المستخدم",
            date: "تاريخ",
            unmatched: "لا مثيل له",
            goToChat: "اذهب للدردشة",
            selectStory: "حدد القصة",
            selectBlock: "حدد كتلة",
            training: "تمرين",
            trainingAlert:
                "لتنفيذ التغييرات التي أجريتها في صفحة تدريب الروبوت، يجب عليك نشر النسخة الجديدة من السيناريو الذي قمت بتعديله.",
            unmatchedPhrases: "عبارات لا مثيل لها",
            ignored: "تجاهل",
            story: "قصة",
            timePeriod: "فترة زمنية",
            wholeTimeSpan: "فترة زمنية كاملة",
            selectAStory: "حدد قصة",
            searchUserQuery: "البحث عن استعلام المستخدم",
            time: {
                today: "اليوم",
                yesterday: "أمس",
                last7: "اخر 7 ايام",
                last30: "آخر 30 يومًا",
                "this-month": "هذا الشهر",
                "last-month": "الشهر الماضي",
                "last-3-month": "آخر 3 أشهر",
                "this-year": "هذا العام",
                "last-year": "العام الماضي",
                custom: "اختر تاريخًا مختلفًا",
            },
            emailProvider: "مزوِّد بريد إلكتروني",
            triggerFromAnywhere: "الزناد من أي مكان",
            allIntegrations: "جميع التكامل",
            integrateYourCBwithChatWidget: "دمج chatbot الخاص بك مع القطعة الدردشة.",
            integrateYourCBwithChatGpt3: "يمكن دمج chatbot مع GPT-4. مفتاح GPT-4 API المطلوب.",
            integrateYourCBwithWebHook: "تمرير معلومات الدردشة بين chatbot وخدمات الويب الخاصة بك بسهولة.",
            integrateYourCBwithIntegratable: "تمرير معلومات الدردشة بين chatbot و {integratable} بسهولة.",
            addWebhook: "إضافة webhook",
            editWebhook: "تحرير webhook",
            newWebhook: "New Webhook",
            webhookTitle: "عنوان webhook",
            webhookUrl: "Webhook url",
            webhookToken: "رمز webhook",
            webhookUsername: "Webhook اسم المستخدم",
            webhookPassword: "كلمة مرور webhook",
            editBlock: "يحرر",
            moveBlock: "يتحرك",
            copyBlock: "ينسخ",
            addFilter: "إضافة مرشح",
            addFilterGroup: "إضافة مجموعة مرشح",
            clearFilter: "فلتر شفاف",
            in: "في",
            and: "و",
            or: "أو",
            chatbot: "روبوت الدردشة",
            allStories: "كل القصص",
            addBot: "إنشاء بوت",
            testBot: "اختبر روبوتك",
            publish: "ينشر",
            editName: "تعديل الاسم",
            search: "ابحث في قصتك ...",
            typeMoreThan3Char: "اكتب 3 حرف على الأقل",
            expand: "يوسع",
            expandAll: "توسيع الكل",
            noMatchingItem: "لا يوجد عنصر مطابق",
            hint: "تَلمِيح",
            select: "يختار",
            navigate: "التنقل",
            dismiss: "رفض",
            choseAttribute: "اختار السمة",
            selectReply: "حدد الرد",
            preview: "معاينة",
            draft: "مسودة",
            lastUpdate: "اخر تحديث",
            published: "نشرت",
            newStory: "قصة جديدة",
            updateStory: "تحديث القصة",
            storyDescription: "وصف القصة",
            storyTitle: "عنوان القصة",
            deleteSingleBlock: "حذف كتلة واحدة",
            deleteWithChildren: "حذف مع الأطفال",
            startTestFromHere: "ابدأ الاختبار من هنا",
            copyBlockId: "نسخ معرف الكتلة",
            gotoLiveLink: "اذهب إلى Live Link",
            copyBlockIdSuccessfull: "تم نسخ معرف الكتلة إلى الحافظة",
            collapse: "ينهار",
            collapseAll: "انهيار جميع",
            snDelay: "{delay} Sec Delay",
            blockUpdated: "كتلة تحديث",
            addPayload: "إضافة الحمولة",
            previewModeCaution: "أنت الآن تقوم بمعاينة أحد إصدارات قصتك. لا يمكنك حفظ التغييرات في وضع المعاينة!",
            enterText: "أدخل النص...",
            trackpad: "لوحة التتبع",
            navigation: "ملاحة",
            navigationDesc: "يرجى اختيار وضع التنقل الخاص بك. الأمر متروك لك إذا كان سيتم تتبعه أو الماوس.",
            botSetting: "إعداد الروبوت",
            botSettingDesc:
                "يرجى تعيين مستوى الثقة. هذه نسبة مئوية بين 0 و 100. يحدد المستوى صحة chatbot التي ترتبط بمدخلات المستخدم.",
            languageSettingsDesc: "يرجى التأكد من أن لغة الروبوت التي تستجيب لها هي لغتك المفضلة.",
            mouse: "الفأر",
            Interactions: "التفاعلات",
            Actions: "أجراءات",
            Supsis_Actions: "تصرفات supsis",
            Shopify_Actions: "الإجراءات المتسوق",
            Akinon_Actions: "أفعال أكينون",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "نقطة البداية",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "استجابة الروبوت",
            AI_BOT_RESPONSE: "استجابة منظمة العفو الدولية (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "الافتراضي",
            FILTER: "منقي",
            addNewFilter: "إضافة مرشح جديد",
            FLOW: "تدفق",
            ATTACHMENT_INPUT: "إدخال المرفق",
            USER_INPUT: "إدخال المستخدم",
            GO_TO_STEP: "اذهب إلى الخطوة",
            WEBHOOK: "webhook",
            SET_ATTRIBUTE: "تعيين السمة",
            QUESTION: "سؤال",
            CLOSE_CHAT: "وثيق الدردشة",
            CREATE_TICKET: "إنشاء تذكرة",
            TRANSFER_CHAT: "نقل الدردشة",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "تعيين القسم",
            SEND_TRANSCRIPT: "إرسال النص",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SEND MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Shopify Show Products",
            SHOPIFY_PRODUCT_AVAILABILITY: "توافر المنتج المتسوق",
            SHOPIFY_ORDER_STATUS: "حالة الطلب المتسوق",
            AKINON_SHOW_PRODUCTS: "Akinon عرض المنتجات",
            AKINON_FIND_PRODUCT: "AKINON Find Product",
            AKINON_ORDER_STATUS: "حالة أمر AKINON",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "عرض مخزن المتجر",
            AKINON_FIND_NEAREST_STORES: "عرض أقرب المتاجر",
            AKINON_SHOW_DISCOUNT_CODES: "عرض رموز الخصم",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "الرد على التعليق",
            INSTAGRAM_COMMENT_DELETE: "حذف التعليق",
            INSTAGRAM_COMMENT_SHOW: "عرض التعليق",
            INSTAGRAM_COMMENT_HIDE: "إخفاء التعليق",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "الرد بشكل خاص",
            followingAttributesFilled: "سوف تأتي السمات التالية مملوءة.",
            GET_LOCATION: "احصل على الموقع",
            FALLBACK: "تراجع",
            SUCCESS: "نجاح",
            FAILURE: "فشل",
            message: "رسالة",
            condition: "حالة",
            score: "نتيجة",
            equal: "متساوي",
            not_equal: "ليس متساويًا",
            contain: "يحتوي",
            not_contain: "لا تحتوي",
            starts_with: "ابدا ب",
            ends_with: "ينتهي",
            empty: "فارغ",
            longer_than: "اطول من",
            shorter_than: "اقصر من",
            less_than: "أقل من",
            less_than_equal: "أقل من متساوٍ",
            greater_than: "أكثر من",
            greater_than_equal: "أكبر من المتساوية",
            value: "قيمة",
            failures: "الفشل",
            email: "بريد إلكتروني",
            name: "اسم",
            username: "اسم المستخدم",
            source: "مصدر",
            language: "لغة",
            timezone: "وحدة زمنية",
            region: "منطقة",
            country: "دولة",
            referrer: "المرجع",
            url: "عنوان URL",
            ip: "IP",
            city: "مدينة",
            lastSeen: "اخر ظهور",
            userId: "معرف المستخدم",
            selectStep: "حدد الخطوة",
            keywords: "الكلمات الدالة",
            userSays: "يقول المستخدم",
            addKeyword: "أضف الكلمة الرئيسية",
            addUserMessage: "أضف رسالة المستخدم",
            set: "تعيين",
            to: "ل",
            gender: "جنس",
            go_to_failure: "اذهب إلى الفشل",
            go_to_success: "اذهب إلى النجاح",
            untilFilled: "حتى تملأ",
            time1: "مرة واحدة",
            time2: "2 مرات",
            time3: ".ثلاث مرات",
            time4: "4 مرات",
            time5: "5 مرات",
            any: "أي",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "أبجدي رقمي",
            integer: "عدد صحيح",
            no: "لا",
            number: "رقم",
            phone: "هاتف",
            yes: "نعم",
            yesNo: "نعم / لا",
            anyDescription: "يطابق أي شيء غير فارغ.",
            alphanumericDescription: "يطابق كل من الرسائل والأرقام",
            integerDescription: "يطابق رقم عدد صحيح",
            noDescription: "لا يطابق أي مرادفات",
            numberDescription: "يطابق الرقم الترتيبي والكارد",
            phoneDescription: "يطابق رقم الهاتف",
            yesDescription: "تطابق نعم المرادفات",
            yesNoDescription: "تطابق نعم ولا مرادفات",
            emailDescription: "تطابق البريد الإلكتروني",
            urlDescription: "يطابق عنوان URL",
            temperature: "درجة حرارة",
            askWhenInvalid: "اسأل عندما غير صالح",
            applyFilter: "تطبيق المرشح",
            RANDOM_TEXT: "نص عشوائي",
            QUICK_REPLY: "رد سريع",
            FILE: "ملف",
            notificationMessageStartSuccess: "الكتلة",
            notificationMessageEndSuccess: "تمت إضافة",
            notificationMessageStartError: "حدث خطأ ، الكتلة",
            notificationMessageEndError: "لم تتم إضافته",
            blockChangedWannaUpdate: "أريد التحديث تغيير",
            responses: "استجابات",
            TEXT: "نص",
            IMAGE: "صورة",
            GALLERY: "صالة عرض",
            BUTTON: "زر",
            flow: "تدفق",
            active: "نشيط",
            passive: "سلبي",
            chooseAttributeType: "اختر نوع السمة",
            imageAttachment: "مرفق الصورة",
            audioAttachment: "مرفق الصوت",
            videoAttachment: "مرفق الفيديو",
            documentAttachment: "مرفق المستند",
            anyAttachment: "أي ارتباط",
            typeAttributeValue: "اكتب قيمة السمة",
            typeSearchValue: "اكتب قيمة البحث",
            addAttribute: "اضف ميزة",
            addAttributeDescription:
                "لا يمكن أن يحتوي اسم السمة على أحرف أبجدية رقمية فقط هي الحروف A-Z أو NUMBERS 0-9 أو DASH أو SHOFSCORE.",
            male: "ذكر",
            USER_DATA: "بيانات المستخدم",
            CUSTOM_ATTRIBUTES: "سمات مخصصة",
            enterBotResponseHere: "أدخل استجابة الروبوت هنا ...",
            addCard: "إضافة بطاقة",
            addButton: "إضافة زر",
            typeCardTitle: "اكتب عنوان البطاقة",
            typeCardDescription: "اكتب وصف البطاقة",
            dragAndDropBrowse: "سحب وإسقاط تصفح",
            dragAndDropBrowseFile: "رفع ملف",
            button: "زر",
            enterYourMessage: "أدخل رسالتك",
            imageView: "عرض الصورة",
            imageUploading: "تحميل الصور",
            fileUploading: "تحميل الملف ...",
            clickToChooseNewImage: "انقر لاختيار صورة جديدة",
            clickToChooseNewFile: "انقر لاختيار ملف جديد",
            removeTheExistingOne: "إزالة واحد الموجود",
            validateResponseWithEntity: "التحقق من صحة الاستجابة مع الكيان",
            actionOnFailureInput: "عمل على مدخلات الفشل",
            askNextQuestion: "اطرح السؤال التالي",
            goToSuccessBlock: "اذهب إلى كتلة النجاح",
            goToFailureBlock: "اذهب إلى كتلة الفشل",
            saveResposeToAttribute: "حفظ respose ليعزو",
            selectReplyType: "حدد نوع الرد",
            questionVariants: "المتغيرات سؤال",
            systemEntities: "كيانات النظام",
            delay: "تأخير",
            retrySectionTextPart: "بسأل",
            retrySectionText: "، إذا كانت استجابة المستخدم غير صالحة",
            addNextQuestion: "أضف السؤال التالي",
            typeBlockTitle: "اكتب عنوان الكتلة",
            versionHistory: "تاريخ النسخة",
            restore: "يعيد",
            versionName: "اسم الإصدار",
            restoreModalText: "سيقوم هذا الإجراء بإعادة الإصدار المحدد. هل أنت متأكد من أنك تريد استعادة هذا الإصدار؟",
            restoreVersion: "استعادة النسخة",
            newVersion: "نسخة جديدة",
            synonymMustBeUnique: "يجب أن يكون المرادف فريدًا",
            save: "يحفظ",
            entries: "إدخالات",
            youHaveNoEntries: "ليس لديك إدخالات",
            inputsCantBeEmpty: "لا يمكن أن تكون المدخلات فارغة",
            entryNamesMustBeUnique: "يجب أن تكون أسماء الدخول فريدة من نوعها",
            entityNameMustBeUnique: "يجب أن يكون اسم الكيان فريدًا",
            synonyms: "المرادفات",
            entities: "جهات",
            title: "عنوان",
            entryName: "اسم الدخول",
            entityhasbeenUpdatedSuccessfully: "تم تحديث الكيان بنجاح",
            emptyError: "لا يمكن أن تكون الإدخالات فارغة",
            entityNameCantBeEmpty: "الكيان لا يمكن أن يكون فارغا",
            allChats: "كل الدردشات",
            paidChats: "دردشات مدفوعة الأجر",
            busiestPeriod: "فترة ازدحام",
            ratingDistribution: "توزيع التصنيف",
            allMessages: "جميع الرسائل",
            avarageMessages: "رسائل Avarage",
            popularity: "شعبية",
            allUsers: "جميع المستخدمين",
            interactionName: "اسم التفاعل",
            numberOfMessage: "عدد الرسالة",
            ofAllUsersMessage: "٪ من جميع رسائل المستخدمين",
            totalData: "إجمالي البيانات",
            avgData: "بيانات AVG",
            exportToCsv: "التصدير إلى CSV",
            exportToExcel: "تصدير إلى Excel",
            inMaintenance: "في الصيانة",
            ADD_TO_SEGMENT: "إضافة إلى الجزء",
            REMOVE_FROM_SEGMENT: "ترفع من الجزء",
            users: "المستخدمون",
            webhookName: "اسم webhook",
            webHookUrl: "Webhook url",
            webHookToken: "رمز webhook",
            delete: "يمسح",
            basicAuth: "مصادقة أساسية",
            requiredFieldsCannotBeLeftBlank: "لا يمكن ترك الحقول المطلوبة فارغة",
            headerValue: "قيمة",
            yourVerificationToken: "رمز",
            yourWebHookName: "اسم webhook الخاص بك",
            yourWebHookUrl: "عنوان URL الخاص بك webhook",
            enterKey: "مفتاح الادخال",
            password: "كلمة المرور",
            saveSuccessfully: "تم حفظ معاملتك بنجاح",
            urlTypeError: "يرجى ملء الحقل بشكل صحيح (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Openai Chat GPT-4 API مفتاح مطلوب.",
                apiKeyDesc:
                    "يتطلب تكامل chatbot + الدردشة GPT-4 مفتاح API. يرجى الحصول على مفتاح API الخاص بك أو استخدام مفتاح API أدناه للتجربة. يمكنك استخدام 20 رسالة فقط للتجربة.",
                getApiKey: "احصل على مفتاح AI AI AI",
                typeApiKey: "اكتب مفتاح API",
                ownApiKey: "Own Openai API Key",
                trialApiKey: "مفتاح API التجريبي (مقيد بـ 20 رسالة)",
                useOurTrial: "استخدم تجريمنا المجاني",
                twentyMessages: "يمكنك المحاولة باستخدام 20 رسالة مجانية.",
                enableChatGpt3: "تمكين الدردشة GPT-4",
            },
        },
        "Would you like to make default this story?": "#VALUE!",
        coupon: {
            code: "شفرة",
            discount: "تخفيض",
            endDate: "تاريخ الانتهاء",
            name: "اسم",
            email: "بريد إلكتروني",
            phone: "هاتف",
            add: "أضف عرض",
            coupons: "كوبونات",
            couponDeleted: "حذف القسيمة",
            limit: "حد",
            visitorBan: "تم حظر الزائر.",
            visitorUnBlock: "تم رفع الحظر.",
        },
        instagramTitle: "انقر فوق الزر أدناه لتمكين ميزات Instagram.",
        instegramFunctionActive: "تمكين ميزة Instagram",
        ChatBOT: "روبوت الدردشة",
        WhatsappContacts: "جهات اتصال Whatsapp",
        InstagramContacts: "جهات اتصال Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "رفع مستوى الصوت",
        minimize: "تقليل",
        maximize: "تحقيق أقصى قدر",
        auditLogs: {
            auditLogsTitle: "سجلات التدقيق",
            auditLogsSub: "تتيح لك سجلات التدقيق تتبع الأحداث التي وقعت في شركتك خلال الـ 30 يومًا الماضية.",
        },
        task: {
            priority_lowest: "الأدنى",
            priority_low: "منخفض",
            priority_medium: "متوسط",
            priority_high: "مرتفع",
            priority_highest: "الأعلى",
            workflowTitle: "عنوان سير العمل",
            workflowActions: "إجراءات سير العمل",
            deleteTask: "حذف المهمة",
            archivingDate: "تاريخ الأرشفة",
            selectOption: "تحديد خيار",
            notAuthorisedCreateTask: "غير مصرح لك بإنشاء مهمة",
            notAuthorisedCreateTaskDesc: "غير مصرح لك بتنفيذ هذه المهمة.",
            goToMessage: "الانتقال إلى الرسالة",
            goToChat: "الانتقال إلى الدردشة",
            showVisitor: "إظهار الزائر",
            closeTheTask: "إغلاق المهمة",
            sureAddCompletedList: "هل أنت متأكد من أنك تريد إضافة المهمة إلى القائمة المكتملة؟",
            success: "نجاح",
            successDesc: "تمت إضافة حقل جديد بنجاح",
            moveAndDeleteTask: "نقل المهام وحذفها",
            justDelete: "حذف فقط",
            selectColumnMoveTask: "حدد العمود الذي تريد نقل المهام إليه",
            todos: "مهام يجب القيام بها",
            inProgress: "قيد التنفيذ",
            approval: "معتمد",
            addAComment: "أضف تعليقاً...",
            deleteComment: "هل أنت متأكد أنك تريد حذف التعليق؟",
            edited: "تم التعديل",
            comments: "التعليقات",
            addComment: "أضف تعليقًا",
            workflow: "سير العمل",
            workflowDetail: "تفاصيل سير العمل",
            workflowPerm: "أذونات سير العمل",
            perm: "أذونات",
            detail: "التفاصيل",
            userPerm: "أذونات المستخدم",
            deleteCard: "حذف البطاقة",
            createCard: "إنشاء بطاقة",
            editCard: "تعديل البطاقة",
            dragCard: "سحب البطاقة",
            allWorkflow: "كل عمليات سير العمل",
            createworkflow: "إنشاء سير العمل",
            deleteWorkflow: "هل أنت متأكد أنك تريد حذف سير العمل هذا؟",
            permEditTask: "ليست لديك صلاحية تعديل هذه المهمة",
            permEditTaskDes: "اتصل بالمسؤول الخاص بك للحصول على أذونات التعديل.",
            createTaskError: "ليست لديك صلاحية إنشاء مهام",
            createTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات إنشاء المهام.",
            moveTaskError: "ليست لديك صلاحية تغيير حالة المهمة",
            moveTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات تغيير حالة المهمة.",
            deleteTaskError: "ليست لديك صلاحية حذف المهام",
            deleteTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات حذف المهام.",
            permissionError: "ليس لديك إذن بإنشاء المهام",
            permissionErrorDesc: "يرجى الاتصال بالمسؤول الخاص بك للحصول على إذن إنشاء المهام",
            whatsappContactProfileTitle: "ملف تعريف {name} / {number}",
            createTaskVisitor: "إنشاء مهمة (زائر)",
            editWorkflow: "تحرير سير العمل",
            visitor: "ملف الزائر",
            createTaskMessage: "إنشاء مهمة (رسالة)",
            createStage: "إنشاء مرحلة",
            stagesAndStatuses: "المراحل والحالات",
            workflowCreateDesc: "وصف التدفق العملي",
            subTasks: "المهام الفرعية",
            followers: "متابعون",
            collaborators: "المتعاونون",
            addRelations: "إضافة علاقات",
            relations: "العلاقات",
            main: "رئيسي",
            name: "الاسم",
            completedOfCheck: "تم إكمال {completed} من إجمالي {total} المهام",
            workflowUpdateMs: "تم تحديث سير العمل بنجاح",
            taskUpdateMs: "تم تحديث المهمة بنجاح",
            workflowCreatedMs: "تم إنشاء سير العمل بنجاح",
            workflowCreateError: "لا يمكن إنشاء سير العمل",
            taskCreatedMs: "تم إنشاء المهمة بنجاح",
            settingsDesc3:
                "بالإضافة إلى ذلك، يتيح لك موديل المهام Supsis إنشاء سير عمل خاص بك مع أتمتة قابلة للتخصيص، مما يتيح لك إدارة المهام بشكل أكثر فعالية وتعزيز التعاون داخل الفريق.",
            settingsDesc4:
                "بهذه الطريقة، يمكنك تتبع كل من مهامك بالتفصيل، وتعيين المهام لأعضاء الفريق، وإدارة عمليات الأعمال الخاصة بك بشكل أكثر كفاءة. يوفر لك موديل المهام Supsis حلاً شاملاً لإدارة المهام وتنسيق الفريق.",
            settingsDesc2:
                "يترك موديل المهام Supsis أي مهمة دون أن تلاحظ. يمكنك تصفية المهام بناءً على أي معلمة، وتتبع أعباء العمل لكل مرحلة من مراحل سير العمل، وتنظيم التقويم الخاص بك ليتماشى مع جداولك.",
            settingsDesc1:
                "يتيح لك موديل المهام تنظيم العمل التعاوني، وتفويض المهام، وتتبع تقدم فريقك. يمكنك تخصيص المهام الخاصة بك حسب احتياجاتك عن طريق تحديد أي عرض وإنشاء سير عمل مخصصة خاصة بك باستخدام الأتمتة.",
            taskModuleSettingsTitle: "إعدادات وحدة المهام",
            high: "مرتفع",
            medium: "متوسط",
            low: "منخفض",
            priority: "الأولوية",
            addExistsSubtask: "إضافة مهمة فرعية موجودة",
            addSubtask: "إضافة مهمة فرعية",
            add: "أضف",
            newCheckList: "قائمة مراجعة جديدة",
            subtaskTitle: "عنوان الوظيفة الفرعية",
            view: "عرض",
            attachFiles: "إرفاق الملفات",
            createTaskDesc: "وصف المهمة",
            title: "عنوان",
            createWorkflow: "إنشاء سير العمل",
            editTask: "تحرير المهمة",
            createTask: "إنشاء مهمة",
            deleteColumnCont: "هل أنت متأكد أنك تريد حذف هذا العمود؟",
            changeStage: "تغيير المرحلة",
            assignees: "المعينين",
            owner: "صاحب",
            stage: "مرحلة",
            writeSomething: "اكتب شيئًا",
            selectAssginee: "حدد المعين",
            assignee: "المعين",
            enterNewTaskDesc: "أدخل وصف المهمة الجديدة",
            enterNewTaskTitle: "أدخل عنوان المهمة الجديدة",
            task: "مهمة",
            deleteTaskCont: "هل أنت متأكد أنك تريد حذف هذه المهام؟",
            deleteWorkFlowCont: "هل أنت متأكد أنك تريد حذف سير العمل هذا؟",
            completed: "مكتمل",
            todo: "مهمة",
            kanbanBoard: "لوحة كانبان",
            listView: "عرض القائمة",
        },
        permissionErrors: {
            userCreate: "ليس لديك إذن لإضافة المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userRead: "ليس لديك إذن لعرض المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userUpdate: "ليس لديك إذن لتحديث المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userDelete: "ليس لديك إذن لحذف المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            visitorBlock: "ليس لديك إذن لحظر الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorUnblock: "ليس لديك إذن لإلغاء حظر الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorDetailRead: "ليس لديك إذن لعرض تفاصيل الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorListRead: "ليس لديك إذن لعرض قائمة الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorDelete: "ليس لديك إذن لحذف الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorExcel: "ليس لديك إذن للحصول على مخرجات Excel. يرجى استشارة المسؤول الخاص بك.",
            visitorUpdate: "ليس لديك إذن لتحديث الزوار. يرجى استشارة المسؤول الخاص بك.",
            bannedVisitorRead: "ليس لديك إذن لعرض قائمة الزوار المحظورين. يرجى استشارة المسؤول الخاص بك.",
            bannedWordCreate: "ليس لديك إذن لإضافة كلمات محظورة. يرجى استشارة المسؤول الخاص بك.",
            bannedWordRead: "ليس لديك إذن لعرض الكلمات المحظورة. يرجى استشارة المسؤول الخاص بك.",
            bannedWordDelete: "ليس لديك إذن لحذف الكلمات المحظورة. يرجى استشارة المسؤول الخاص بك.",
            chatRead: "ليس لديك إذن لعرض الدردشات. يرجى استشارة المسؤول الخاص بك.",
            chatUpdate: "ليس لديك الإذن لتحرير المحادثات. يرجى التشاور مع المسؤول الخاص بك.",
            archiveRead: "ليس لديك الإذن لعرض الأرشيف. يرجى التشاور مع المسؤول الخاص بك.",
            roleCreate: "ليس لديك الإذن لإضافة الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleRead: "ليس لديك الإذن لعرض الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleUpdate: "ليس لديك الإذن لتحديث الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleDelete: "ليس لديك الإذن لحذف الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            departmentCreate: "ليس لديك الإذن لإضافة الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentRead: "ليس لديك الإذن لعرض الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentUpdate: "ليس لديك الإذن لتحديث الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentDelete: "ليس لديك الإذن لحذف الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentCreate: "ليس لديك الإذن لإنشاء المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentRead: "ليس لديك الإذن لعرض المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentUpdate: "ليس لديك الإذن لتحديث المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentDelete: "ليس لديك الإذن لحذف المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeCreate: "ليس لديك الإذن لإنشاء رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeRead: "ليس لديك الإذن لعرض رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeUpdate: "ليس لديك الإذن لتحديث رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeDelete: "ليس لديك الإذن لحذف رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            settingCreate: "ليس لديك الإذن لإنشاء الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingRead: "ليس لديك الإذن لعرض الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingUpdate: "ليس لديك الإذن لتحديث الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingDelete: "ليس لديك الإذن لحذف الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            reportCreate: "ليس لديك الإذن لإنشاء التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportRead: "ليس لديك الإذن لعرض التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportUpdate: "ليس لديك الإذن لتحديث التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportDelete: "ليس لديك الإذن لحذف التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestCreate:
                "ليس لديك الإذن لإنشاء طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestRead: "ليس لديك الإذن لعرض طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestUpdate:
                "ليس لديك الإذن للرد على طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestDelete:
                "ليس لديك الإذن لحذف طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            catalogCreate: "ليس لديك الإذن لإنشاء الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogRead: "ليس لديك الإذن لعرض الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogUpdate: "ليس لديك الإذن لتحديث الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogDelete: "ليس لديك الإذن لحذف الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryCreate: "ليس لديك الإذن لإنشاء قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryRead: "ليس لديك الإذن لعرض قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryUpdate: "ليس لديك الإذن لتحديث قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryDelete: "ليس لديك الإذن لحذف قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotTemplateRead: "ليس لديك الإذن لعرض قوالب الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotTemplateAiRead: "ليس لديك الإذن لعرض قوالب الدردشة الذكية. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotIntegrationsRead: "ليس لديك الإذن لعرض تكاملات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotArchiveRead: "ليس لديك الإذن لعرض أرشيف الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesRead: "ليس لديك الإذن لعرض كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesCreate: "ليس لديك الإذن لإنشاء كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesUpdate: "ليس لديك الإذن لتحديث كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesDelete: "ليس لديك الإذن لحذف كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotReportRead: "ليس لديك الإذن لعرض تقارير الدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotTrainRead: "ليس لديك الإذن لعرض تدريب الدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentCreate:
                "ليس لديك الإذن لإنشاء شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentRead:
                "ليس لديك الإذن لعرض شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentUpdate:
                "ليس لديك الإذن لتحديث شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentDelete:
                "ليس لديك الإذن لحذف شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            integrationsRead: "ليس لديك الإذن لعرض صفحة التكاملات. يرجى التواصل مع المسؤول الخاص بك.",
            whatsappIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل WhatsApp. يرجى التواصل مع المسؤول الخاص بك.",
            instagramIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل Instagram. يرجى التواصل مع المسؤول الخاص بك.",
            telegramIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل Telegram. يرجى التواصل مع المسؤول الخاص بك.",
            integrationCreate: "ليس لديك الإذن لتمكين التكاملات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerCreate: "ليس لديك الإذن لإنشاء المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerRead: "ليس لديك الإذن لعرض المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerUpdate: "ليس لديك الإذن لتحديث المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerDelete: "ليس لديك الإذن لحذف المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            billingRead: "ليس لديك إذن لعرض الفواتير. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskCreate: "ليس لديك إذن لإنشاء المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskRead: "ليس لديك إذن لعرض المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskUpdate: "ليس لديك إذن لتحديث المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskDelete: "ليس لديك إذن لحذف المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarCreate: "ليس لديك إذن لإنشاء التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarRead: "ليس لديك إذن لعرض التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarUpdate: "ليس لديك إذن لتحديث التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarDelete: "ليس لديك إذن لحذف التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailCreate: "ليس لديك إذن لإنشاء البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailRead: "ليس لديك إذن لعرض البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailUpdate: "ليس لديك إذن لتحديث البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailDelete: "ليس لديك إذن لحذف البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
        },
        message: {
            createDepartment: "إنشاء قسم",
            goToLink: " انتقل إلى الرابط",
            emailAddressYouProvide: "يوجد بالفعل حساب باستخدام عنوان البريد الإلكتروني الذي قدمته. يرجى محاولة تسجيل الدخول أو إعادة تعيين كلمة المرور الخاصة بك.",
            channelPrivacyPolicyNotMet: "سياسة الخصوصية للقناة غير مستوفية",
            userIsNotInDepartment: "المستخدم غير موجود في هذا القسم",
            currentDepartment:"القسم الحالي",
            validDepartment:"القسم الصالح",
            youCanForwardToThisDepartment:"يمكنك توجيه المحادثة إلى هذا القسم",
            goToSettings:"الذهاب إلى الإعدادات",
            changeDepartmentAndForward:"تغيير القسم والتوجيه",
            selectDepartmentToForwardAgent:"يرجى تحديد القسم الذي ترغب في توجيه المحادثة من خلاله للوكيل المسمى {selectAgentName}.",
            selectDepartmentToForward: "يرجى اختيار القسم للإرسال",
            packageConfirmationMessage: "هل أنت متأكد من أنك تريد شراء الباقة؟ الباقة التي تشتريها خاضعة للرسوم الفورية. يمكنك الاستمرار في استخدامها لمدة عام بعد الإلغاء. سعر هذا المنتج هو السعر قبل إضافة ضريبة القيمة المضافة 20%.",
            packagePurchaseConfirmation: "هل أنت متأكد من أنك تريد شراء الباقة؟ سيتم خصم الباقات الشهرية في بداية كل شهر. سينتهي استخدام الباقة بعد تاريخ الإلغاء. سعر هذا المنتج هو السعر قبل إضافة ضريبة القيمة المضافة 20%.",
            annualPurchaseDiscount: "استفد من عرض خصم 30٪ على المشتريات السنوية!",
            customerTables: "جدول العملاء",
            formIntegration: "تكامل النموذج",
            automationIntegration: "تكامل الأتمتة",
            remainingAutomationTask: "مهمة الأتمتة المتبقية",
            createUserError: "حدث خطأ أثناء إنشاء المستخدم",
            sendTemplateMessage: "إرسال رسالة قالب",
            startChatWithDifferentChannel: "بدء محادثة مع قناة مختلفة",
            whatsappChatStarter: "بادئ محادثة واتساب",
            pressEnterToJoin: "اضغط Enter للانضمام إلى المحادثة",
            pressEnterToStartChat: "اضغط Enter لبدء المحادثة",
            cannotSendMessage: "لا يمكنك إرسال رسالة لهذا الشخص",
            cannotSendSessionMessage: "لا يمكنك إرسال رسالة جلسة لهذا الشخص",
            conversationNotInYourDepartments: "هذه المحادثة لا تنتمي إلى أي من أقسامك",
            customizeImage: "إذا كنت تريد تخصيص الصورة",
            clickToUpload: "انقر هنا لتحميل صورة",
            uploadNote: "فيما يلي تنسيقات الملفات وأحجامها المقبولة للتحميل",
            imageSize: "لا يمكن تحميل الصورة لأنها أكبر من 2 ميجابايت",
            videoSize: "لا يمكن تحميل الفيديو لأنه أكبر من 20 ميجابايت",
            documentSize: "لا يمكن تحميل المستند لأنه أكبر من 2 ميجابايت",
            uploading: "جاري تحميل الصورة، يرجى الانتظار...",
            uploadSuccess: "تم تحميل الصورة بنجاح",
            note: "ملاحظة",
            gridView: "نظرة عامة",
            completedTasks: "المهام المنجزة",
            system: "النظام",
            destroyedBy: "تم إنشاء القناة بنجاح",
            brand: "العلامة التجارية",
            questions: "الأسئلة",
            channelCreatedSuccess: "تم إنشاء القناة بنجاح",
            channelCreatedError: "فشل في إنشاء القناة",
            plans: {
                types: {
                    supsis: "حزم الممثلين",
                    chatbot: "روبوت الدردشة",
                    automation: "أتمتة",
                    customer_tables: "جدول العملاء",
                    mail: "البريد الإلكتروني",
                    tasks: "المهام",
                    form: "نموذج",
                    whatsapp: "واتساب",
                    whatsapp_business: "واتساب للأعمال",
                    instagram: "إنستغرام",
                    messenger: "مسنجر",
                    meta_lead: "ميتا ليد",
                    trendyol: "ترينديول",
                    "artificial_intelligence": "الذكاء الاصطناعي",
                    "webhook": "الويب هوك",
                },
            },
            vipCustomerDescription:
                "تحديد هذه الشخص كعميل VIP ينقله إلى أعلى قائمة الانتظار ويضمن حصوله على خدمة ذات أولوية.",
            switchOn: "تشغيل",
            switchOff: "إيقاف",
            ownerDescription:
                "توضح هذه الميزة مالك الدردشة. بغض النظر عن حالة المالك (متصل أو غير متصل)، يتم دائمًا تعيين الدردشات للمالك. يمكن فقط للمالك المعني عرض الدردشات المملوكة ولا يمكن الرد عليها بواسطة الروبوت.",
            permissionError: "ليس لديك إذن لتنفيذ هذا الإجراء!",
            copySuccess: "تم نسخ المحتوى بنجاح!",
            unowned: "بدون مالك",
            jsonPreview: "معاينة JSON",
            enterNewValue: "أدخل قيمة جديدة",
            updatePreferredLanguage: "تحديث اللغة المفضلة",
            updateTags: "تحديث العلامات",
            updateEmail: "تحديث البريد الإلكتروني",
            enterNewEmail: "أدخل بريدًا إلكترونيًا جديدًا",
            deleteConfirmation: "تأكيد الحذف",
            confirmDelete: "هل أنت متأكد أنك تريد حذف هذه الميزة؟",
            yesDelete: "نعم، احذف",
            vipCustomer: "★ عميل VIP",
            joinChat: "الدخول إلى الدردشة",
            takeControlFromChatbot: "إختيار المسؤول الخاص بك",
            enterJoin: "يمكنك الدخول إلى الدردشة بالضغط على مفتاح Enter",
            watchChat: "مشاهدة الدردشة",
            untitledAutomation: "👉 ملف تعريف غير معنون انقر فوق التشغيل الآلي",
            event: "حدث",
            chatbotSettings: "إعدادات توجيه الروبوت",
            chatbotScenarioNotFound: "لم يتم العثور على سيناريو الروبوت",
            noChatbotScenario: "لم يتم العثور على سيناريو روبوت في النظام.",
            scenarioNotFound: "لم يتم العثور على السيناريو",
            descNotAvailable: "الوصف غير متوفر",
            lastRegulation: "آخر تنظيم",
            taskCreator: "منشئ المهمة",
            noPermission: "ليس لديك إذن لإنشاء مهام.",
            noPermissionDescription: "ليس لديك إذن لتنفيذ هذا الإجراء.",
            notAppointed: "لم يتم تعيينه",
            changeStage: "تغيير المرحلة",
            selectedCandidates: "1 مرشح(مرشحة) مختار(ة)",
            coverPhotoRemove: "إزالة صورة الغلاف",
            coverPhotoSet: "تعيين كصورة غلاف",
            autoTransfer: "نقل جهات الاتصال الخاصة بك إلى زوهو تلقائيًا",
            autoTransferDescription:
                "يتم نقل جهات الاتصال التي تصل إلى هذه القناة تلقائيًا إلى وحدة جهات الاتصال في Zoho CRM. أولئك الذين تم نقلهم إلى Zoho ينشطون أدوات Zoho.",
            zohoChannelRequiredTitle: "قناة Zoho CRM مطلوبة",
            zohoChannelRequiredContent: "ليس لديك قناة Zoho CRM. انقر هنا لإضافة واحدة على الفور.",
            okText: "إضافة قناة Zoho CRM",
            cancelText: "إلغاء",
            forceQueueForNoOwnerContacts: "إجبار جهات الاتصال بدون مالك على الانتظار في الطابور",
            forceQueueDescription:
                "فقط جهات الاتصال المملوكة يتم تعيينها تلقائيًا، مما يجبر جهات الاتصال بدون مالك على الانتظار في الطابور.",
            showNoOwnerContactsToAdmins: "عرض جهات الاتصال بدون مالك فقط للمسؤولين",
            showNoOwnerContactsDescription: "جهات الاتصال بدون مالك مرئية فقط للمسؤولين.",
            autoAssignOwner: "تعيين مالك الاتصال تلقائيًا",
            autoAssignOwnerDescription: "عندما يتم تعيين الدردشة تلقائيًا لممثل، يتم تعيينها أيضًا كمالك.",
            creator: "المنشئ",
            hideShow: "إخفاء / عرض",
            url: "URL",
            cannedMessages: "رسائل جاهزة",
            templateMessages: "رسائل نموذجية",
            chatbots: "الدردشة الآلية",
            noCannedMessages: "لم يتم العثور على رسائل جاهزة",
            filterToFindMore: "يمكنك العثور على المزيد من الرسائل الجاهزة عن طريق تغيير الفلاتر الخاصة بك.",
            runPrompt: "تشغيل الموجه",
            noLeadsFound: "لم يتم العثور على أي عملاء محتملين لهذا الشخص",
            deals: "صفقات",
            noDealsFound: "لم يتم العثور على أي صفقات لهذا الشخص",
            loadingDeals: "جارٍ تحميل الصفقات",
            zohoCRM: "Zoho CRM",
            viewContact: "عرض الاتصال",
            noNotesAdded: "لم يتم إضافة أي ملاحظات بعد",
            attachments: "مرفقات",
            addNewNote: "إضافة ملاحظة جديدة",
            savingg: "جارٍ الحفظ...",
            warningFillFields: "يرجى ملء حقول العنوان والمحتوى.",
            successNoteAdded: "تمت إضافة الملاحظة بنجاح.",
            errorAddingNote: "حدث خطأ أثناء إضافة الملاحظة.",
            noteTitle: "عنوان الملاحظة",
            noteContent: "محتوى الملاحظة",
            selectPreferredAgent: "اختر الوكيل المفضل الذي تريد تعيينه للزائر.",
            postOperations: "عمليات النشر",
            loadingPostOperations: "جارٍ تحميل عمليات النشر",
            noPostOperations: "لم يتم العثور على عمليات نشر لهذا الشخص",
            postOperationDetails: "تفاصيل عملية النشر",
            noMediaDocuments: "لا توجد وسائط أو مستندات متاحة لهذه الشخص.",
            selectionLimitError: "يمكنك اختيار حد أقصى 30 عنصرًا.",
            showNote: "إظهار الملاحظة للجميع",
            hideNote: "إخفاء الملاحظة",
            updateNote: "تحديث الملاحظة",
            addUserNote: "أضف ملاحظة حول المستخدم",
            privateNote: "ملاحظة خاصة",
            metaReferrals: "إحالات ميتا",
            noMetaReferrals: "لم يتم العثور على تفاعلات إعلانات ميتا.",
            searchPrompt: "ابحث عن شيء.",
            noRecentResults: "لم يتم العثور على نتائج حديثة.",
            contactInfo: "معلومات الاتصال",
            noPropertiesAdded: "لم يتم إضافة أي خصائص بعد.",
            propertyAddedUpdated: "تمت إضافة/تحديث الخاصية بنجاح.",
            propertyError: "حدث خطأ أثناء إضافة/تحديث الخاصية.",
            propertyDeleted: "تم حذف الخاصية بنجاح.",
            propertyDeleteError: "حدث خطأ أثناء حذف الخاصية.",
            zohoSynchronization: "مزامنة زوهو",
            zohoSyncConfirmation: "هل تريد إجراء تغييرات على الشخص في زوهو أيضًا؟",
            hideOtherInfo: "إخفاء معلومات أخرى",
            showOtherInfo: "عرض معلومات أخرى",
            whatsappChatStart: "بدء دردشة واتساب",
            ownership: "ملكية العميل",
            countryAndLanguage: "البلد، اللغة",
            calendarEvent: "حدث تقويم",
            reservation: "حجز",
            contact: "اتصال",
            user: "مستخدم",
            customerOwnership: "ملكية العميل",
            ownerless: "بدون مالك",
            preferredDepartment: "القسم المفضل",
            flowluTransfer: "نقل إلى Flowlu",
            mergeSuccess: "تمت عملية الدمج بنجاح.",
            visitorOwnershipWarning: "هذا الزائر مملوك من قبل مستخدم آخر.",
            newAutomation: "أتمتة جديدة",
            automations: "الأتمتة",
            createProfileAutomation: "إنشاء أتمتة الملف الشخصي",
            profileButtonClicked: "تم النقر على زر الملف الشخصي",
            profileButtonDescription: "سيتم تفعيل هذه الأتمتة عند النقر على زر الملف الشخصي.",
            automationName: "اسم الأتمتة",
            create: "إنشاء",
            dayRange: "نطاق الأيام",
            hourRange: "نطاق الساعات",
            last24Hours: "آخر 24 ساعة",
            today: "اليوم",
            yesterday: "أمس",
            thisWeek: "هذا الأسبوع",
            lastWeek: "الأسبوع الماضي",
            last7Days: "آخر 7 أيام",
            last30Days: "آخر 30 يومًا",
            thisMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            startDateTime: "تاريخ ووقت البدء",
            endDateTime: "تاريخ ووقت الانتهاء",
            complaint: "شكوى",
            opens: "فتح",
            clicks: "نقرات",
            mockData: "(بيانات وهمية)",
            preferredRepresentative: "اختيار الوكيل المفضل",
            forwardToDepartment: "إرسال إلى القسم",
            toMobileAgents: "الوكلاء المحمولين",
            noMediaAndDocuments: "لا يوجد ميديا وملفات لهذا المستخدم",
            reportBug: "إبلاغ عن خطأ",
            waitingForReply: "في انتظار الرد",
            memorySize: "حجم الذاكرة",
            usedMemory: "الذاكرة المستخدمة",
            availableMemory: "الذاكرة المتاحة",
            memoryLimit: "الحد الأقصى للذاكرة",
            memoryLimitPrice: "التكلفة للذاكرة الإضافية",
            telegramBotIsReachable: "يمكن الوصول إلى خدمة روبوت تيليجرام",
            telegramBotIsHealthy: "خدمة روبوت تيليجرام صحية",
            telegramBotIsUnhealthy: "يوجد خطأ في خدمة روبوت تيليجرام",
            pieView: "عرض دائري",
            chartView: "عرض الرسم البياني",
            tableView: "عرض الجدول",
            lastUpdate: "آخر تحديث",
            workflow: "سير العمل",
            task: "مهمة",
            filterBy: "حسب الفلتر",
            watchAllLive: "مشاهدة جميع البث المباشر",
            sessionsUnique: "الجلسات (المستخدمون الفريدون)",
            sessionsAll: "الجلسات (جميع المستخدمين)",
            moreFeaturesDesc:
                "المزيد من الميزات، والمزيد من عمليات التكامل، والمزيد من الوكلاء! اتخذ إجراءً الآن لإدارة فريقك بشكل أفضل وتنمية أعمالك إلى أقصى إمكاناتها!",
            metaLeadForms: "نماذج MetaLeads",
            metaLeadsConnectedSucs: "تم توصيل MetaLeads بنجاح",
            failedToConnectMetaLeads: "فشل الاتصال بنماذج MetaLeads",
            forbiddenChannel: "قناة محظورة",
            forbiddenChannelDesc: "غير مسموح لك بعرض هذه القناة",
            firstContact: "جهة الاتصال الأولى",
            needsAnalysis: "تحليل الاحتياجات",
            offerSent: "العرض المرسل",
            offerReview: "مراجعة العرض",
            decisionPhase: "مرحلة القرار",
            personDeleted: "الشخص المحذوف",
            metaLeadsIntegration: "تكامل العروض الوصفية",
            phoneNumberIsInvalid: "رقم الهاتف غير صالح",
            owner: "المالك",
            addAnItem: "إضافة عنصر",
            saveItem: "حفظ عنصر",
            customItem: "عنصر مخصص",
            backgroundPhoto: "صورة الخلفية",
            whenYouActivateFeature: "عند تفعيل هذه الميزة، لن تظهر في صفحة الحجز",
            logo: "الشعار",
            noLogo: "لا يوجد شعار",
            addTeamMember: "إضافة عضو فريق",
            timezone: "المنطقة الزمنية",
            selectDayys: "تحديد يوم (أيام)",
            selectStartHour: "تحديد وقت البدء",
            selectEndHour: "تحديد وقت الانتهاء",
            moveLeft: "تحريك لليمين",
            moveRight: "تحريك لليسار",
            address: "العنوان",
            reply: "الرد",
            replyToAll: "الرد على الكل",
            deleteThreadMessage: "حذف رسالة الموضوع",
            totalEmailsBounced: "إجمالي رسائل البريد الإلكتروني المرتجعة",
            totalEmailsComplained: "إجمالي رسائل البريد الإلكتروني المشكو منها",
            untilNowTotalEmailOpens: "إجمالي رسائل البريد الإلكتروني التي تم فتحها حتى الآن",
            untilNowTotalEmailLinkClicks: "إجمالي نقرات رابط البريد الإلكتروني حتى الآن",
            uniqueClicks: "إجمالي النقرات الفريدة",
            untilNowTotalUniqueEmail: "إجمالي النقرات الفريدة على رابط البريد الإلكتروني حتى الآن (لكل مستلم)",
            emailCampaignTimeline: "المخطط الزمني لحملة البريد الإلكتروني",
            receivedBroadcasts: "عمليات البث المستلمة",
            groupDeletedSuccessfully: "تم حذف المجموعة بنجاح",
            verify: "تم التحقق",
            done: "تم",
            pleaseSelectAnEmailAddress: "الرجاء تحديد عنوان بريد إلكتروني",
            goBack: "رجوع",
            show: "إظهار",
            vueEmailEditor: "محرر البريد الإلكتروني فيو (تجريبي)",
            saveDesign: "حفظ التصميم",
            exportHTML: "تصدير HTML",
            saveAsAsEmailCustomerGroup: "الحفظ كمجموعة عملاء البريد الإلكتروني",
            saveAsAsWhatsAppCustomerGroup: "حفظ كمجموعة عملاء واتساب",
            deleteModalModalFormDesc:
                "إذا قمت بحذف هذا النموذج، فسيتم حذف جميع بيانات النموذج نهائيًا. هل أنت متأكد من رغبتك في المتابعة؟",
            todo: "أشياء يجب القيام بها",
            inProgress: "قيد التنفيذ",
            approval: "موافقة",
            completed: "مكتمل",
            transactionType: "نوع المعاملة",
            previousBalance: "الرصيد السابق",
            nextBalance: "الرصيد التالي",
            amount: "المبلغ",
            wpIntegrationChannelRequired: "مطلوب قناة تكامل الويب الخاصة بـ Whatsapp",
            wpIntegrationChannelRequiredDesc:
                "يتطلب تكامل واتساب + Whatsapp Web قناة Whatsapp Web. يُرجى إنشاء قناة جديدة.",
            wabaIntegrationChannelRequired: "مطلوب قناة تكامل واتساب للأعمال.",
            wabaIntegrationChannelRequiredDesc:
                "يتطلب تكامل واجهة برمجة تطبيقات واتساب للأعمال تكامل Whatsapp Business API قناة الويب الخاصة بـ Whatsapp. يُرجى إنشاء قناة جديدة.",
            instaIntegrationChannelRequired: "مطلوب قناة تكامل Instagram.",
            instaIntegrationChannelRequiredDesc:
                "يتطلب تكامل chatbot + Instagram قناة Instagram. يُرجى إنشاء قناة جديدة.",
            createWpChannel: "إنشاء قناة واتساب على الويب",
            createWabaChannel: "إنشاء قناة Whatsapp Business API",
            createInstaChannel: "إنشاء قناة Instagram",
            failToDeleteGroup: "فشل حذف المجموعة",
            failToDeleteGroups: "فشل في حذف المجموعات",
            failToFetchGroupContacts: "فشل في جلب جهات اتصال المجموعة",
            mailAddressDeletedSuccessfully: "تم حذف عنوان البريد بنجاح",
            defaultMailAddressChangedSuccessfully: "تم تغيير عنوان البريد الافتراضي بنجاح",
            mailAddressAlreadyRegistered: "لا يمكن أن يكون عنوان البريد مسجلاً بالفعل أو فارغاً.",
            pleaseVerifyByClicking: "الرجاء التحقق بالنقر على الرابط المرسل إلى عنوان بريدك الإلكتروني.",
            signSucsRegistered: "تم تسجيل التوقيع بنجاح",
            myContacts: "جهات الاتصال الخاصة بي",
            unanswered: "لم يتم الرد",
            emailBroadcasts: "عمليات البث عبر البريد الإلكتروني",
            monthlyLimit: "الحد الشهري",
            totalShipments: "إجمالي الشحنات",
            shippingStatus: "حالة الشحن",
            lastAction: "آخر إجراء",
            receiver: "المستلم",
            delivered: "تم التسليم",
            opened: "تم الفتح",
            clicked: "تم النقر",
            bounced: "عاد",
            clickedLinks: "تم النقر فوق الروابط",
            reason: "السبب",
            timer: "مؤقت",
            implemented: "تم التنفيذ؟",
            module: "الوحدة النمطية",
            excelDownload: "تنزيل Excel",
            serviceFeatures: "ميزات الخدمة",
            mailAddressDeletedSucs: "تم حذف عنوان البريد بنجاح",
            inputSearchText: "إدخال نص البحث",
            createRecord: "إنشاء سجل",
            separatorCharacter: "حرف فاصل",
            exampleResultPreview: "مثال على معاينة النتيجة",
            importRecords: "استيراد السجلات",
            equals: "يساوي",
            notEquals: "غير متساوٍ",
            startsWith: "يبدأ ب",
            endsWith: "ينتهي ب",
            greaterThan: "أكبر من",
            lessThan: "أقل من",
            before: "قبل",
            after: "بعد",
            is: "يكون",
            isNot: "ليس",
            empty: "فارغ",
            notEmpty: "غير فارغ",
            isOneOff: "مرة واحدة",
            field: "حقل",
            records: "سجل",
            addIntegration: "إضافة تكامل",
            chatbotScenarioReleased: "تم إصدار سيناريو روبوت المحادثة",
            chatbotScenarioHasBeenCancelled: "تم إلغاء سيناريو روبوت الدردشة الآلية",
            titleAndDesc: "العنوان والوصف",
            templateAndMailSelection: "اختيار القالب والبريد",
            peopleToSend: "الأشخاص المراد الإرسال إليهم",
            submissionPlans: "خطة التقديم",
            summary: "الملخص",
            broadcastTitle: "عنوان البث",
            sentByEmail: "البريد الإلكتروني المرسل",
            emailTemplate: "قالب البريد الإلكتروني",
            onlyPeopleWithEmail: "فقط الأشخاص الذين لديهم عنوان بريد إلكتروني صالح للإرسال",
            sendNow: "إرسال الآن",
            plan: "الخطة",
            senderEmail: "البريد الإلكتروني للمرسل",
            totalBuyer: "إجمالي المشتري",
            estimatedDuration: "المدة المقدرة",
            person: "الشخص",
            shippingIsNowComplete: "اكتمل الشحن!",
            back: "رجوع",
            customerName: "اسم العميل",
            customerEmail: "البريد الإلكتروني للعميل",
            customValue: "قيمة مخصصة",
            selectMailTemplate: "يجب عليك تحديد قالب بريد",
            youMustSelectSendingMailAddress: "يجب تحديد عنوان البريد المرسل.",
            youMustSelectCustomerGroupSend: "يجب تحديد مجموعة العملاء المراد الإرسال إليها.",
            createBroadcast: "إنشاء بث",
            broadcastDetails: "تفاصيل البث",
            youCanCheckYourEmailStatus:
                "يمكنك التحقق من حالة بريدك الإلكتروني عن طريق ترقية خطتك. يمكنك التحقق من حالة بريدك الإلكتروني عن طريق ترقية خطتك.",
            sentDetails: "التفاصيل المرسلة",
            failed: "فشل",
            total: "إجمالي",
            totalEmailsProcessed: "إجمالي رسائل البريد الإلكتروني التي تمت معالجتها",
            totalEmailsDelivered: "إجمالي رسائل البريد الإلكتروني المرسلة",
            toAvailableAgents: "للوكلاء المتاحين",
            toAvailableDepartments: "للأقسام المتاحة",
            toWithAgentAndDepartment: "للوكلاء والأقسام المتاحة",
            toMobilAgents: "للوكلاء المتنقلين",
            toPreferredAgents: "للوكلاء المفضلين",
            searchAgent: "وكيل البحث",
            searchDepartment: "قسم البحث",
            searchMobileAgent: "وكيل البحث المتنقل",
            searchAgentOrDepartment: "وكيل البحث أو القسم",
            searchPreferredAgent: "البحث عن الوكيل المفضل",
            noAgentsAvailableToForward: "لا يوجد وكلاء متاحين لإعادة التوجيه",
            noDepartmentsAvailableToForward: "لا توجد أقسام متاحة لإعادة التوجيه",
            noMobileAgentsAvailableToForward: "لا يوجد وكلاء متنقلون متاحون لإعادة التوجيه",
            noPreferredAgentsAvailableToForward: "لا يوجد وكلاء مفضلون متاحون لإعادة التوجيه",
            ifYouSendThisConversationToTheQueue:
                "إذا قمت بإرسال هذه المحادثة إلى قائمة الانتظار، فسيتم إزالتك من الدردشة ووضع المحادثة في قائمة الانتظار. إذا تم تمكين التخصيص التلقائي للمحادثة، فسيتم تعيين المحادثة إلى وكيل مناسب وقد يتم تحويلها إليك.",
            ifAutomaticChatAssignmentIsDisabled:
                "إذا تم تعطيل التخصيص التلقائي للمحادثة فستبقى المكالمة في قائمة الانتظار. يمكن للموظفين المصرح لهم استلام المكالمة من قائمة الانتظار.",
            sendQueue: "إرسال إلى قائمة الانتظار",
            agentName: "اسم الوكيل",
            departmentName: "اسم القسم",
            toQueue: "قائمة الانتظار",
            web: "الويب",
            mobile: "موبايل",
            noGrouping: "بدون تجميع",
            groupByThis: "تجميع حسب هذا",
            selectGroupingCriteria: "تحديد معايير التجميع",
            activeUsers: "المستخدمون النشطون",
            passiveUsers: "المستخدمون السلبيون",
            noPlatform: "لا توجد منصة محددة",
            noRole: "دور غير محدد",
            noDepartment: "لا يوجد قسم محدد",
            noLanguage: "لا توجد لغة محددة",
            group2: "مجموعة",
            groupedByStatus: "مجمعة حسب الحالة",
            grouping: "تجميع",
            activeSubjects: "الموضوعات النشطة",
            passiveSubjects: "الموضوعات المنفعلة",
            groupSubjects: "مواضيع المجموعة",
            showAll: "إظهار الكل",
            onlyActive: "نشط فقط",
            onlyPassive: "السلبي فقط",
            groupBy: "تجميع حسب الحالة",
            selectTimezone: "تحديد المنطقة الزمنية",
            userFilter: "عامل تصفية المستخدم",
            confidenceScore: "درجة الثقة",
            chatbotLanguage: "لغة روبوت المحادثة",
            botScenerio: "سيناريو الروبوت",
            selectTemplate: "تحديد القالب",
            ImportFromReadyTemplates: "الاستيراد من القوالب الجاهزة",
            classification: "تصنيف",
            addClassification: "إضافة تصنيف",
            expressionClassified: "التعبير المراد تصنيفه",
            zohoModuleName: "اسم وحدة Zoho",
            selectModule: "تحديد الوحدة النمطية",
            standardFields: "الحقول القياسية",
            selectStandardField: "تحديد حقل قياسي",
            customFields: "الحقول المخصصة",
            selectCustomFields: "تحديد حقل مخصص",
            aiFunction: "وظيفة الذكاء الاصطناعي",
            aiFunctionDesc: "إدارة دالة الذكاء الاصطناعي لتنفيذ إجراءات بناءً على مدخلات المستخدم",
            functionName: "اسم الدالة",
            functionDesc: "وصف الدالة",
            addParameter: "إضافة معلمة",
            chooseAiStory: "اختيار قصة ذكاء اصطناعي",
            chatbotAiPromptDesc:
                "الذكاء الاصطناعي يتعلم ويحدد كيف يجب أن يتصرف من خلال إعطائه تعليمات حول مهمة أو مشكلة معينة باستخدام ميزة 'المطالبة'.",
            enterPrompt: "أدخل الموجه",
            aiParameterTunings: "ضبط معلمة الذكاء الاصطناعي",
            aiParameterTuningsDesc:
                "يمكنك ضبط معلمات الذكاء الاصطناعي لجعل الذكاء الاصطناعي أكثر استجابة ودقة. تُستخدم هذه المعلمات للتحكم في سلوك الذكاء الاصطناعي وكيفية استجابته لمدخلات المستخدم.",
            temperature: "درجة الحرارة",
            temperatureDesc:
                "درجة حرارة أخذ العينات التي يجب استخدامها، بين 0 و 2. القيم الأعلى مثل 0.8 ستجعل الإخراج أكثر عشوائية، بينما القيم الأقل مثل 0.2 ستجعله أكثر تركيزًا وحتمية.",
            topDesc:
                "كبديل لأخذ العينات حسب درجة الحرارة، ما يسمى بأخذ العينات النواة (kernel sampling)، يأخذ النموذج في الاعتبار نتائج الرموز ذات الكتلة الاحتمالية الأعلى_p. لذا فإن 0.1 يعني أن الرموز ذات الكتلة الاحتمالية الأعلى بنسبة 10% فقط هي التي تؤخذ بعين الاعتبار. نوصي عادةً بتغيير هذا أو درجة الحرارة، ولكن ليس كليهما.",
            toolChoices: "خيارات الأداة",
            noneDesc: "لا شيء يعني أن النموذج لن يستدعي أي أداة وبدلاً من ذلك سينشئ رسالة.",
            autoDesc:
                "الوضع التلقائي هو القيمة الافتراضية ويعني أن النموذج يمكنه الاختيار بين توليد رسالة أو استدعاء عامل أو أكثر.",
            requiredDesc: "الوضع المطلوب يعني أن النموذج يجب أن يستدعي وكيلًا واحدًا أو أكثر قبل الاستجابة للمستخدم.",
            createArticles: "إنشاء مقالة",
            createArticlesDesc: "إنشاء مقالات لمساعدة المستخدمين في العثور على إجابات لأسئلتهم.",
            articlesTitle: "عنوان المقالة",
            articlesContent: "محتوى المقالة",
            createFaq: "إنشاء أسئلة متكررة (FAQ)",
            createFaqDesc:
                "إنشاء أسئلة متكررة جديدة لروبوت الدردشة الخاص بك. سيساعد هذا روبوت الدردشة الآلي في الإجابة عن أسئلة المستخدم.",
            question: "سؤال",
            saveAndClose: "حفظ وإغلاق",
            contentPreview: "معاينة المحتوى",
            upgradePackageTitle: "قم بترقية باقتك وتجنب القيود",
            upgradePackageDescription:
                "المزيد من الميزات، والمزيد من عمليات التكامل، والمزيد من الوكلاء! اتخذ إجراءً الآن لإدارة فريقك بشكل أفضل وزيادة إمكانات عملك إلى أقصى حد!",
            upgradePackage: "الترقية",
            deleteSelected: "حذف الملفات المحددة",
            newFolder: "مجلد جديد",
            newFile: "ملف جديد",
            noFilesFound: "لم يتم العثور على ملفات في هذا المجلد",
            uploadFile: "تحميل ملف",
            enterFolderName: "الرجاء إدخال اسم المجلد",
            folderName: "اسم المجلد",
            dropFileHere: "إسقاط الملفات هنا",
            createFolder: "إنشاء مجلد",
            fileUploadingError: "حدث خطأ أثناء تحميل ملف",
            fileUploadingSucs: "تم إنشاء المجلد بنجاح",
            folderNameNotEmpty: "لا يمكن أن يكون اسم المجلد فارغًا",
            deleteFolder: "حذف مجلد",
            sureDeleteFolder: "هل تريد بالتأكيد حذف هذا المجلد وجميع الملفات الموجودة فيه؟",
            deletionSucs: "تم الحذف بنجاح",
            deleteFile: "حذف ملف",
            sureDeleteFile: "هل أنت متأكد من أنك تريد حذف هذا الملف؟",
            deletionError: "حدث خطأ أثناء عملية الحذف",
            selectFile: "تحديد ملف",
            moreThanOneSelect: "يمكنك تحديد أكثر من ملف واحد",
            selectAnFile: "تحديد ملف",
            removeZohoLinkbulkSms: "إرسال رسائل نصية قصيرة مجمعة",
            sendBulkBulkSmsCustomers: "إرسال رسائل نصية قصيرة مجمعة إلى عملائك",
            writeYourMessage: "اكتب رسالتك هنا",
            sendSms: "إرسال رسائل نصية قصيرة",
            sendSmsYourCustomers: "إرسال رسائل قصيرة إلى عملائك",
            manageChannelDetail: "إدارة معلومات القناة",
            details: "التفاصيل",
            teamGramChannels: "قنوات TeamGram",
            newTeamGramIntegration: "تكامل TeamGram الجديد",
            teamGramIntegration: "تكامل TeamGram",
            notMoreThanOneTeamGramChannels: "لا يمكنك إنشاء أكثر من قناة TeamGram واحدة",
            teamGramDetail: "تفاصيل TeamGram",
            manageYourYourTeamGramIntegration: "إدارة تكامل TeamGram الخاص بك",
            trendyolChannels: "قنوات ترينديول",
            trendyolStoreIntegration: "تكامل متجر ترينديول",
            trenyolStoreConnection: "توصيل متجر ترينديول الخاص بك",
            deleteTrendyolIntegration: "حذف تكامل ترينديول",
            sureDeleteTrendyolIntegration: "هل أنت متأكد من رغبتك في حذف تكامل Trendyol؟ هذا الإجراء لا رجعة فيه.",
            trendyolStoreChannel: "قناة متجر ترينديول",
            deleteTrendyolChannel: "حذف قناة ترينديول",
            channelUpdatedSucs: "تم تحديث القناة بنجاح",
            failedUpdateChannel: "فشل تحديث القناة.",
            trendyolStoreIntegrationDetail: "تفاصيل تكامل متجر ترينديول",
            configureTrendyolStoreStoreIntegrationDetail: "تكوين تكامل متجر ترينديول الخاص بك",
            trenyolStoreProductQuestManage: "Trendyol Store - إدارة مهام المنتج",
            trendyolStoreDesc: "يمكنك استخدام الإعدادات التالية لإدارة الاستفسارات الخاصة بمنتجات متجر ترينديول.",
            zohoCrmChannels: "قنوات Zoho CRM",
            zohoPersonalChannel: "قنوات زوهو الشخصية",
            connectZohoZoho: "الاتصال بـ Zoho CRM",
            updateChannelDesc5: "تحديث قناة Zoho CRM",
            zohoCrmIntegration: "تكامل Zoho CRM",
            sureDeleteDeleteZohoChannel: "هل أنت متأكد من رغبتك في حذف قناة Zoho CRM؟",
            createNotMoreThanOneZohoChannels: "لا يمكنك إنشاء أكثر من قناة Zoho واحدة",
            removeZohoLink: "إزالة رابط Zoho",
            connectToZoho: "الاتصال ب Zoho",
            chatClosed: "تم إغلاق الدردشة",
            scoreChat: "تم تسجيل الدردشة",
            createdTicket: "تم إنشاء تذكرة",
            updatedTicket: "تم تحديث التذكرة",
            newUserCreated: "تم إنشاء مستخدم جديد",
            updateUser: "مستخدم محدث",
            deleteUsers: "تم حذف مستخدم",
            changeStatusRepresent: "تم تغيير حالة الممثل",
            incomingMessage: "رسالة واردة",
            outgoingMessage: "رسالة صادرة",
            createdNewTicket: "تم إنشاء تذكرة جديدة",
            bitrix24Channels: "قنوات Bitrix24",
            sureDeleteBitrixChannel: "هل أنت متأكد أنك تريد حذف قناة Bitrix24؟",
            bitrix24Integrations: "تكامل Bitrix24",
            notCreateMoreThanOneChannel: "لا يمكنك إنشاء أكثر من قناة واحدة من قنوات Ideasoft",
            connectToBitrix24: "الاتصال بـ Bitrix24",
            connectToBitrix24Api: "الاتصال ب Bitrix24 Api",
            updateChannel: "تحديث القناة",
            updateChannelDesc: "تحديث قناة Bitrix24 Api",
            yourBitrix24Domain: "اسم مجال Bitrix24 الخاص بك",
            bitrix24ConnectedSucs: "تم توصيل Bitrix24 بنجاح",
            failedToConnectBitrix24: "فشل الاتصال بـ Bitrix24",
            channelCreatedSuccessfully: "تم إنشاء القناة بنجاح",
            failedToCreateChannel: "فشل إنشاء قناة",
            holidayPlusChannels: "قنوات Holiday+Channels",
            newHolidayPlusIntegration: "تكامل جديد لـ Holiday+",
            holidayPlusIntegrations: "تكامل Holiday+",
            notCreateMoreThanOneHolidayChannel: "لا يمكنك إنشاء أكثر من قناة عطلة+ واحدة",
            holidayPlusDetail: "تفاصيل العطلة+",
            manageHolidayPlusIntegration: "إدارة تكامل Holiday+ الخاص بك",
            ideasoftChannels: "قنوات Ideasoft",
            connectToIdeasoft: "الاتصال بـ Ideasoft",
            connectToIdeasoftApi: "الاتصال بواجهة برمجة تطبيقات Ideasoft",
            updateChannelDesc2: "تحديث قناة واتس آب للأعمال",
            ideasoftIntegration: "تكامل Ideasoft",
            sureDeleteIdeasoftChannel: "هل تريد بالتأكيد حذف قناة Ideasoft؟",
            moreThanOneChannelError: "لا يمكنك إنشاء أكثر من قناة Ideasoft واحدة",
            websiteAddress: "عنوان موقع الويب",
            ideasoftConnectedSucs: "تم توصيل Ideasoft بنجاح",
            failedToConnectIdeasoft: "فشل الاتصال بـ Ideasoft",
            redirectURLcopiedToClipboard: "إعادة توجيه عنوان URL المنسوخ إلى الحافظة",
            openAIChannels: "فتح قنوات الذكاء الاصطناعي",
            newOpenAiChannel: "قناة OpenAI جديدة",
            createNewChannelOpenAi: "إنشاء قناة جديدة ل OpenAI",
            updateChannelDesc3: "تحديث قناة واتساب لـ Whatsapp business api",
            openAiIntegration: "تكامل OpenAI",
            sureDeleteOpenAiChannel: "هل أنت متأكد من رغبتك في حذف قناة OpenAI؟",
            createMoreThanOneOpenAiChannel: "لا يمكنك إنشاء أكثر من قناة OpenAI واحدة",
            postaCellChannels: "قنوات PostaCell",
            newPostaCellChannel: "قنوات PostaCell الجديدة",
            createNewPostaCellChannel: "إنشاء قناة جديدة لمزود خدمة الرسائل القصيرة لـ PostaCell",
            updateChannelDesc4: "تحديث قناة Whatsapp business api",
            accessControl: "التحكم في الوصول",
            leads: "الرصاص",
            ensureFacebookAccount: "تأكد من وجود حساب وصفحة على فيسبوك",
            ensureAdAccount: "تأكد من وجود حساب إعلاني",
            page: "الصفحة",
            leadCount: "عدد العملاء المحتملين",
            showLeads: "إظهار العملاء المحتملين",
            syncLeeds: "مزامنة ليدز",
            wpStartChat: "مشغل دردشة واتساب",
            archivedIn: "مؤرشف؟",
            makeSelect: "إجراء التحديد",
            newLead: "Leed الجديد",
            initialContact: "جهة الاتصال الأولى",
            needsAssessment: "تحليل الاحتياجات",
            proposalSent: "إرسال العرض",
            proposalReview: "مراجعة العرض",
            negotiation: "التفاوض",
            decisionStage: "مرحلة القرار",
            closure: "إغلاق",
            followUp: "متابعة",
            campaign: "حملة",
            adSet: "مجموعة الإعلانات",
            ad: "إعلان",
            inArchived: "مؤرشف",
            deletedSelectedPerson: "حذف الأشخاص المحددين",
            sureDelSelectedPerson: "هل أنت متأكد من رغبتك في حذف الأشخاص المحددين؟",
            deletePerson: "حذف الأشخاص المحددين",
            sureDeletePerson: "هل أنت متأكد من رغبتك في حذف الشخص؟",
            phoneNumberNotAvailable: "رقم الهاتف غير متوفر",
            statusSucsUpdated: "تم تحديث الحالة بنجاح",
            statusUpdatedFailed: "حدث خطأ أثناء تحديث الحالة",
            archivedContact: "أرشفة جهة الاتصال",
            sureWantArchivePerson: "هل أنت متأكد أنك تريد أرشفة هذا الشخص؟",
            personArchived: "شخص مؤرشف",
            personArchivedHead: "فشلت عملية الأرشفة",
            metaLeadChannels: "قنوات ميتا ليد",
            wpStartSpeech: "بادئ خطاب واتساب",
            pleaseSelectStartChat: "الرجاء تحديد القناة التي تريد بدء الدردشة عليها:",
            phoneNumber: "رقم الهاتف",
            phoneNumberDesc: "رمز البلد مع أرقام فقط بدون مسافات",
            channelDesc: "القناة التي تريد بدء الدردشة عليها",
            pleaseSelectStartChatOn: "يرجى تحديد القناة التي تريد بدء الدردشة عليها",
            notAuthorisedChannel: "أنت غير مصرح لك بالوصول إلى هذه القناة.",
            phoneNumberError: "رقم الهاتف غير صحيح",
            chatStartError: "حدث خطأ في بدء الدردشة. يرجى المحاولة مرة أخرى.",
            noRecordFailed: "لم يتم العثور على سجل",
            metaLeadsChannel: "قناة MetaLeads Leads",
            mlChannelDetails: "تفاصيل قناة Meta Leads",
            manageMlChannel: "إدارة قناة العروض الوصفية",
            deleteMetaLeadsChannelInfo: "هل أنت متأكد من أنك تريد حذف قناة Meta Leads؟",
            contactPage: "صفحة الاتصال",
            addRouted: "إضافة موجه",
            otherEmailProviders: "موفرو البريد الإلكتروني الآخرون",
            visitorScreenLabel: "تسمية شاشة الزائر",
            enterCatalogTitle: "أدخل عنوان الكتالوج...",
            passwordUpdate: "تحديث كلمة المرور",
            showCenterScreen: "العرض في منتصف الشاشة",
            skipNow: "تخطى الآن",
            confirm: "تأكيد",
            newTable: "جدول جديد",
            actions: "معاملات",
            integrationsTrendyol: "اربط متجرك على Trendyol ورد على استفسارات عملائك تلقائيًا",
            integrationsHoliday: "قم بدمج Holiday+ لتوفير الفنادق والغرف عبر الدردشة الآلية",
            integrationsTeamgram: "انقل عملائك من Supsis إلى Teamgram لتبسيط إدارة العملاء لديك",
            integrationsTicimax: "أرسل رسالة آلية إلى الأعضاء المجزئين في Ticimax",
            integrationsBitrix24: "قم بتفعيل API Bitrix24 لتحسين تجربة الدردشة الآلية لعملائك",
            integrationsIdeasoft: " قم بتفعيل API Ideasoft لتحسين تجربة الدردشة الآلية لعملائك",
            integrationsOpenAI:
                "تفعيل خدمات OpenAI استجابة الذكاء الاصطناعي للدردشة, مساعد الذكاء الاصطناعي CoPilot قاعدة معلومات الذكاء الاصطناعي للدردشة",
            integrationsSMSPostacell: "قم بتفعيل إرسال الرسائل النصية عبر مزود خدمة الرسائل النصية PostaCELL",
            integrationsMetaLeads:
                "قم بإدارة عملاء Meta المحتملين عبر Supsis اربط العملاء المحتملين بالتذاكر أو روبوت الدردشة أو الدعم المباشر",
            integrationsZoho: "ادمج عملياتك التجارية في Zoho CRM مع Supsis.",

            forward: "إلى الأمام",
            packUpRequired: "مطلوب ترقية الحزمة",
            upgradePack: "باقة الترقية",
            supsisMobilApp: "تطبيق SUPSIS MOBİL",
            supsisMobilAppDesc: "تطبيق IOS و Android في السوق!",
            sendEmail: "إرسال بريد إلكتروني",
            jumpToMessage: "انقر للانتقال إلى الرسالة",
            doesntMatter: "لا يهم",
            events: "أحداث التقويم",
            reservations: "الحجوزات",
            designer: "مصمم",
            targetContacts: "جهات الاتصال المستهدفة",
            scheduler: "المجدول",
            planAndTask: "الخطة والمهام",
            insights: "رؤى",
            createRole: "إنشاء دور",
            createSubject: "إنشاء موضوع",
            createUser: "إنشاء مستخدم",
            blockManuel: "بلوك مانويل",
            showHide: "إظهار/إخفاء",
            contactSearch: "البحث عن جهة الاتصال",
            favorites: "المفضلة",
            downloadAllData: "تنزيل جميع البيانات",
            downloadThePage: "تنزيل الصفحة",
            choosePoints: "اختر النقاط",
            channel: "قناة",
            createdAt: "تم إنشاؤها في",
            action: "الإجراء",
            searchChannel: "قنوات البحث",
            activeChannels: "القنوات النشطة",
            deleteChannels: "القنوات المحذوفة",
            selectChannel: "اختر القناة",
            channelFilter: "تصفية القناة",
            noConversationDesc: "هنا يمكنك رؤية الدردشات النشطة والدردشات المخصصة لك.",
            forMe: "بالنسبة لي",
            unAssigned: "غير معين",
            agentDetails: "تفاصيل الوكيل",
            contactProperties: "خصائص الاتصال",
            goToProfile: "اذهب إلى الملف الشخصي",
            addNote: "أضف ملاحظة",
            noPreferredAgent: "لا يوجد وكيل مفضل بعد",
            toPrefer: "تفضيل",
            inChat: "في الدردشة",
            watching: "يشاهد",
            chatsTitle: "المحادثات",
            dealyTimeMaxValueError: "يمكن أن يكون وقت التأخير 15 كحد أقصى",
            dealyTimeTypeError: "يجب أن تكون قيمة وقت التأخير رقما",
            passedTimeHm: "{hour} ساعات {min} دقائق",
            passedTimeMs: "{min} دقائق {sec} ثانية",
            passedTimeSc: "{sec} ثانية",
            translateMessage: "تمت ترجمة رسالتك بواسطة الذكاء الاصطناعي.",
            toneChanged: "تم تغيير نبرة الرسالة إلى {tone}",
            aiResponseAdded: "تمت إضافة استجابة الذكاء الاصطناعي إلى الرسالة",
            messageLonger: "تم جعل الرسالة أطول",
            grammarFixed: "تم تصحيح القواعد",
            aiTranslate: "ترجمة",
            other: "آخر",
            yourLanguage: "لغتك",
            contactLanguage: "لغة العملاء",
            myLanguage: "لغتي",
            forwardToChatbot: "إرسال إلى الروبوت",
            friendly: "ودود",
            confident: "واثق",
            straightForward: "بسيط",
            casual: "غير رسمي",
            professional: "مهني",
            longSentence: "جملة طويلة",
            changeTone: "تغيير النبرة",
            fixGrammar: "تصحيح القواعد",
            aiResponse: "استجابة الذكاء الاصطناعي",
            templateButtonNote:
                "لحظر الاتصال، تأكد من استخدام النصوص التالية على زر الحظر. بغض النظر عن الأحرف الكبيرة أو الصغيرة",
            templateButtonTags: "#إلغاء الاشتراك# | #حظر# | #منع# | #إلغاء الاشتراك#",
            dashboard: "لوحة القيادة",
            calendarModule: "وحدة التقويم",
            taskModule: "وحدة إدارة المهام",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "لا يوجد قسم مفضل",
            searchForDepartment: "البحث عن القسم",
            departmentAssignedToTheVisitor: "حدد القسم الذي ترغب في تعيينه للزائر.",
            assignPreferredDepartment: "تعيين القسم المفضل",
            smsChannel: "قناة الرسائل القصيرة",
            whatsappv2Channel: "قناة واتساب V2",
            whatsappv1Channel: "قناة واتساب V1",
            wBChannel: "قناة واتساب للأعمال",
            messengerChannel: "قناة المراسل",
            instagramChannel: "قناة Instagram",
            allPlatforms: "جميع المنصات",
            cbStartMessage: "رسالة بدء الدردشة الآلية",
            cbStartMessageDesc:
                "تتم معالجة الرسالة الأولى التي يدخلها المستخدم تلقائيًا بواسطة الدردشة الآلية وتوجيهها إلى العنوان المناسب.",
            messengerUserProfile: "ملف تعريف مستخدم Messenger",
            instagramUserProfile: "ملف تعريف مستخدم Instagram",
            noEventFound: "لم يتم العثور على أحداث",
            visitorMails: "رسائل الزوار",
            visitorActions: "إجراءات الزائرين",
            notVerified: "غير مُتحقق",
            visitorEvents: "أحداث الزوار",
            assignedTasks: "المهام المعينة",
            mails: "رسائل البريد",
            prefferedAgents: "الوكلاء المفضلين",
            createEvent: "إنشاء حدث",
            blockManagement: "إدارة الحظر",
            deleteUser: "حذف المستخدم",
            blocked: "محظور",
            profiles: "الملفات الشخصية",
            similiarProfiles: "تم العثور على ملفات مماثلة",
            ReplyAsAPm: "الرد كرسالة خاصة والإغلاق",
            replyAsAComment: "الرد كتعليق والإغلاق",
            messengerAddDesc: "انقر على الزر الاتصال أدناه وقم بتسجيل الدخول إلى حساب الفيسبوك الخاص بك.",
            instaAddPrivacyCheckDesc: "لقد قرأت وأوافق على {Terms and Conditions} و {Privacy}",
            instaAddDesc5: "انقر على الزر الاتصال أدناه وقم بتسجيل الدخول إلى حساب الفيسبوك الخاص بك.",
            instaAddDesc4: "التسجيل كمطور فيسبوك",
            instaAddDesc3: "تأكد من تفعيل مفتاح <b>'السماح بالوصول إلى الرسائل'</b>",
            instaAddDesc2: "تأكد من أن حسابك المهني في Instagram متصل بصفحتك على الفيسبوك",
            instaAddDesc1: "تأكد من أن حسابك على Instagram هو حساب مهني (حساب تجاري) في Instagram.",
            selectedDepartment: "القسم المحدد",
            departmentForwardEnable: "تم تمكين قاعدة إعادة توجيه القسم",
            departmentForwardRule: "قاعدة إعادة توجيه القسم",
            departmentForwardDesc: "حدد القسم الذي ستُحيل إليه المحادثات الواردة إلى القناة.",
            channelName: "اسم القناة",
            forwardToLiveAgents: "إعادة توجيه إلى الوكلاء الحيين👉 ",
            manageIgChannel: "إدارة قناتك على Instagram",
            igDetail: "تفاصيل إنستجرام",
            manageVisibilityDesc: "إدارة من يمكن أن يرى هذه القناة",
            selectAnIgAccount: "اختر حساب Instagram",
            connectToInsta: "الاتصال بـ Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "هل أنت متأكد أنك تريد حذف قناة Instagram؟",
            instagramChannels: "قنوات إنستجرام",
            suspendedDescription: "لقد تم تعليق حسابك بسبب الفواتير غير المدفوعة.",
            onlyChatbot: "الدردشة فقط",
            onlyAgents: "الوكلاء فقط",
            checkboxWarning: "يجب تحديد هذا الحقل",
            sendingAllow: "إرسال",
            receiving: "استقبال",
            platform: "منصة",
            banModalTitle: "النافذة المنبثقة لحظر الزائر",
            selectDepartmentDesc: "حدد الأقسام التي ترغب في تغيير رؤيتها",
            selectAgentDesc: "حدد الوكلاء الذين ترغب في تغيير رؤيتهم",
            selectDepartment: "حدد القسم",
            selectAgent: "حدد الوكيل",
            visibleDepartments: "الأقسام المرئية",
            visibleAgents: "الوكلاء المرئيين",
            visibilityInfoCont: "يمكن لجميع الوكلاء والإدارات رؤية هذه القناة",
            editDepartmentVisibility: "تحرير أذونات القسم",
            editAgentVisibility: "تحرير أذونات الوكيل",
            typeSTToSearch: "اكتب شيئًا للبحث عن المستخدمين",
            exportToCSV: "تصدير إلى CSV",
            clear: "مسح",
            usedSessionCount: "عدد الجلسات المستخدمة",
            maxSessionCount: "الحد الأقصى لعدد الجلسات",
            leftSessionCount: "عدد الجلسات المتبقية",
            planManagement: "إدارة الخطط",
            maxAutomationTask: "الحد الأقصى لمهام الأتمتة",
            teamChat: "دردشة الفريق",
            templateNameIsNotValid: "اسم القالب غير صالح",
            relatedAdvertisement: "إعلان ذو صلة",
            whatsappNumber: "رقم واتس اب",
            integrationsWhatsappV1: "يتطلب خطة واتساب لتحقيق تواصل سلس بين Supsis و WhatsApp.",
            integrationsWhatsappV2: "يمكنك نقل معلومات الدردشة بسهولة بين Supsis و WhatsApp.",
            integrationsWhatsappBusiness: "يمكنك نقل معلومات الدردشة بسرعة وبشكل ملائم بين Supsis و WhatsApp.",
            selectDays: "اختر الأيام",
            addTime: "اختر الوقت",
            instagramContactList: "قائمة جهات الاتصال على Instagram",
            archiveAllRated: "احصل على جميع المحادثات التي تم فيها إجراء تقييم.",
            allChannels: "جميع القنوات",
            comment: "تعليق",
            news: "ما الاخبار",
            conversation: "حديث الفريق",
            speechTermination: "إنهاء المحادثة",
            noSystemMessage: "لا توجد رسائل في النظام حتى الآن!",
            supsisCustomerService: "خدمات العملاء التي تقدمها Supsis ،",
            supsisClickExperience: "يمكنك تجربة التجربة من خلال النقر.",
            customerPage: "انتقل إلى صفحة العملاء",
            buttonTitle: "عنوان الزر",
            buttonType: "نوع الزر",
            buttonSendMessage: "ارسل رسالة",
            buttonGoToBlock: "اذهب إلى المدونة",
            buttonOpenUrl: "رابط مفتوح",
            buttonPhoneCall: "مكالمة هاتفية",
            buttonOpenMoment: "افتح لحظة",
            buttonCloseChat: "إغلاق الدردشة",
            buttonTransferChat: "نقل الدردشة",
            buttonCreateTicket: "إنشاء تذكرة",
            deleteVisitor: "هل أنت متأكد أنك تريد حذف المستخدم؟ لا يمكن التراجع عن هذا الإجراء.",
            userProfile: "الملف الشخصي",
            addCalendarEvent: "إضافة +",
            you: "أنت",
            and: "و",
            apiIntegration: "مطور",
            generateToken: "إنشاء رمز مميز",
            copyToken: "نسخ الرمز المميز",
            dndBlocked: "تم إيقاف تشغيل إعدادات إرسال الملف.",
            labels: "تسميات",
            noData: "لايوجد بيانات",
            color: "لون",
            titleColor: "لون العنوان",
            secondTitleColor: "لون العنوان الثاني",
            tag_name_indicator: "اسم العلامة",
            sendMessage: "إرسال رسالة",
            removeFromG: "إزالة من المجموعة",
            delChannel: "هل أنت متأكد أنك تريد حذف هذه القناة؟",
            new_name: "اسم جديد",
            set_group_info: "تحرير معلومات المجموعة",
            shortcut_desc_num: "التبديل بين المحادثات النشطة باستخدام الأرقام الرقمية",
            copilot_desc_num: "يسمح لك بفتح Copilot على شاشة الدردشة",
            typing_w_chat: "يكتب...",
            edit_group_info: "تحرير معلومات المجموعة",
            notif_sound: "قم بتشغيل أصوات الإشعارات",
            notif_mute: "كتم الإشعارات",
            leave: "انصرف",
            group: "مجموعة",
            updateTag: "تحديث العلامة",
            ordered_desc: "تخصيص الدردشات للممثلين بالترتيب.",
            random_desc: "تخصيص الدردشات للممثلين بشكل عشوائي.",
            Rrobin_desc: "تخصيص الدردشات للممثلين بأسلوب دوري دائري. (يعطي الأولوية للممثلين الأقل انشغالًا)",
            RrobinRev_desc: "تخصيص الدردشات للممثلين بأسلوب دوري دائري عكسي. (يعطي الأولوية للممثلين الأكثر انشغالًا)",
            algo_desc: "اختر الخوارزمية لتوزيع الدردشات تلقائيًا",
            algorithm: "خوارزمية",
            os_browser: "نظام التشغيل ومتصفح الويب",
            CHAT: "محادثة",
            addTag: "إضافة علامة",
            tags: "العلامات",
            searchRepresentative: "البحث عن مندوب",
            voting: "التصويت",
            chatWidget: "supsis دردشة القطعة",
            webhooks: "Webhooks",
            selectHooks: "حدد خطاف الويب",
            planRequired: "{integratable} الخطة المطلوبة",
            allIntegrations: "جميع التكامل",
            disableAgentSystemMessages: "إخفاء رسائل نظام الوكيل",
            disableAgentSystemMessagesDesc: "إخفاء رسائل نظام الوكيل.",
            disableAutoTranslate: "الترجمة التلقائية",
            disableAutoTranslateDesc:
                "يترجم الرسائل تلقائياً من اللغات المختلفة. وبالتالي يمكنك التواصل مع عملائك بسهولة أكبر.",
            shouldAddMethod: "يجب عليك ملء طريقة الدفع وعنوان الفواتير!",
            approveSelection: "الموافقة على الاختيار",
            trialDaysEndSelectPlan: "تأكيد اختيار الخطة",
            trialDaysEndSelectPlanDesc: "لقد انتهى نسختك التجريبية. تحتاج إلى التأكيد من خلال اختيار الخطة أدناه.",
            infoAboutAnnouncement: "معلومات موجزة حول الإعلان",
            announcement: "إعلان",
            newAnnouncementForm: "نموذج إعلان جديد",
            newAnnouncement: "إعلان جديد",
            announcements: "الإعلانات",
            newTicketSound: "تذكرة جديدة",
            vtippyDepartmentNotification: "إعدادات الإشعار لرسائل محادثة القسم",
            vtippyGroupNotification: "إعدادات الإشعار لرسائل المجموعات التي تم إنشاؤها",
            vtippyTicketNotification: "إعدادات الإشعار لكل تذكرة جديدة تتلقاها",
            vtippyAnnouncemenNotification: "إعدادات الإشعار للإعلانات الجديدة",
            languageSelection: "اختيار اللغة",
            announcementTitle: "عنوان الإعلان",
            infinitePlay: "العب بشكل مستمر",
            hideBubbleOnMobile: "يختبئ على الهاتف المحمول",
            vtippyHideBubbleOnMobile: "يتم إخفاء فقاعة الدردشة من مستخدمي الأجهزة المحمولة.",
            deleteSystemLanguage: "حذف {code} لغة من النظام",
            assignedChat: "دردشة مخصصة",
            check: "خانة الاختيار",
            systemStatus: "حالة النظام",
            chatAssignedToUser: "محادثة جديدة مخصصة",
            inactiveThresholdTime: "وقت الدردشة غير النشط (دقيقة)",
            tippyInactiveThresholdTime:
                "إذا لم يتم إرسال أي رسالة خلال الوقت المحدد ، فإن المحادثة تعتبر غير نشطة. أدخل القيمة (الدقائق). يجب أن يكون المدى في 1 دقيقة - 120 دقيقة.",
            inactiveTerminateTime: "إنهاء الدردشة غير النشطة المدة (دقيقة)",
            tippyInactiveTerminateTime:
                "سيتم إنهاء الدردشة غير النشطة إذا لم يتم تحويلها إلى الوضع النشط خلال فترة زمنية معينة. أدخل القيمة (الدقائق). يجب أن يكون المدى في 1 دقيقة - 120 دقيقة.",
            removePendingMessage: "إلغاء إرسال الرسالة",
            disconnected: "انقطع الاتصال",
            visitorWriteEmptyChatTippy: "يمكن للعميل الكتابة إلى محادثة قبل اتصال الوكيل.",
            visitorWriteEmptyChat: "يمكن للعميل الكتابة بدون وكيل متصل.",
            visitorConnectionEventSystemMessageEnabled: "تمكين رسائل نظام حالة اتصال الزوار",
            visitorConnectionEventSystemMessageEnabledTippy: "غادر الزائر ورسائل نظام عودة الزوار تمكين",
            openBubble: "فقاعة مفتوحة",
            showHeaderImage: "عرض صورة الرأس",
            askQuestion: "طرح سؤال",
            locationPermsNeeded: "هناك حاجة إلى أذونات الموقع لاستخدام هذه الميزة",
            useMyLocation: "استخدم موقعي",
            acceptingChat: "قبول الدردشات",
            notAcceptingChat: "عدم قبول الدردشات",
            blockBy: "محظور من قبل",
            languageRemovalQuestion: "أنت على وشك حذف لغة {code} من النظام!",
            loggedOut: "تسجيل الخروج",
            vtippyNewVisitorNotification: "إشعار مسموع لكل زائر جديد إلى موقع الويب الخاص بك",
            vtippySelectnotification: "يمكنك اختيار صوت الإخطار.",
            vtippyVoiceLevel: "يمكنك ضبط مستوى الصوت",
            vtippyStartVoice: "يستمع",
            vtippyInfiniteNotification:
                "إذا لم تكن نشطًا في لوحة الدردشات الجديدة ، فستستمر في اللعب. يمكنك تحرير النقر النشط بالنقر.",
            vtippyTranslateButton: "يترجم اللغة المحددة إلى لغات أخرى",
            vtippyTranslateClearButton: "ينظف المحتوى بلغات أخرى.",
            vtippyNewChatNotification: "يمكنك تحديد إشعار الصوت للمحادثات الجديدة القادمة إلى النظام وضبط مستوى الصوت.",
            vtippyNewConversationNotification:
                "يمكنك اختيار إشعار الصوت وضبط مستوى الصوت عندما يتم تعيين محادثات واردة جديدة لك.",
            vtippyNewMessageNotification: "يمكنك تحديد إشعارات للرسائل الواردة لمحادثاتك وضبط مستوى الصوت.",
            vtippyPrivateMessageNotification: "يمكنك تحديد إشعار للرسالة الواردة إلى Talk Talk.",
            hideInactiveAgents: "إخفاء العوامل غير النشطة",
            hideMinorValues: "إخفاء القيم البسيطة",
            hashHintMessage: "يمكنك إدخال اختصارات الهاشتاج بسرعة مع #hash",
            pmHintMessage: "هل تعلم أنه يمكنك إرسال رسالة خاصة للكلمة الرئيسية؟ على سبيل المثال PM: مرحبًا",
            shortcutHintMessage: "هل تعلم أنه يمكنك إرسال رسائل بشكل أسرع مع الرسائل المختصرة؟",
            switchBetweenConversations: "هل تعلم أنه يمكنك التبديل بسرعة بين المحادثات مع اختصارات ABC؟",
            atNameHintMessage: "هل تعلم أنه يمكنك إدخال اسم الزائر بسرعة مع name؟",
            dndHintMessage: "يمكنك تحميل الملفات باستخدام السحب والإفلات.",
            pasteFile: "يمكنك إرسال الملفات.",
            atEmailHintMessage: "هل تعلم أنه يمكنك إدخال بريد الزائر بسرعة مع @mail؟",
            pastePlainText: "اللصق من الحافظة كنص عادي",
            pressAndTalk: "Press and talk",
            agentActivities: "أنشطة الوكيل",
            listStatuses: "الحالات",
            newHASHContent: "#add التجزئة",
            hash: "الوسم",
            hashText: "نص التجزئة",
            exampleHash: "تتبع الطلب",
            notValidHash: "يجب ألا تحتوي على مسافات.",
            websiteChatWidgetIntegration: "تكامل أداة الدردشة على الموقع",
            videoCallEnabledDesc: "تنشيط لتمكين ميزة مكالمة الفيديو.",
            videoCallEnabled: "ميزة مكالمة الفيديو",
            audioCallDesc: "تنشيط لتمكين ميزة البحث الصوتي.",
            audioCallEnabled: "ميزة البحث الصوتي",
            assignPreferredAgent: "تعيين وكيل مفضل",
            representativeAssignedToTheVisitor: "حدد الوكيل المفضل الذي تريد تعيينه للزائر.",
            agentFileSendEnabledDesc: "يتيح القدرة على إرسال الملفات إلى المندوبين",
            agentFileSendEnabled: "يمكن للممثلين إرسال الملفات",
            visitorFileSendEnabledDesc: "يتيح لك تشغيل ميزة إرسال ملف الزوار أو إيقاف تشغيلها",
            visitorFileSendEnabled: "يمكن للزوار إرسال الملفات",
            visitorAutoLogin: "زائر تسجيل الدخول للسيارات",
            visitorAutoLoginDesc: "بدء المحادثة التلقائية عندما انقر فوق الزائر على فقاعة الدردشة",
            agentVoiceRecordEnabledDesc: "يمكّن الوكلاء من تسجيل الصوت",
            agentVoiceRecordEnabled: "يمكن للوكلاء تسجيل الصوت",
            visitorVoiceRecordEnabledDesc: "يمكّن الزائرين من تسجيل الصوت",
            visitorVoiceRecordEnabled: "يمكن للزوار تسجيل الصوت",
            startVideoCall: "مكالمة فيديو",
            startAudioCall: "مكالمة صوتية",
            visitorGDPRDeleteEnabledDesc: "يتيح لك تبديل القدرة على حذف جميع معلومات الزوار",
            visitorGDPRDeleteEnabled: "يمكن للزوار حذف جميع معلوماتهم",
            visitorLocationEnabled: "يمكن للزوار مشاركة الموقع",
            visitorLocationEnabledDesc: "يسمح للزائرين بتشغيل مشاركة الموقع أو إيقاف تشغيله",
            customerLocationEnabled: "يمكن للممثلين مشاركة الموقع",
            customerAutoMergeEnabled: "يدمج تلقائيا نفس الأفراد",
            customerAutoMergeEnabledDesc:
                "تقوم هذه الميزة بتنفيذ عملية الدمج التلقائي لجمع بيانات تخص نفس الأفراد بفعالية. وبهذه الطريقة، يتم تمثيل المستخدمين ذوي الملامح المماثلة بشكل أكثر انتظاما وترتيبا في مجموعات البيانات.",
            chatAiCopilot: "مساعد الدردشة الذكية",
            chatAiCopilotDesc: "الرد التلقائي على أسئلة عملائك باستخدام مساعد الدردشة الذكية",
            customerLocationEnabledDesc: "يسمح للممثلين بتشغيل مشاركة الموقع أو إيقاف تشغيله",
            thoesNotOwners: "إبقاء غير المالكين في قائمة الانتظار",
            thoesNotOwnersDesc: "يمكنك تمكين هذه الميزة لإبقاء الأشخاص الذين لا يملكون المحادثة في قائمة الانتظار.",
            hideContactInfo: "إخفاء معلومات الاتصال",
            hideContactInfoDesc:
                "عند تمكين هذه الميزة، سيتم إخفاء أرقام العملاء ورسائل البريد الإلكتروني الخاصة بهم عن الوكلاء.",
            triggerAlreadyExists: "الزناد موجود بالفعل",
            ticketStatusForm: "نموذج حالة التذكرة",
            statusFormTitle: "عنوان حالة التذكرة",
            allStatus: "جميع الحالات",
            triggers: "محفزات",
            trigger: "مشغل",
            noTrigger: "لم تضيف أي مشغلات بعد",
            triggerSkipLoginForm: "نموذج تسجيل الدخول",
            triggerSkipLoginFormTrue: "إظهار نموذج تسجيل الدخول",
            triggerSkipLoginFormFalse: "تخطي نموذج تسجيل الدخول والانتقال مباشرة إلى الرسالة",
            noContent: "لا يوجد محتوى",
            toCreate: "لنصنع او لنبتكر",
            clickTheButton: "انقر فوق الزر",
            triggerContent:
                "اكتب الوصف الذي تريد ظهوره في الوسيط الذي يفتح. ما عليك سوى الكتابة بلغة واحدة ويتم الترجمة إلى لغات أخرى تلقائيًا.",
            triggerDrag: "يمكنك ضبط مدة الرسالة عن طريق سحب الشريط أو النقر عليه.",
            triggerNewCondition: "يمكنك إضافة حالة جديدة مع الزر.",
            triggerNoConditionDescription1:
                "يمكنك إنشاء الشروط التي تريدها من الخيارات. إذا لم تنشئ أي شروط لأي مشغل ، فسيكون المشغل الأول نشطًا.",
            triggerNoConditionDescription2: "يظهر واحد فقط من المشغلات مع نفس الشروط على صفحة الزوار.",
            triggerShowAndHide: "يمكنك إظهار أو إخفاء المشغلات وقتما تشاء.",
            countryLanguage: "لغة البلد",
            addTrigger: "إضافة الزناد",
            yesPlease: "نعم من فضلك!",
            noThanks: "ًلا شكرا.",
            firstAnswer: "تأكيد حوار السؤال الجواب",
            secondAnswer: "اسأل حوار استبعاد الإجابة",
            noTitle: "لا يوجد حاضر",
            sumChat_MediaFile: "الوسائط والوثائق",
            importantWarning: "تحذير مهم!",
            images: "الصور",
            URLS: "روابط",
            files: "دوسيلار",
            noCondition: "بدون شرط! يمكنك إضافة شروط بالنقر فوق أيقونة Plus.",
            showTriggers: "انقر لإظهار المشغلات",
            showThisTrigger: "انقر لإظهار هذا الزناد",
            hideTriggers: "انقر لإخفاء المشغلات",
            hideThisTrigger: "انقر لإخفاء هذا الزناد",
            updateTrigger: "تحديث الزناد",
            conditions: "شروط",
            messageDurationPerRow: "مدة الرسالة لكل صف",
            updateCompleted: "تحديث الانتهاء",
            CatalogUpdatedSuccessfully: "تم تحديث الكتالوج بنجاح",
            integrateSupsiswithIntegratable: "تمرير معلومات الدردشة بين supsis و {integratable} بسهولة.",
            installationOK: "المثبتة",
            dayTime: "ساعة",
            weekDay: "يوم من الأسبوع",
            spendTimePage: "قضيت الوقت على الصفحة",
            spendTimeSite: "قضيت الوقت في الموقع",
            pageUrl: "رابط الصفحة",
            pageTitle: "عنوان الصفحة",
            equal: "متساوي",
            not_equal: "غير متساوي",
            less_than: "أقل من",
            greater_than: "أكثر من",
            less_than_or_equal: "اصغر من او يساوي",
            greater_than_or_equal: "أكبر من أو يساوي",
            visitorName: "اسم الزائر",
            seconds10: "10 ثواني",
            seconds30: "30 ثانية",
            minute1: "1 دقيقة",
            minutes5: "5 دقائق",
            minutes10: "10 دقائق",
            minutes30: "30 دقيقة",
            hour1: "1 ساعة",
            hours2: "ساعاتين",
            hours4: "4 ساعات",
            hours8: "8 ساعات",
            hours12: "12 ساعة",
            hours24: "24 ساعة",
            maxCondition: "كحد أقصى",
            doYouWishToDeleteTrigger: "هل ترغب في حذف الزناد",
            contains: "يتضمن",
            not_contains: "لا يحتوي",
            chatLanguage: "لغة الدردشة",
            translating: "جار الترجمة",
            buyWhatsapp: "شراء تكامل WhatsApp",
            liveSupportStartingWait: "بدء الدعم المباشر ، يرجى الانتظار",
            noConnection: "لا يوجد اتصال!",
            integrations: "التكامل",
            refundInvoiceSure: "هل أنت متأكد من أنك تريد إعادة الفاتورة؟",
            invoiceMarkedAsPaidSuccess: "تم وضع علامة على الفاتورة بنجاح",
            invoiceMarkedAsPaidError: "خطأ ، لم يتم وضع علامة على الفاتورة",
            deleteConfirm: "هل تريد حذف هذا {object}؟",
            markPaidConfirm: "هل أنت متأكد من مارك مثل هذه الفاتورة؟",
            addLink: "وصلة",
            startChatDesc: "ابدأ المحادثة",
            selectStep: "حدد خطوة:",
            addGOTO: "اذهب إلى",
            sendFastLink: "إرسال رابط سريع",
            or: "أو",
            allTags: "جميع العلامات",
            showDetail: "أظهر تفاصيل",
            hideDetail: "إخفاء التفاصيل",
            weLlSendPhone: "سنرسل إلى هاتفك",
            weLlSendEmail: "سنرسل إلى بريدك الإلكتروني",
            linkSentToPhone: "تم إرسال الرابط كرسائل نصية",
            offerlinkSendToPhone: "سنرسل لك رابط تنزيل تطبيقنا عبر الرسائل القصيرة.",
            offerlinkSendToMail: "سنرسل لك رابط تنزيل تطبيقنا عبر البريد الإلكتروني.",
            theEmail: "بريدي الإلكتروني المسجل",
            differentEmail: "بريد إلكتروني آخر مختلف",
            linkSentToMailBox: "تم إرسال الرابط إلى Adress بريدك",
            errorOccurred: "حدث خطأ !",
            clickStoreIcon: "يمكنك الوصول إلى تطبيق الهاتف المحمول من خلال النقر على الرمز المناسب لهاتفك.",
            meetWithSupsis: "هل ترغب في مقابلة تطبيق Supsis Mobile الخاص بنا؟",
            downloadMobileApps: "قم بتنزيل تطبيق الجوال",
            getApps: "احصل على التطبيقات",
            info: "معلومة",
            conversationHistory: "تاريخ المحادثة",
            planInfoHeader: "تخطيط المعلومات",
            planInformation: "خطتك هي {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} Free Agent)",
            creditAvailable: "ائتمان وكيلك المتاح في خطتك:",
            upDownGradePlan: "إذا كنت ترغب في الترقية/خفض خطتك ، من فضلك",
            click: "انقر",
            autoStartChat: "بداية الدردشة التلقائية",
            bubbleColor: "لون فقاعة الدردشة",
            openFolder: "افتح المجلد",
            preDefined: "موضوعات",
            customIcon: "تثبيت من جهاز الكمبيوتر الخاص بك",
            theme: "سمة",
            themeSettings: "إعدادات الموضوع",
            chatThemeSettings: "إعدادات موضوع الدردشة",
            bubbleSettings: "إعدادات فقاعة الدردشة",
            inputHeightOfBubble: "حجم الفقاعة",
            inputPixelsOfChatBubble: "انقر لتحرير مسافات فقاعة الدردشة إلى الحواف",
            modalTitleIsMarginAsPixelInfo: "مسافات فقاعة الدردشة إلى الحواف:",
            inputPxOfXaxis: "الموقف الأفقي",
            inputPxOfYaxis: "الوضع الرأسي",
            inputPxOfMobileXaxis: "(موبيل) الموقف الأفقي",
            inputPxOfMobileYaxis: "(موبيل) الموقف الرأسي",
            animations: "الرسوم المتحركة",
            preferredAnimation: "الرسوم المتحركة المفضلة",
            selectAnAnimation: "حدد الرسوم المتحركة",
            inputOfBubbleMessage: " {contentOfChatBubble}\n{ أضف محتوى إلى فقاعات الدردشة الضخمة",
            showChatBubbleOnlyLoggedUserToolTip: "إنه الإعداد لإخفاء فقاعة الدردشة بناءً على حالة تسجيل الدخول.",
            showChatBubbleOnlyLoggedUser: "أظهر فقاعة لتسجيلها فقط في المستخدم. (Ideasoft)",
            helloDoUNeedHelp: "مرحبا هل تحتاج إلى مساعدة؟",
            bubbleIcon: "صورة فقاعة الدردشة",
            overrideMargins: "تخصيص الهوامش",
            autoHideBubble: "إخفاء فقاعة الدردشة",
            vtippyAutoHideBubble: "يخفيون فقاعة الدردشة عندما يكون الوكلاء في وضع عدم الاتصال",
            hideBubble: "تعطيل فقاعة الدردشة",
            vtippyHideBubble: "قم بإيقاف فقاعة الدردشة.",
            overrideMobileMargin: "تخصيص الهوامش للجوال",
            vtippyMobileMargin: "تخصيص الهوامش للجوال",
            isFabsActive: "إظهار زر الإجراء العائم",
            isAlwaysActive: "القائمة مفتوحة دائمًا",
            isAlwaysActiveDesc: "هل ترغب في أن تظل قائمة فقاعة الدردشة مفتوحة دائمًا في عرض الويب؟",
            bubbleOpenableMenu: "دردشة فقاعة المنسدلة",
            vtippyIsFabsActive: "إعداد زر العرض / إخفاء الإجراء العائم",
            vtippyIsFabsAsIcon: "إنه إعداد ما إذا كانت الرموز ستظهر في القائمة المنسدلة.",
            isFabsAsIcon: "عرض أيقونات القائمة.",
            setMarginAsPixel: "تعيين بكسل",
            returnDefaultMargins: "إعدادات الهامش الافتراضية",
            deleteSite: 'هل تريد حذف الموقع "{siteName}"؟',
            deleteThisSite: "حذف الموقع",
            assetOversizeWithExt: "يجب أن يكون حجم الملف أقل من 10 ميغابايت وفي تنسيق JPG.",
            closeChat: "نهاية المراسلة",
            ticket: "تذكرة",
            formStep: "خطوة الشكل",
            menuStep: "خطوة القائمة",
            contentStep: "خطوة المحتوى",
            menuTitle: "عنوان القائمة",
            messageContent: "محتوى الرسالة",
            goToLive: "نقل إلى التمثيلي",
            prevStep: "العودة إلى الخطوة السابقة",
            button: "زر",
            addImage: "صورة",
            addText: "نص",
            stepTitle: "عنوان الخطوة",
            addTicket: "تذكرة",
            formDescription: "سؤال",
            addInput: "سؤال",
            addRandomText: "نص عشوائي",
            calendarPassedTimeMinSec: "{min} دقيقة {sec} الثانية {name}",
            calendarPassedTimeSec: "{ساعة} ساعة {min} دقيقة {sec} الثانية {name}",
            updateUserName: "تحديث اسم المستخدم",
            forgotPassword: "هل نسيت كلمة السر",
            osrFromMessageSaved: "تم حفظ الرسالة دون اتصال.",
            requiredField: "هذه الخانة مطلوبه.",
            nightModeOn: "وضع الليل على",
            catalogMenu: "قائمة طعام",
            catalogContent: "محتوى",
            all: "الجميع",
            allDepartments: "جميع الإدارات",
            preferredLanguage: "اللغة المفضلة",
            kmkAutoDepartmentBind: "اكتشاف kmk auto deparment",
            kmkAutoDepartmentBindDesc: "بحث بائع على مواقع عملاء KMK وقم بتعيين صفحة تسجيل الدخول كقسم",
            visitorEmailUpdated: "تم تحديث البريد الإلكتروني للزائر",
            visitorEmailIsNotValid: "البريد الإلكتروني للزوار غير صالح",
            visitorNameUpdated: "اسم الزائر تم تحديثه",
            clickToEdit: "إضغط للتعديل",
            addEmail: "+ إضافة بريد إلكتروني",
            addFullname: "+ إضافة fullname",
            partner: "المرجع؟",
            isIntegrated: "اندماج؟",
            agentCount: "عدد الوكيل",
            closePreviewColors: "إغلاق معاينة الموضوع",
            previewColors: "معاينة موضوع مفتوح",
            videoCalls: "مكالمات فيديو",
            filterLost: "الدردشات المفقودة",
            vtipyCustomLogin: "يمكنك تخصيص المعلومات التي سيتم طلبها في نموذج تسجيل الدخول عندما يتصل زوارك بالنظام.",
            vtipyLoginlessChat: "سيتم إخفاء نموذج تسجيل الدخول للزوار. يمكن للزائر الاتصال بالدردشة مباشرة.",
            loginlessChat: "نموذج تسجيل الدخول للزوار",
            imageUrl: "رابط الصورة",
            replied: "رد",
            solved: "تم حلها",
            openImage: "صورة مفتوحة",
            writeFeedback: "يمكنك كتابة ملاحظاتك حول supsis هنا.",
            feedbackFailed: "حدث خطأ أثناء إرسال الملاحظات.",
            feedbackSuccessful: "ردود الفعل تقديم ناجحة.",
            sendFeedback: "ارسل رأيك",
            errorReport: "يمكنك أن تعطينا ملاحظات حول المشكلات التي تواجهها حول supsis.",
            sendErrorFeedBack: "أعطنا ملاحظات حول القضية التي تواجهها.",
            successImgUpload: "تم تحميل صورتك بنجاح.",
            successImgDelete: "تم حذف الصورة بنجاح.",
            errorImgUpload: "حدث خطأ أثناء تحميل صورتك.",
            errorImgDelete: "حدث خطأ أثناء حذف الصورة",
            chatBotEndStatics: "معدل نجاح محادثة chatbot",
            videoCallDist: "توزيع مكالمات الفيديو",
            departmentInfo: "معلومات القسم",
            infoAboutDepartment: "قدم معلومات موجزة عن القسم",
            deleteDepartmentQuestion: "هل تريد حقًا حذف هذا القسم؟",
            departmentDeleted: "حذف القسم",
            departmentTitle: "لقب القسم",
            updateDepartmentForm: "نموذج تحديث القسم",
            newDepartmentForm: "نموذج قسم جديد",
            department: "قسم",
            newDepartment: "قسم جديد",
            departmentSaved: "أنقذ القسم",
            sameDepartment: "هناك قسم بنفس الاسم",
            sameValue: "هناك قيمة بنفس الاسم!",
            sameTag: "هناك وسم بهذا الاسم!",
            departments: "الإدارات",
            chatTimingSettings: "إعدادات توقيت الدردشة",
            assetOversize: "يجب ألا يتجاوز حجم الملف الذي تريد إرساله 2 ميجابايت.",
            assetOversizeMB: "لا يجب أن يتجاوز حجم الملف الذي تريد إرساله {mb} ميجابايت.",
            messageDeleted: "تم حذف هذه الرسالة",
            filterLostChat: "تصفية الدردشات المفقودة",
            filterClosedByAgent: "مرشح مغلق من قبل الوكيل",
            filterVideoCall: "مرشح مكالمة الفيديو",
            notificationText: "يحتاج Supsis إلى إذن لـ",
            notificationTitle: "الإخطارات معطلة",
            deniedText: "إن إشعاراتك مغلقة ، فأنت بحاجة إلى تشغيل إشعاراتك حتى لا تفوتك عملائك.",
            deniedTitle: "انقر لفتح الإخطارات الخاصة بك!",
            deniedHeader: "حتى لا تفوت عملائك ، تحتاج إلى تشغيل إشعاراتك!",
            showNotificationGuide: "انقر للاطلاع على التفاصيل",
            howToEnableNotification: "كيف يمكنني تمكين الإخطارات",
            notificationOK: "نعم",
            notificationUnderstood: "تم فهمه!",
            notificationCancel: "يلغي",
            howToEnableNotificationInstruction1: "انقر على أيقونة القفل في شريط العناوين للمتصفح",
            howToEnableNotificationInstruction2: 'إذا تم تعطيل "الإخطارات" في قسم الأذونات ، فقم بتمكينه',
            howToEnableNotificationInstruction3: 'إذا لم تظهر "الإشعارات" في قسم الأذونات ، فانقر فوق "إعدادات الموقع',
            howToEnableNotificationInstruction4: 'قم بتشغيل إذن "الإخطارات" من قسم "الأذونات" في صفحة إعدادات الموقع',
            checkPaymentMethod: "يرجى التحقق من طريقة الدفع الخاصة بك",
            pushNotificationEnabled: "تم تمكين إشعار الدفع الرائع",
            pushNotificationDenied: "لقد أنكرت إذن الإخطار",
            suspendedMessage: "تم تعليق حسابك",
            enableNotification: "تمكين إخطارات سطح المكتب.",
            languageSettings: "لغة مختارة",
            problemsSound:
                'إذا كانت لديك مشاكل في الإشعارات ، فيمكنك النقر فوق قفل صورة من مربع بحث المتصفح (الموضح في الصورة) انقر فوق "إعدادات الموقع" وتغيير "الصوت" للسماح',
            betweenRepresentative: "هناك رسالة جديدة من ممثل",
            desktopNotifications: "إخطارات سطح المكتب",
            notificationEnabled: "يتم تمكين إخطارات سطح المكتب Supsis.",
            newMessageAlert: "لديك رسالة جديدة.",
            notificationDisable: "يمكنك تعطيل الإخطار من الإعدادات التمثيلية",
            newConversationAlert: "لديك زائر جديد.",
            chatBot: "روبوت الدردشة",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "أرشيف",
            chatbotChatCount: "روبوت الدردشة",
            changeTitle: "غير العنوان",
            changeVisitorTitle: "تغيير عنوان الزائر",
            catalog: "عنوان الكتالوج",
            openTheCatalog: "كتالوج مفتوح",
            catalogNotOpen: "تم تعطيل ميزة الكتالوج. يمكنك تشغيل ميزة الكتالوج لدعم عملائك بمحتوى مستعد مسبقًا.",
            showCatalogCategories: "اضبط ما إذا كانت قائمة الكتالوج ستظهر على فقاعة الدردشة",
            showChatBot: "اضبط ما إذا كان chatbot سيظهر على فقاعة الدردشة",
            openCatalog: "الرؤية كتالوج",
            unreadMessages: "رسائل غير مقروءة",
            personalFirstMsg: "الوكيل المتوسط ​​وقت الاستجابة (SEC)",
            personalRating: "نقاط الموظفين AVG",
            soundSettings: "إعدادات الإشعار",
            newPrivateMessage: "رسالة خاصة",
            addNewGroup: "إنشاء مجموعة جديدة",
            newMessage: "رسالة جديدة",
            newConversation: "دردشة جديدة",
            newVisitor: "زائر جديد",
            chatPosition: "موقف الدردشة",
            bottomLeftCorner: "الزاوية اليسرى السفلية",
            leftDocked: "رست على اليسار",
            bottomRightCorner: "الزاوية اليمنى السفلى",
            rightDocked: "رست الحق",
            chatPositionSelect: "اختر الموقف",
            teamChatGroup: "رسائل المجموعة",
            teamChatDepartment: "رسائل القسم",
            teamChatTeam: "رسائل الفريق",
            teamChatDm: "رسائل البريد المباشر",
            bottomLeft: "أسفل اليسار",
            left: "غادر",
            bottomRight: "أسفل اليمين",
            right: "يمين",
            mailorname: "البريد الإلكتروني أو الاسم",
            fieldName: "الاسم الرئيسي",
            value: "قيمة",
            addSetting: "إضافة إعدادات",
            globalSettings: "الاعدادات العامة",
            breaksByTime: "عداد الكسر حسب الوقت",
            clPlaceholder: "الاسم الذي سيظهر في نموذج العميل",
            target: "تحميل عنوان اختبار",
            duration: "مدة اختبار التحميل (ثانية)",
            arrivalCount: "عدد الدردشة",
            bootMaxLife: "دردشة أقصى وقت الحياة (SEC)",
            startLoadTest: "ابدأ اختبار التحميل",
            noClusterInstanceFound: "لا يوجد خادم",
            stopLoadTest: "توقف اختبار التحميل",
            integrationDesc: "فقط أضف رمز السطر الواحد أدناه إلى موقعك.",
            integrationDemoCode: "رمز تجريبي للتكامل البسيط",
            integrationWindow: "كيف يمكنني الاندماج في موقعي؟",
            notIntegrated: "اندماج",
            help: "يساعد",
            notIntegratedDesc:
                "لاحظنا أنك لم تضيف نظام الدردشة إلى موقعك. عندما تقوم بدمجه في موقعك وابدأ الدردشة الأولى ، ستقوم بإكمال التكامل. انقر للحصول على البرنامج النصي للتكامل",
            backToLogin: "ارجع إلى شاشة تسجيل الدخول",
            passwordlessLoginUnsuccessful: "تسجيل الدخول غير ناجح. يمكن انتهاء صلاحية أو استخدامها من قبل",
            passwordlessLogin: "تسجيل الدخول بدون كلمة مرور",
            loginWithEmail: "تسجيل الدخول مع البريد الإلكتروني",
            loginWithPassword: "تسجيل الدخول مع كلمة المرور",
            enteringPasswordless: "تسجيل الدخول بدون كلمة مرور ...",
            toMainPath: "إعادة التوجيه إلى الصفحة الرئيسية",
            userRoleChanged: "تغيرت أذوناتك. سيتم إعادة توجيهك إلى الصفحة الرئيسية.",
            passwordChangeSuccess: "تغيرت كلمة المرور الخاصة بك بنجاح",
            feedback: "إظهار ردود الفعل",
            showFeedbackHistory: "إظهار الرسائل التي تم إرسال ملاحظات",
            newSelfServiceSite: "موقع خدمة الذات الجديد",
            subdomain: "نطاق فرعي",
            rootUserEmail: "بريد إلكتروني",
            rootUserName: "اسم",
            newVersion: "نسخة جديدة متاحة",
            closeLiveSupport: "وثيق الدعم المباشر",
            newVersionShort: "نسخة جديدة",
            bannedWordRestrict: "حظر الكلمة المحظورة",
            ticketShow: "السماح للعملاء بإنشاء تذاكر",
            ticketShowDesc: "تمكين خيار إنشاء التذاكر في قائمة الدردشة",
            autoLoadIframe: "حركة المرور الحية",
            autoLoadIframeDesc: "تحميل التلقائي iframe ، مرر جميع حركة الزوار",
            bannedWordRestrictDesc:
                "عندما يتم تشغيل حظر الكلمة المحظورة ، يتم منع الممثلين من كتابة الكلمات المحظورة المحددة في النظام للزوار.",
            agentDown: "وكيل أسفل",
            delayChat: "دردشة تأخر",
            tableSettingTippy: "يمكنك تغيير المعلومات التي ستظهر في الجدول.",
            tableSettings: "إعدادات الجدول",
            tableSettingsInfo: "يمكنك تغيير المعلومات التي ستظهر في الجدول. يمكنك تحديد عمود 7 على الأكثر",
            privateParametry: "معلمات المستخدم المخصصة",
            systemOperetor: "معلومات النظام",
            cityAndDistrict: "مقاطعه المدينه",
            general: "عام",
            availability: "توافر",
            home: "بيت",
            successful: "نجح",
            forgetPasswordSent:
                "تم إرسال البريد الإلكتروني لإعادة تعيين البريد الإلكتروني ، تحقق من صندوق الوارد الخاص بك",
            saturday: "السبت",
            friday: "جمعة",
            thursday: "يوم الخميس",
            wednesday: "الأربعاء",
            tuesday: "يوم الثلاثاء",
            monday: "الاثنين",
            sunday: "الأحد",
            download: "تحميل الملف",
            calendarPassedTimeHour: "{name} لـ {hour} ساعة",
            calendarPassedTime: "{name} لـ {hour} ساعة {min} دقيقة",
            calendarPassedTimeMin: "{name} لـ {value} min",
            workScheduleOneDay: "جدول العمل {name} على {sDate}",
            workSchedule: "جدول العمل {name} بين {sDate} - {eDate}",
            calendar: "تقويم",
            noRating: "لا يوجد تصنيف للعرض",
            rateDist: "توزيع الأسعار",
            distConversation: "توزيع الكلام من قبل الممثلين",
            distributionConversa: "توزيع النقاط",
            distChatbotAgent: "قنوات الاتصال",
            distAgent: "وكيل شات بوت",
            distFugitive: "الكلام الفائت والكلام المستلم",
            distLive: "دردشة مباشرة",
            distChatbot: "الشات بوت",
            distComplex: "دردشة مباشرة & الشات بوت",
            distHandled: "أجاب الدردشة",
            distMissed: "دردشة غير مجاب عنها",
            distWeb: "موقع إلكتروني",
            distWhatsapp: "واتس اب",
            distTelegram: "برقية",
            distInstagram: "الانستغرام",
            totalWhatsappChatCount: "عدد دردشة Whatsapp",
            statsByTime: "عدد الدردشة حسب الوقت",
            selectRep: "حدد ممثل",
            allRepresentatives: "جميع الممثلين",
            avgRating: "درجة التقييم ({point}) ({count} تصنيف)",
            avgFirstMessageTime: "متوسط وقت الاستجابة",
            totalBreakTime: "وقت كسر النظام",
            totalBreakNum: "عداد الكسر",
            averageConTime: "متوسط وقت المحادثة",
            multiWpReportTitle: "رقم محادثة واتس اب متعدد",
            multiWpReport: "عدد محادثات الواتساب المتعددة",
            multiWpReportExplanation: "يمكنك رؤية مقدار الدردشة لقنوات Whatsapp المتعددة الخاصة بك.",
            longestConTime: "أطول وقت محادثة",
            shortestConTime: "أقصر وقت محادثة",
            refresh: "ينعش",
            waitingReply: "الرسائل المعلقة",
            organizationName: "اسم المنظمة",
            companySlogan: "الاسم الطويل للمنظمة",
            messageSentErr: "الرسالة لا ترسل ، حاول مرة أخرى.",
            messageSent: "تم الارسال.",
            openPrivateChat: "فتح الدردشة التمثيلية",
            escKey: "يخفي محادثة نشطة",
            archiveChatKey: "يسمح لك بالانضمام إلى الدردشة في أسفل صفحة الأرشيف.",
            chatCopilot: "يقوم بتشغيل برنامج Chat CoPilot",
            privateChat: "لوحة محادثة بين العوامل",
            multiModeAlertDesc: 'Supsis مفتوح في نافذة أخرى. انقر فوق "استخدم هنا" لاستخدام supsis في هذه النافذة.',
            useHereText: "استخدم هنا",
            brandVisibility: "تسمية العلامة التجارية Supsis تظهر على فقاعة الدردشة",
            focusInput: "حقل إدخال الدردشة النشطة للمؤشر",
            send: "يرسل",
            notYet: "ليس بعد",
            sending: "إرسال",
            onlyRepresentative: "لا يمكن أن يرى رسالتك إلا من قبل الممثلين",
            yourMessage: "رسالتك",
            liveFabListDescription: "الدعم المباشر",
            messengerIntegrationDesc: "تحدث مع عملائك عبر صفحة الفيسبوك، وأرسل رسائل آلية باستخدام الدردشة الآلية.",
            checkDepartmentToAgent: "التحقق من القسم للوكيل عبر الإنترنت",
            ifAllOfflineStory: "القصة لتوجيه إذا كان الجميع غير متصلين",
            AssignMessagesToAgents: "تعيين جميع الرسائل للوكلاء",
            firstChatbotAndAssign: "يُجيب Chatbot أولاً ثم يُسند إلى وكيل",
            hybridAssign:
                "يتحقق النظام من القسم لمعرفة ما إذا كان هناك وكيل عبر الإنترنت ، وإذا لم يكن هناك وكيل عبر الإنترنت ، فإنه يعينه إلى الشاتبوت.",
            ticketFabListDescription: "تذكرة",
            whatsappFabListDescription: "ال WhatsApp",
            phoneFabListDescription: "هاتف",
            emailFabListDescription: "بريد إلكتروني",
            facebookFabListDescription: "فيسبوك",
            twitterFabListDescription: "تويتر",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "موقع YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "اكتب رابط قناة {channelLink} في هذا الحقل.",
            typeYourAccountLink: "اكتب رابط حساب {accountLink} في هذا الحقل.",
            typeYourMessage: "اكتب رسالتك هنا",
            typeYourMessageMail:
                "سيتم إرسال الرسالة التي تم إدخالها في هذا الحقل من قبل العميل إلى عنوان البريد أعلاه كرسالة أولى.",
            typeYourMessageDesc:
                "سيتم إرسال الرسالة التي تم إدخالها في هذا الحقل من قبل العميل إلى رقم الهاتف أعلاه كرسالة أولى.",
            sendNumber: "رقم الهاتف لإرسال الرسالة إلى: {path}",
            callNumber: "رقم الهاتف لعميلك للاتصال: {phoneNumber}",
            numberIsNotCorrect: "تم إدخال الرقم المفقود !!",
            emailIsNotCorrect: "البريد الإلكتروني غير صحيح!",
            selectFab: "حدد FAB",
            notValid: "يمكنك فقط إدخال الحروف. (حرف واحد) .e ، d ، f ، z ، a ، x ، c ، v ، w ، t ، n الحروف غير صالحة",
            forMacUsers: "يمكن لمستخدمي MAC استخدام اختصار التحكم (⌃)",
            basePriceValue: "السعر الأساسي",
            basePriceDiscount: "تخفيض",
            basePriceCurrency: "عملة",
            customerDBEnabled: "اختيار قاعدة البيانات: استخدم خادم قاعدة بيانات العملاء",
            customerDBDisabled: "اختيار قاعدة البيانات: استخدم SUPSIS Server",
            mongoConnectionString: "اتصال Mongo",
            whatsappBasePriceValue: "سعر قاعدة WhatsApp",
            whatsappPlusBasePriceValue: "WhatsApp Plus سعر الأساس",
            instagramBasePriceValue: "سعر قاعدة Instagram",
            instagramPlusBasePriceValue: "السعر الأساسي Instagram Plus",
            clientAddress: "عنوان العميل",
            customerClientAddress: "عنوان عميل العميل",
            apiAddress: "عنوان API",
            socketAddress: "عنوان المقبس",
            backendAddress: "عنوان الخلفية",
            panelLogoUrl: "عنوان شعار لوحة URL",
            panelCustomCssUrl: "لوحة عنوان URL المخصص CSS",
            customerLogoUrl: "عنوان URL شعار العميل",
            customerCssUrl: "عميل CSS URL",
            siteAlias: "الملقب الموقع",
            language: "لغة",
            features: "سمات",
            interactionPopularity: "شيوع التفاعلات",
            interactionCount: "عدد التفاعل",
            uniqueUserCount: "عدد المستخدم الفريد",
            allUserPercentage: "(٪) النسبة المئوية لكل المستخدمين",
            represantativeSettings: "الإعدادات التمثيلية",
            documentTitle: "نموذج مستند Supsis",
            supsisDocument: "وثيقة Supsis",
            ApiDoc: "وثائق الواجهة البرمجية للتطبيق",
            chatBalloonTehemeSettings: "إعدادات بالون وموضوع الدردشة",
            customLoginFormSettingsTitle: "تخصيص نموذج تسجيل الدخول للزوار",
            addNewField: "أضف حقلًا جديدًا",
            editField: "تحرير الحقل",
            typeHere: "اكتب المحتوى هنا!",
            pco: "cur",
            perPage: "/صفحة",
            perPageInFilter: "قطعة",
            noUserInfoFound: "لم يتم العثور على معلومات المستخدم",
            startFilter: "بدء مرشح",
            showMyChats: "أظهر الدردشات الخاصة بي",
            showOnlineAgents: "إظهار الوكلاء عبر الإنترنت فقط",
            showWaitingChats: "عرض الدردشات الانتظار",
            addNewStatus: "أضف الحالة",
            newTitleContent: "عنوان جديد",
            newCTRLContent: "محتوى CTRL جديد",
            newALTContent: "محتوى ALT جديد",
            newTABContent: "محتوى علامة تبويب جديدة",
            roleName: "اسم الدور",
            error: "خطأ",
            contentTitle: "عنوان المحتوى",
            contentType: "نوع المحتوى",
            cannotMoveFullParent: "لا يمكن تحريك هذا العنصر",
            newSiteForm: "نموذج تسجيل موقع جديد",
            updateSiteForm: "نموذج تحديث الموقع",
            newBannedWordForm: "نموذج تسجيل الكلمات المحظور الجديد",
            updateBannedWordForm: "نموذج تحديث الكلمات المحظور",
            newWelcomeMessageForm: "نموذج تسجيل رسالة ترحيب جديد",
            updateWelcomeMessageForm: "نموذج تحديث رسالة النظام",
            newDefaultContentForm: "نموذج تسجيل المحتوى الافتراضي الجديد",
            updateDefaultContentForm: "نموذج تحديث المحتوى الافتراضي",
            newSubjectForm: "نموذج تسجيل الموضوع الجديد",
            updateSubjectForm: "نموذج تحديث الموضوع",
            showChatColorMeaning: "ألوان الدردشة",
            showIntro: "عرض مقدمة",
            options: "خيارات",
            resetPassword: "إعادة تعيين كلمة المرور",
            audioLevel: "حجم تنبيه الصوت",
            privateChatNotificationSound: "صوت الإشعار",
            continue: "يكمل",
            newRoleForm: "نموذج تسجيل الدور الجديد",
            updateRoleForm: "نموذج تحديث الدور",
            newRolePlaceHolder: "انقر لدور جديد",
            newUserForm: "نموذج تسجيل مستخدم جديد",
            updateUserForm: "نموذج تحديث المستخدم",
            changeOSRForm: "رسالة تغيير في وضع عدم الاتصال",
            tooltipOSRForm: "يمكنك تغيير الرسالة دون اتصال.",
            newOSRForm: "نموذج الدعم في وضع عدم الاتصال",
            newOSRMessages: "أضف رسالة غير متصلة بالإنترنت",
            updateOSRForm: "نموذج التحديث في وضع عدم الاتصال",
            osrTitle: "عنوان",
            osrTitleDescription: "يمكنك إضافة عنوان نموذج الدعم في وضع عدم الاتصال",
            osrContent: "محتوى",
            osrContentDescription: "يمكنك إضافة محتوى نموذج الدعم في وضع عدم الاتصال",
            hello: "مرحبا بالعالم",
            date: "تاريخ",
            startDate: "تاريخ البدء",
            finish: "ينهي",
            start: "يبدأ",
            search: "يبحث",
            endDate: "تاريخ الانتهاء",
            representative: "مندوب",
            representative_: "ممثل",
            star: "نجمة",
            filter: "منقي",
            reset: "إعادة ضبط",
            dailyChatList: "قائمة الدردشة اليومية",
            dailyChatDuration: "مدة الدردشة اليومية",
            chatDuration: "مدة الدردشة",
            dailyChatGraph: "الرسم البياني للدردشة اليومية",
            ok: "نعم",
            cancel: "يلغي",
            chatCount: "عدد الدردشة",
            shortest: "أقصر",
            longest: "أطول",
            average: "متوسط",
            count: "عدد",
            averagePoint: "متوسط ​​النقطة",
            pointDist: "توزيع النقطة",
            point: "نقطة",
            filters: "المرشحات",
            totalCustomer: "إجمالي العميل",
            avResponseTime: "متوسط ​​وقت الاستجابة",
            breakDuration: "مدة كسر",
            breakCount: "عداد الكسر",
            lastLoginPlatform: "منصة",
            active: "نشيط",
            passive: "سلبي",
            userForm: "المستخدم",
            sender: "المُرسِل",
            profile: "حساب تعريفي",
            name: "اسم",
            number: "رقم",
            username: "اسم المستخدم",
            email: "بريد إلكتروني",
            password: "كلمة المرور",
            oldPassword: "كلمة المرور القديمة",
            newPassword: "كلمة المرور الجديدة",
            passwordAtLeast: "كلمة المرور (على الأقل {num})",
            passwordRepeat: "اعد كلمة السر",
            changePassword: "تغيير كلمة المرور",
            status: "حالة",
            enableState: "نشيط؟",
            douYouWishToDeleteUser: "دو ترغب في حذف هذا المستخدم؟",
            userDeleted: "تم حذف المستخدم",
            userSaved: "تم حفظ المستخدم.",
            oldPasswordError: "كلمة المرور القديمة غير صحيحة ، يرجى التحقق.",
            chooseAnOption: "الرجاء تحديد صوت الإخطار.",
            userVolumeUpdated: "تحديث إعدادات الصوت.",
            save: "يحفظ",
            update: "تحديث",
            addNewMenu: "أضف قائمة جديدة",
            addNewContent: "أضف محتوى جديد",
            pleaseTitleEnter: "الرجاء العنوان إدخال",
            like: "يحب",
            disLike: "لم يعجبنى",
            users: "المستخدمون",
            visitor: "الزائرين",
            allContacts: "كل الاتصالات",
            allUsers: "جميع الممثلين",
            allSites: "جميع المجالات",
            newUser: "مستخدم جديد",
            noNewUser: "لا يوجد مستخدم بعد.",
            noNewAdminUser: "لا يوجد مستخدم مسؤول حتى الآن.",
            noRoleFound: "لا يوجد دور حتى الآن.",
            noBannedWordFound: "لا توجد كلمة محظورة حتى الآن.",
            noWelcomeMessageFound: "لا توجد رسالة نظام حتى الآن.",
            noSubjectFound: "لا يوجد موضوع حتى الآن.",
            noVisitorFound: "لا يوجد زائر.",
            noContactFound: "لا يوجد اتصال.",
            sendResponse: "اكتب رد",
            delete: "يمسح",
            noLiveSupportFound: "لا يوجد زائر متصل بالدعم المباشر",
            noLiveSupportFoundWithDepartment: "لا يوجد خطاب ينتمي إلى القسم",
            duplicate: "ينسخ",
            makeDefault: "جعل الافتراضي",
            checkMore: "تحقق أكثر",
            useReadyTemplates: "استخدم قوالب جاهزة",
            noRePresentativeFound: "لا يوجد ممثل",
            noBannedVisitorFound: "لا يوجد زائر محظور حتى الآن.",
            removeBanDescription: "إزالة الحظر",
            editThisItem: "قم بتحديث هذا العنصر",
            removeThisItem: "أزل هذا البند",
            role: "دور",
            autoChatAssignLimit: "محادثة تلقائية تعيين الحد",
            chatAssignInfo: "-1 = افتراضي النظام ، 0 = لا يوجد تعيين ،> 0 = تعيين كقيمة معينة.",
            relatedDepartments: "الإدارات ذات الصلة",
            subjectInfo: "إذا لم يكن هناك موضوع محدد ، يُسمح بجميع الموضوعات.",
            archive: "أرشيف",
            offlineSupportRequests: "الدعم في وضع عدم الاتصال",
            first: "أولاً",
            last: "آخر",
            query: "بدء البحث",
            clean: "ينظف",
            loading: "تحميل",
            loadMore: "تحميل المزيد",
            noMessage: "ليست أي رسالة",
            selectChat: "اختر الدردشة",
            noMessageInChat: "لا توجد رسالة في هذه الدردشة",
            noMediaToShow: "لا توجد وسائط لعرضها",
            firstSeen: "ظهور أول مرة",
            userInfo: "معلومات المستخدم",
            chatId: "معرف الدردشة",
            visitorId: "معرف الزائر",
            visitingPage: "صفحة زيارة",
            osAndBrowser: "نظام التشغيل والمتصفح",
            customerClientVersion: "إصدار عميل العميل",
            visitorFeedback: "ردود الفعل الزائر",
            notes: "ملاحظات",
            nameSurname: "اسم اللقب",
            chats: "الدردشات",
            bannedVisitors: "الزوار المحظورون",
            country: "دولة",
            city: "مدينة",
            cityDistrict: "مقاطعه المدينه",
            browser: "متصفح",
            os: "نظام التشغيل",
            ipAddress: "عنوان IP",
            connectionDate: "تاريخ الاتصال",
            transaction: "عملية",
            banRemoved: "حظر إزالة.",
            bannedWords: "الكلمات المحظورة",
            newBannedWord: "كلمة محظورة جديدة",
            noBannedWord: "لا كلمة محظورة حتى الآن.",
            bannedWordForm: "نموذج العمل المحظور",
            word: "كلمة",
            bannedWordAndWordGroup: "مجموعة الكلمة / العمل المحظورة",
            doYouWishToDeleteBannedWord: "دو هل ترغب حقًا في حذف هذه الكلمة المحظورة؟",
            doYouWishToOfflineSupportRequest: "دو هل ترغب حقًا في حذف هذه الرسالة؟",
            bannedWordSaved: "الكلمة المحظورة المحفوظة",
            deletedSuccessfully: "حذف بنجاح",
            deleteErrorMsg: "خطأ: لم يتم حذفه ، حاول مرة أخرى",
            socketError: "خطأ في اتصال المقبس. الرجاء تحديث الصفحة وحاول مرة أخرى.",
            socketConnecting: "الاتصال بالخادم",
            offlineModeDescription: "النظام لأسفل ، لن يتمكن العملاء من الوصول إلى الدعم المباشر.",
            offlineModeSettingsDescription: "تحقق من ميزة الوضع غير المتصلة في قائمة الإعدادات.",
            offlineModeUser: "يجب أن يكون هناك ممثل واحد على الأقل عبر الإنترنت في النظام.",
            offlineModeMessage: "رسالة دون اتصال",
            offlineMode: "وضع غير متصل بالشبكة",
            adminCannotConnectSocket: "لا يمكن للمسؤول الاتصال بالمقبس.",
            liveSupport: "الدعم المباشر",
            siteVisitors: "زوار الموقع",
            visitors: "الزائرين",
            thoseConnectedToLiveSupport: "أولئك الذين يتصلون بدعم مباشر",
            visitorHistory: "تاريخ الزوار",
            visitorHistoryDescription: "يمكنك عرض وتحميل سجل دردشة الزائر.",
            privateMessage: "رسالة خاصة",
            addRepresentative: "إضافة ممثل",
            forwardRepresentative: "ممثل إلى الأمام",
            keyboardShortcuts: "اختصارات لوحة المفاتيح",
            chatColorMeanings: "معاني ألوان الدردشة",
            connLostCheckInternet: "الاتصال المفقود ، يرجى التحقق من اتصال الإنترنت الخاص بك.",
            wishToEndThisChat: "دو ترغب في إنهاء هذه الدردشة؟",
            defaultContents: "المحتوى الافتراضي",
            contents: "محتويات",
            newDefaultContent: "محتوى افتراضي جديد",
            title: "عنوان",
            shortcutChar: "الطابع الاختصار",
            pickOne: "إختر واحدة",
            writeSomething: "اكتب حرفًا (A-Z | 0-9)",
            letterSequence: "تسلسل الرسالة",
            exampleText: "مثال: SOC -> كرة القدم",
            anyChar: "أي شخصية",
            shorcutKey: "مفتاح الاختصار",
            content: "محتوى",
            shortcutName: "اسم الاختصار",
            type: "يكتب",
            shortcut: "الاختصار",
            defaultContentForm: "نموذج المحتوى الافتراضي",
            deleteContentQuestion: "هل ترغب حقًا في حذف هذا المحتوى الافتراضي؟",
            titleContentForm: "رأس المحتوى الجاهز",
            defaultContentDeleted: "المحتوى الافتراضي المحذوف",
            defaultContentSaved: "المحتوى الافتراضي المحفوظ.",
            contentMoved: "تحرك المحتوى.",
            yourEmail: "عنوان البريد الإلكتروني",
            yourName: "اسمك ولقبك",
            login: "تسجيل الدخول",
            lostPassword: "هل نسيت كلمة السر",
            multipleSession: "لقد وقعت في مكان آخر.",
            notAuthorizedToDisplayPage: "أنت غير مخول لرؤية هذه الصفحة!",
            permissions: "أذونات",
            newPermission: "إذن جديد",
            permissionForm: "شكل إذن",
            displayTitle: "عنوان العرض",
            key: "مفتاح",
            keyToUseInSystem: "القيمة الرئيسية للاستخدام في النظام",
            deletePermissionQuestion: "هل ترغب حقًا في حذف هذا الإذن؟",
            permissionDeleted: "تم حذف إذن.",
            permissionSaved: "إذن تم حفظه.",
            newRole: "دور جديد",
            selectARole: "حدد دورًا",
            yes: "نعم",
            no: "لا",
            fullAuth: "إذن كامل",
            roleDeleted: "دور تم حذفه.",
            roleSaved: "دور محفوظ.",
            roleForm: "شكل الدور",
            roles: "أدوار",
            settings: "إعدادات",
            selectTopic: "حدد قسم",
            autoCallTransfer: "نقل المكالمات التلقائية",
            customerTyping: "كتابة العملاء",
            typing: "الكتابة",
            agentTyping: "الكتابة التمثيلية",
            disconnectTime: "وقت إعادة الاتصال ماكس (ثانية)",
            tippyDissconnectTime: "عندما تكون الدردشة غير نشطة بعد عدد الثواني ستنتهي محادثة.",
            queueNumberVisibleFeature: "عرض رقم قائمة الانتظار للزائر",
            privateChatEnabled: "إظهار الدردشة بين الممثلين",
            delayedTalkTime: "وقت التأخير (ثانية)",
            employeeAverageChatCount: "متوسط ​​رقم الدردشة لمعدل دردشة الموظف",
            customerDownTimeWhenRepExit: "توقف العميل عندما يترك التمثيلي (SN.)",
            autoAssignLimit: "الحد الأقصى التلقائي التلقائي",
            wasted: "محادثة فقدت الوقت (ثانية)",
            settingFormWrong: "بيانات النموذج خاطئة ، حاول مرة أخرى بعد التحقق من ذلك",
            settingsSaved: "تم حفظ الإعدادات.",
            settingsCannotSaved: "لا يمكن حفظ الإعدادات",
            noAuthorization: "لا تخويل",
            warningBadInput: "يوصى بإدخال رقم بين 0 و 70.",
            warning: "تحذير!",
            warningBadInputMarginY: "تحذير من إدخال الهامش العمودي ⚠",
            warningBadInputMarginX: "تحذير من إدخال الهامش الأفقي ⚠",
            warningBadInputBubbleSize: "تحذير من إدخال فقاعة الدردشة ⚠",
            delayTime: "وقت التأخير (ثانية)",
            sites: "المواقع",
            newSite: "موقع جديد",
            noSiteYet: "لا يوجد موقع حتى الآن.",
            siteAddress: "عنوان الموقع",
            turnBack: "رجوع",
            customerRepLimit: "حد ممثل العميل",
            siteSaved: "تم حفظ الموقع.",
            siteSaveError: "حدث خطأ أثناء إنشاء الموقع",
            subjects: "المواضيع",
            newSubject: "موضوع جديد",
            noSubject: "لا موضوع حتى الآن.",
            subject: "موضوع",
            subjectTitle: "عنوان الموضوع",
            description: "وصف",
            infoAboutSubject: "معلومات حول الموضوع",
            deleteSubjectQuestion: "هل ترغب حقًا في حذف هذا الموضوع؟",
            subjectDeleted: "موضوع تم حذفه.",
            subjectSaved: "موضوع حفظ.",
            welcomeMessages: "رسائل النظام",
            newWelcomeMessages: "رسالة ترحيب جديدة",
            noWelcomeMessage: "لا توجد رسالة نظام.",
            welcomeMessageContent: "محتوى رسالة النظام",
            makeChoice: "أختار...",
            welcomeMessage: "ترحيب رسالة",
            repLoggedIn: "قام ممثل بتسجيل الدخول",
            loginMessage: "تسجيل الدخول",
            message: "رسالة",
            deleteWelcomeMessageQuestion: "هل ترغب حقًا في حذف رسالة النظام هذه؟",
            welcomeMessageDeleted: "تم حذف رسالة النظام",
            welcomeMessageSaved: "تم حفظ رسالة النظام.",
            welcomeMessageForm: "نموذج رسالة النظام",
            noRep: "لا يوجد ممثل حتى الآن.",
            addChat: "أضف الدردشة",
            forwardChat: "الدردشة إلى الأمام",
            ago: "منذ",
            repName: "اسم الممثل",
            lastOnline: "آخر اتصال/وقت عبر الإنترنت",
            lastStatusChange: "تغيير الحالة الأخيرة",
            activeChat: "دردشة نشطة",
            userMaxCapacity: "سعة الدردشة القصوى",
            noActiveChat: "لا دردشة نشطة",
            watch: "يشاهد",
            join: "ينضم",
            open: "فتح محادثة",
            directMessage: "رسالة خاصة",
            block: "حاجز",
            transactions: "المعاملات",
            informations: "المعلومات",
            visitStart: "قم بزيارة البداية",
            fullName: "الاسم الكامل",
            waitChatTime: "وقت الانتظار/الدردشة",
            blockUserConfirm: "هل تريد منع هذا المستخدم؟",
            messaging: "المراسلة",
            hideChat: "إخفاء الدردشة",
            block_: "حاجز",
            privateMessage_: "رسالة خاصة",
            assignRep: "تعيين ممثل",
            forwardRep: "إلى الأمام",
            leaveChat: "اترك الدردشة",
            endChat: "نهاية المحادثة",
            translatedTextDescription: "ترجم Amazon هذه الرسالة {from} -> {to}.",
            autoTranslate: "ترجمة السيارات",
            translateThisMessage: "ترجمة هذه الرسالة",
            autoTranslateDetectedDesc: "لغة الزائر هي {visitorLanguage}. انقر هنا لتفعيل الترجمة التلقائية",
            on: "على",
            off: "عن",
            copy: "ينسخ",
            prevChats: "الدردشات السابقة",
            noShortCut: "لا اختصار",
            leaveChartConfirm: "دو هل ترغب حقًا في مغادرة الدردشة؟",
            endChatConfirm: "دو ترغب في إنهاء الدردشة؟",
            endConversation: "نهاية المحادثة",
            onlyOneRep: "أنت الممثل الوحيد في هذه المحادثة!",
            chatList: "قائمة الدردشة",
            chatBar: "شريط الدردشة",
            unreadTitle: "غير مقروء",
            visitorLeftTitle: "غادر الزائر",
            activeChatTitle: "دردشة نشطة",
            autoAssignedTitle: "دردشة مخصصة تلقائية",
            watchModeTitle: "وضع الساعة",
            lostChat: "الاتصال التمثيلي فقد",
            chatWidthDelay: "الدردشة مع التأخير",
            repChatWidthDelay:
                "عندما لا يكون هناك ممثل نشط في النظام أو جميع ممثلينا ممتلئين بسبب ارتفاع حركة المرور ، ستكون خلفية الدردشة خضراء",
            repLostConn: "إذا فقد ممثل العميل الاتصال ، فستكون خلفية الدردشة وردية.",
            unreadMsg: "إذا كانت هناك رسائل غير مقروءة ، فستكون الخلفية زرقاء فاتحة.",
            visitorLeftChat: "إذا غادر الزائر المحادثة ، تصبح الخلفية رمادية داكنة.",
            activeChatMsg: "الخلفية خضراء إذا كانت الدردشة نشطة",
            autoAssignMsg:
                "تصبح الخلفية خردلًا إذا تم تعيينها عن طريق المهمة التلقائية ولم يتم النظر إلى المحادثة أبعد من ذلك",
            watchModeMsg: "إذا تم تشغيله في وضع التشغيل ، تصبح الخلفية حمراء",
            online: "متصل",
            beRightBack: "بعيد",
            away: "بعيد",
            busy: "مشغول",
            offline: "غير متصل على الانترنت",
            logout: "تسجيل خروج",
            forWindows: "للنوافذ",
            forMac: "لل ماك",
            nextChatFromActive: "التبديل من النشط إلى المحادثة التالية",
            previousChatFromActive: "التبديل من النشط إلى السابق",
            hideActiveChat: "إخفاء المحادثة النشطة",
            closeActiveChat: "إغلاق محادثة نشطة",
            firsthiddenChat: "انضم إلى أكثر دردشة العميل التي انتظرها",
            firstChatWaiting: "قم بالتبديل إلى المحادثة الانتظار",
            previousOpenedChat: "بغض النظر عن الترتيب ، انتقل إلى المحادثة التي تم فتحها مسبقًا",
            historyDetails: "تفاصيل التاريخ",
            chat: "محادثة",
            chatNotFound: "لم يتم العثور على كلام",
            dataNotFound: "لم يتم العثور على بيانات.",
            visitorInfo: "معلومات الزائر",
            timeSpent: "قضاء الوقت",
            noActiveVisitors: "لا زوار نشطين",
            totalConnected: "عدد المحادثة",
            missedChat: "عدد الدردشة الفائتة",
            workTime: "وقت العمل",
            closedChatCount: "دردشة مغلقة",
            activeConvo: "محادثة نشطة",
            notAnswered: "لم يرد بعد",
            delayedConvo: "تأخير",
            leavingRep: "ترك ممثل",
            staffRate: "معدل عمل الموظفين",
            select: "القائمة المنسدلة",
            fullname: "الاسم الكامل",
            text: "نص",
            numeric: "رقم",
            phone: "هاتف",
            optionsPlaceholder: "قيمة الخيار",
            selectField: "انقر إذا كنت تريد إضافة قائمة منسدلة",
            fullnameField: "انقر إذا كنت تريد إضافة حقل اسم كامل.",
            textField: "انقر إذا كنت تريد إضافة حقل نص.",
            labelField: "انقر إذا كنت تريد إضافة حقل وصف.",
            numericField: "انقر إذا كنت تريد إضافة حقل رقمي.",
            phoneField: "انقر إذا كنت ترغب في إضافة حقل هاتف.",
            departmentField: "انقر إذا كنت ترغب في إضافة حقل قسم.",
            emailField: "انقر إذا كنت ترغب في إضافة حقل بريد إلكتروني.",
            visible: "مرئي",
            required: "مطلوب",
            label: "تعليق",
            customLoginAlert: "يجب أن يحتوي نموذج تسجيل الدخول الخاص بك على حقل مرئي واحد على الأقل.",
            atLeastOneLanguage: "يجب أن تشعر بلغة واحدة على الأقل",
            requiredFieldField: "هذه الخانة مطلوبه",
            notRequiredField: "لا يشترط هذا المجال",
            visibleField: "هذا المجال مرئي",
            notVisibleField: "هذا الحقل لا يظهر في النموذج.",
            connectServer: "أنت متصل بالخادم",
            disconnectServer: "أنت غير متصل بالخادم",
            liveChatOff: "الدردشة الحية متوقفة",
            visitorScreen: "شاشة الزوار",
            viewOnTheSite: "عرض على الصفحة",
            viewOnTheSiteTippy: "انقر هنا لترى كيف تصمد التغييرات الخاصة بك.",
            showHint: "اظهر التلميح",
            dontShowHint: "لا تظهر تلميحًا",
            liveChatOn: "الدردشة الحية قيد التشغيل",
            nightModeOff: "وضع الليل قبالة",
            doubleClickEdit: "انقر نقرًا مزدوجًا أو اضغط على زر التحرير لتحريره.",
            edit: "يحرر",
            deleteField: "يمسح",
            arrow_upward: "السهم لأعلى",
            arrow_downward: "السهم لأسفل",
            newCatalogCategory: "فئة الكتالوج الجديدة",
            childCreate: "انقر نقرًا مزدوجًا لإنشاء طفل جديد",
            updateCatalogCategoryFrom: "تحديث نموذج فئة الكتالوج",
            newCatalogCategoryFrom: "نموذج فئة الكتالوج الجديدة",
            catalogCategoryMenu: "إضافة قائمة فئة الكتالوج",
            catalogCategoryLeaf: "إضافة القائمة الفرعية فئة الكتالوج",
            catalogCategoryName: "فئة الكتالوج اسم",
            newCatalogContentFrom: "نموذج محتوى الكتالوج الجديد",
            catalogContentName: "اسم محتوى الكتالوج",
            catalogCategorySaved: "فئة الكتالوج المحفوظة",
            catalogCategoryDeleted: "فئة الكتالوج المحذوفة",
            catalogCategoryRate: "معدل المحتوى",
            catalogContentFeature: "ميزة محتوى الكتالوج",
            vtipyAudioLevel: "تستخدم لكتم الصوت أو إلغاء كتم الأصوات.",
            vtipyOrganizationName: "يمكنك تغيير اسم المؤسسة وتحديثه.",
            vtipyBrandVisibility: "Supsis هو الإعداد ما إذا كان يمكن عرض العلامة في فقاعة الدردشة.",
            vtipyBrandVisibilityForced: "يمكن لمستخدمي بروبان فقط التغيير !!",
            vtipyClientDefault: "يمكنك تغيير لغة صفحة الوكيل هنا.",
            vtipyCustomerClientDefault: "يمكنك تغيير لغة صفحة العميل (الدردشة) هنا.",
            vtipyVisitorPreferredLang: "يمكن للعميل تحديد اللغة المنطوقة على صفحة (الدردشة).",
            vtipyCustomerClientLanguageDetect: "يمكنك تغيير لغة صفحة العميل (الدردشة) هنا.",
            vtipySelectTopic: "تحدث المهام التلقائية للممثلين الحاليين في القسم المحدد.",
            vtipyAutoCallTransfer: "يعين تلقائيا مكالمات الانتظار إلى الوكلاء المتاحين.",
            vtipyCustomerTyping: "يتيح لك معرفة ما كتبه العميل على شاشة الدردشة على شاشة الدردشة التمثيلية.",
            vtipyAgentTyping: "إنها تعطي معلومات عند كتابة التمثيلية للعميل في الدردشة bobble",
            vtipyQueueNumberVisibleFeature:
                "عندما يكون الممثلون مشغولين ، فإنه يوضح العملاء الذين يرغبون في الاتصال ، في أي ترتيب هم.",
            vtipyPrivateChatEnabled: "يظهر لوحة المحادثة بين العوامل.",
            vtipyDelayedTalkTime:
                'إذا لم يتم توصيل أي مندوبين بالمحادثة خلال هذا الوقت ، فسيتم تسميته \\ "الدردشة المتأخرة \\',
            vtipyOfflineMode: "يتيح لك وضع النظام في وضع عدم الاتصال.",
            vtipyAutoAssignLimit: "يحدد عدد العملاء (الدردشة) سيتم تعيينهم للممثل تلقائيًا.",
            vtipyCustomerDownTimeWhenRepExit: "وقت الخمول العميل عندما يخرج الممثل (ثانية)",
            tippyDisconnectTime: "إغلاق الدردشة بعد فصل العميل (SEC).",
            changeSettings: "تغيير الإعدادات العالمية",
            totalBg: "مجموع الدردشات",
            activeBg: "الدردشات النشطة",
            watchBg: "يشاهد",
            waitingBg: "محادثات عابرة",
            lateBg: "محادثات عابرة",
            freeBg: "حر",
            maxCapacityBg: "السعة القصوى",
            addNewSettings: "أضف إعدادات عالمية جديدة",
            darkMode: "الوضع المظلم",
            clientDefault: "لوحة الافتراضية اللوحة",
            customerClientDefault: "لغة العميل الافتراضية",
            customerClientLanguageDetect: "لغة العميل لاكتشاف تلقائي",
            visitorPreferredLang: "دع العميل يختار اللغة المنطوقة",
            preferredThemeColor: "لون السمة المفضل لشاشة دردشة العميل",
            detail: "التفاصيل",
            supportUs: "اتصل بنا (الدعم المباشر)",
            langSetting: "إعدادات اللغة",
            changeLang: "تغيير اللغة",
            fontSizeSetting: "إعداد تكبير الشاشة",
            changeLangDesc: "يغير لغة التطبيق إلى {code}",
            trLang: "اللغة التركية",
            enLang: "إنجليزي",
            fieldRequired: "{الحقل} مطلوب حقل",
            selectALanguage: "اختر لغة",
            selectATheme: "حدد موضوع",
            responseForm: "نموذج الاستجابة",
            clientRequestInfo: "معلومات طلب العميل",
            createdDate: "تاريخ الإنشاء",
            descMessage: "رسائل",
            new: "جديد",
            selectAllPermission: "اختر الكل",
            catalogCategories: "فهرس",
            copiedClipboard: "نسخ إلى الحافظة",
            changeLogo: "تغيير الشعار",
            changePhoto: "غير الصوره",
            addPhoto: "إضافة صورة",
            seePhoto: "انظر الصورة",
            deletePhoto: "احذف الصورة",
            organizationLogo: "شعار المنظمة",
            changePlan: "خطة التغيير",
            close: "يغلق",
            vtipyUploadLogo:
                "من خلال تحميل شعار شركتك من هذا المجال ، يمكنك استخدام شعارك الخاص في رسائل البريد الإلكتروني وصفحات العملاء.",
            tagName: "اسم العلامة",
            tagDescription: "وصف التسمية",
            tagColor: "لون التسمية",
            userInformations: "معلومات المستخدم",
            incomingChat: "محادثة واردة",
            support: "يدعم",
            team: "تعيين",
            groups: "مجموعات",
            newConversationStarted: "بدأت محادثة جديدة",
            allHistoryLoaded: "تم تحميل كل التاريخ",
            chatCreator: "منشئ الدردشة",
            enterGroupTitle: "أدخل عنوان المجموعة",
            requiredTitle: "لا يمكنك ترك حقل العنوان فارغًا",
            requiredChannel: "لا يمكن ترك اسم القناة فارغًا",
            next: "يتأكد",
            selectPeople: "حدد الأشخاص",
            textLimitAlertMessage:
                "الحد الأقصى لعدد الأحرف في WhatsApp هو 19 حرفًا ولن يتم عرضه بعد هذا الحد. ومع ذلك، على الويب، يتم نقل النصوص التي تتجاوز الحد المسموح به وهو 19 حرفًا تلقائيًا إلى السطر التالي ويتم عرضها.",
        },
        shouldAddMethod:
            "يجب عليك ملء حقل طريقة الدفع وعنوان الفواتير!\nلن يتم سحب أي أموال من حسابك..\n" +
            "في نهاية الشهر ، سيتم إنشاء فاتورة وفقًا لمبلغ استخدامك.",
        telegram: {
            typeInTelegramToken: "اكتب رمز برقية",
            token: "رمز",
            telegramTokenTitle: "تكامل Telegram Supsis",
            telegramAlertForm: "يمكنك الحصول على Telegram bot token منz",
            telegramAlertTitle: "هل تريد حقًا حذف الرمز المميز؟",
            telegramAlertText: "الرمز المميز سوف يختفي بشكل دائم!",
        },
        wp: {
            sendAgain: "إعادة الإرسال",
            shippingDetails: "تفاصيل الشحن",
            importContactsFromFile: "استيراد جهات الاتصال من ملف",
            chatStarted: "بدأت الدردشة",
            chatNotStarted: "الدردشة لم تبدأ",
            contactSelected: "الاتصال المحدد",
            startChatWithAnyNo: "ابدأ الدردشة مع أي رقم",
            toLittleChar: "رقم مفقود !",
            typeInANumberDesc: "اكتب الرقم لبدء الدردشة مع:",
            wpPlusAndLicenceRequired: "WhatsApp Plus خطة وترخيص مطلوب.",
            wpPlusAndLicenceRequiredDesc:
                "قبل أن تتمكن من بدء الدردشات بأرقام غير مسجلة في جهات الاتصال الخاصة بك ، يجب عليك ترقية خطة WhatsApp والحصول على ترخيص ..",
            chatStartingWait: "بدء المحادثة ، يرجى الانتظار",
            whatsapp: "ال WhatsApp",
            agreement: "اتفاق",
            purchase: "شراء",
            activating: "تنشيط خدمة WhatsApp",
            authenticating: "مصادقة رمز الاستجابة السريعة",
            ready: "مستعد",
            enableFeature: "تمكين ميزة WhatsApp",
            readAndAgree: "لقد قرأت وأوافق",
            subscribe: "يشترك",
            subscribed: "مشترك",
            toEnableWpDescription: "لتمكين ميزات WhatsApp ، انقر فوق الزر أدناه.",
            waitForWpActivationDescription:
                "يتم تنشيط خدمة حساب WhatsApp الخاصة بك. يرجى الانتظار لبعض الوقت. يستغرق حوالي 10-30 ثانية.",
            greatWpActivatedDescription: "رائع ، يتم تنشيط خدمة حساب WhatsApp الخاصة بك!",
            unsubscribe: "إلغاء الاشتراك",
            planDetails: "سمات",
            sendReceiveMessage: "إرسال واستقبال الرسائل النصية",
            sendReceiveImage: "إرسال وتلقي ملفات الصور",
            sendReceiveAudio: "إرسال واستقبال ملفات الصوت",
            sendReceiveGif: "إرسال وتلقي ملفات GIF",
            startChat: "ابدأ الدردشة على supsis",
            supsisFunctionality: "وظائف دردشة Supsis مفيدة",
            onePhoneMultiAgent: "هاتف واحد ووكلاء متعددين",
            basicIntegration: "التكامل الأساسي وتكوين الصفر",
            activationTitle: "لتفعيل تكامل WhatsApp على supsis:",
            wpIntegrationInstruction1: "افتح WhatsApp على هاتفك",
            wpIntegrationInstruction2: "اضغط على القائمة أو الإعداد. انقر فوق الأجهزة المرتبطة",
            wpIntegrationInstruction3: "أشر هاتفك إلى هذه الشاشة لالتقاط الرمز",
            qrGeneratingWait: "توليد رمز الاستجابة السريعة من فضلك انتظر ...",
            pleaseContinueToWaitUntilCompleted:
                "بعد التحقق من رمز الاستجابة السريعة ، سيتم التبديل تلقائيًا إلى الحقل المكتمل. انتظر من فضلك...",
            authenticatingWait: "المصادقة ، من فضلك انتظر ...",
            unsubscribeWpInetgration: "إلغاء الاشتراك في تكامل WhatsApp",
            unsubscribeIGIntegration: "إلغاء الاشتراك في تكامل Instagram",
            wpBack: "خلف",
            terminatelWpInetgration: 'عند النقر فوق الزر "إلغاء الاشتراك" ، سيتم إنهاء تكامل WhatsApp الخاص بك',
            cancelWpInetgration: "هل تريد إلغاء تكامل WhatsApp؟",
            terminatelIGIntegration: 'عند النقر فوق الزر "إلغاء الاشتراك" ، سينتهي تكامل Instagram الخاص بك',
            cancelIGIntegration: "هل تريد إلغاء تكامل Instagram؟",
            startChatWp: "ابدأ الدردشة",
            purchaseHeader: "شراء تكامل supsis-whatsapp",
            wpServices: "خدمة WhatsApp",
            wpServicesIntegrationCompleted: "اكتمل تكامل WhatsApp الخاص بك. يمكنك الآن استخدام الخدمة.",
            purchasePaymentDescription:
                "ميزة WhatsApp التي تم إصدارها من شهر إلى شهر. سيتم تنشيط خدمة WhatsApp الخاصة بك بعد قبول الاشتراك.",
            wpIntegrationFeatures: "ميزات تكامل WhatsApp",
            saveChanges: "حفظ التغييرات",
            contactList: "قائمة الإتصال",
            broadcast: {
                broadcast: "إذاعة",
                detail: "تفاصيل البث",
                customer: "عميل",
                phoneNumbers: "ارقام التواصل",
                showMore: "أظهر المزيد",
                groupName: "أسم المجموعة",
                messages: "رسائل",
                status: "حالة",
                usageCost: "تكلفة الاستخدام",
                sendingTime: "إرسال الوقت",
                progress: "تقدم",
                groupDetail: "تفاصيل المجموعة",
                messagesPerContact: "رسائل لكل جهة اتصال",
                successRatio: "نسبة النجاح",
            },
            messages: "رسائل",
            broadcastRequests: "طلبات البث",
            customerGroups: "مجموعات العملاء",
            messageTemplates: "قوالب الرسائل",
            plans: "خطط",
            wpIntegrationRequired: "تكامل WhatsApp مطلوب",
            wpRequiredIntegrationDescription: "آسف ، سيتم تنشيط الصفحة التي قمت بزيارتها عند دمج WhatsApp الخاص بك.",
            integrateWp: "دعنا نذهب ، دمج whatsapp",
            active: "نشيط",
            archived: "أرشفة",
            createBroadcastMessage: "إنشاء رسالة بث",
            title: "عنوان",
            description: "وصف",
            createdAt: "أنشئت في",
            numbers: "أعداد",
            actions: "أجراءات",
            action: "فعل",
            createCustomerGroup: "إنشاء مجموعة عملاء مخصصة",
            search: "يبحث",
            name: "اسم",
            contacts: "جهات الاتصال",
            noContactFound: "لم يتم العثور على اتصال",
            broadcastTitle: "إعطاء عنوان البث الخاص بك.",
            recipients: "المستلمين",
            selectRecipients: "حدد المستلمين",
            writeYourMessage: "اكتب رسالتك.",
            schedule: "جدول",
            scheduleNowOrLater: "الجدول الزمني الآن أو بعد ذلك",
            summary: "ملخص",
            cancel: "يلغي",
            send: "يرسل",
            sending: "إرسال",
            deleteCustomerGroup: "هل أنت متأكد من حذف مجموعة العملاء هذه؟ {name}",
            customerGroupDeleting: "حذف مجموعة العملاء ...",
            customerGroupDeletingSuccess: "تم حذف مجموعة العملاء بنجاح",
            customerGroupDeletingError: "خطأ أثناء حذف مجموعة العملاء",
            wpPlusRequired: "الخطة WhatsApp Plus المطلوبة.",
            broadcastMessageArchived: "رسالة البث أرشفة",
            broadcastMessageNotArchived: "رسالة البث غير مؤرشفة",
            groupNameSearch: "اكتب اسم مجموعة العملاء",
            groupNameDesc: "اسم مجموعة العميل حدد مجموعات العملاء الخاصة بك",
            save: "يحفظ",
            number: "رقم",
            addColumn: "إضافة العمود",
            addColumnDesc: "أضف عمودًا إلى الجدول",
            addNewContact: "إضافة جهة اتصال جديدة",
            addNewContactDesc: "أضف جهة اتصال إلى الجدول",
            importFile: "استيراد من الملف",
            importFileDesc: "استيراد جهات الاتصال من ملف Excel أو CSV",
            contactAdded: "الاتصال المضافة",
            updateCustomerGroup: "تحديث مجموعة العملاء ...",
            updateCustomerGroupSuccess: "تم تحديث مجموعة العملاء بنجاح",
            sendBroadcastMessage: "إرسال رسالة البث",
            columnName: "اسم العمود",
            columnType: "نوع العمود",
            defaultValue: "القيمة الافتراضية",
            setDefaultValue: "اضبط القيمة الافتراضية على جهات الاتصال",
            age: "عمر",
            location: "موقع",
            gender: "جنس",
            selectContactFile: "حدد ملف الاتصال",
            selectContactCsvOrExcel: "حدد ملف CSV أو Excel.",
            importConfiguration: "تكوين استيراد",
            customizeFile: "تخصيص تكوين الاستيراد الخاص بك.",
            sendMessageTo: "من تريد إرسال الرسالة إلى؟",
            allContact: "كل الاتصال",
            messageTypes: "أنواع الرسائل",
            whenSendMessage: "متى تريد إرسال الرسالة إلى؟",
            instantlyRightNow: "على الفور الآن",
            completed: "مكتمل",
            scheduleFuture: "جدول زمني لتاريخ المستقبل",
            messageDesc: "سيتم إرسال رسالتك على الفور إلى جميع المستلمين",
            messageSendAt: "سيتم إرسال رسالتك إلى جميع المستفيدين في",
            estimatedPrice: "السعر المقدر",
            estimatedTime: "الوقت المقدر",
            now: "الآن",
            tenMinute: "10 دقائق",
            cancelled: "ألغيت",
            failed: "فشل",
            running: "جري",
            queued: "قائمة الانتظار",
            scheduled: "المقرر",
            noNumberAdded: "لم تتم إضافة أرقام",
            csvOrExcelFile: "ملف CSV أو Excel",
            broadcastMessagesToContactFile: "رسائل البث إلى قائمة الاتصال",
            broadcastMessageTemplates: "قوالب الرسائل البث",
            messageFlow: "تدفق الرسالة",
            textMessageSupport: "دعم الرسائل النصية",
            imageMessageSupport: "دعم رسالة الصورة",
            spamPreventions: "الوقاية من البريد العشوائي",
            includesAllBasicPlans: "يشمل كل شيء في الخطة الأساسية",
            chatbotIntegration: "تكامل chatbot",
            messageToNewNumbers: "رسالة إلى أرقام جديدة",
            broadcastMessageToEveryone: "بث رسائل للجميع",
            personalizedBroadcastMessage: "رسائل البث الشخصية",
            customerGroupSegmentation: "تجزئة مجموعة العملاء",
            scheduleBroadcastMessage: "جدولة رسالة البث",
            locationMessageSupport: "دعم رسالة الموقع",
            advancedSpamPreventions: "الوقاية من البريد العشوائي المتقدمة",
            whatsappPlans: "خطط WhatsApp",
            selectBestPlan: "اختر الخطة التي تناسبك",
            comingSoon: "قريباً...",
            selectFile: "حدد ملف",
            created: "مخلوق",
            message: "رسالة",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            instagramComments: "تعليقات انستغرام",
            messengerComments: "تعليقات ماسنجر",
            trendyolComments: "تعليقات تريندول",
            ticketSelection: "تم تحديد التذكرة",
            bulkClose: "إغلاق جماعي",
            igComment: "تعليق على إنستغرام",
            igMentioned: "إشارات إنستغرام",
            incomingReqChatbot: "الطلبات الواردة مع روبوت المحادثة",
            incomingReqWebForm: "الطلبات الواردة من نموذج الويب",
            incomingReqAutomation: "الطلبات من الأتمتة",
            thisPersonEmailAnswered: "هذا الشخص يريد الرد عبر البريد الإلكتروني",
            thisPersonWpAnswered: "هذا الشخص ينتظر إجابة عبر واتساب",
            clickStartWpChat: "انقر لبدء دردشة واتساب",
            requestProgress: "تقدم الطلب",
            requestMessage: "طلب رسالة",
            clickAddMailAddress: "انقر لإضافة عنوان بريد",
            sendReplyCloseTicket: "إرسال الرد وإغلاق التذكرة",
            closeTicket: "إغلاق التذكرة",
            selectEmailSender: "تحديد مرسل البريد الإلكتروني",
            withEmailWillNotRecievice: "لن تتمكن من تلقي الردود على البريد عند الإرسال باستخدام عنوان البريد هذا!",
            deleteCommentAndClose: "حذف وإغلاق التعليق",
            sendReplyAndClose: "إرسال رد وإغلاق",
            startChatWp: "بدء دردشة واتساب",
            sureWantToDeleteTicket: "هل أنت متأكد من رغبتك في حذف تذكرة؟",
            bulkDeleteConfirmation: "تأكيد الحذف الجماعي للتذكرة",
            selectedTicketSucsDelete: "تم حذف التذاكر المحددة بنجاح.",
            thereErrorDeletingTicket: "حدث خطأ أثناء حذف التذاكر.",
            deleteConfirm: "تأكيد الحذف",
            sureDeleteTicket: "هل أنت متأكد من رغبتك في حذف هذه التذكرة؟",
            ticketSucsDelete: "تم حذف التذكرة بنجاح.",
            represantiveSucsAppoint: "تم تعيين الوكيل بنجاح.",
            ticketClosedSucs: "تم إغلاق التذكرة بنجاح.",
            ticketCloureFailed: "فشل إغلاق التذكرة.",
            unprocessed: "غير معالج",
            pleaseSelectValidStatus: "الرجاء تحديد حالة صالحة.",
            ticketStatusBeenUpdatd: "تم تحديث حالة التذكرة.",
            doYouWantCloseTicket: "هل تريد إغلاق التذكرة؟",
            ticketWillMarkedClosed: "سيتم وضع علامة على التذكرة على أنها مغلقة وأرشفتها.",
            errorUpdatingTicketFailed: "حدث خطأ أثناء تحديث حالة التذكرة.",
            igCommentDeleteIgPost: "تم حذف تعليق Instagram من منشور IG الخاص بك.",
            igCommentHideChange: "تم تغيير حالة إخفاء التعليق على إنستغرام.",
            pleaseChooseRepresent: "الرجاء اختيار ممثل.",
            selectedTicketSucsDelegated: "تم تفويض التذاكر المحددة بنجاح.",
            errorOccuredDuringDelegation: "حدث خطأ أثناء عملية التفويض.",
            bulkTicketClosing: "إغلاق تذاكر مجمعة",
            sureWantCloseTicket: "هل أنت متأكد من رغبتك في إغلاق التذكرة؟",
            selectedTicketSucsClosed: "تم إغلاق التذاكر المحددة بنجاح.",
            thereErrorClosingTicket: "حدث خطأ أثناء إغلاق التذاكر.",
            changeFilterTicketPage: "تغيير عوامل التصفية في صفحة التذاكر",
            nameOfFilter: "اسم المرشح",
            filterValue: "قيمة عامل التصفية",
            deletesSelectedTickets: "حذف التذاكر المحددة",
            idTicketBeDelete: "معرفات التذاكر المراد حذفها. (معرفات التذاكر المحددة أو جميع معرفات التذاكر المدرجة)",
            assignsAgentSelectedTickets: "يخصص ممثلاً للتذاكر المحددة",
            idTicketBeAssigned:
                "معرفات التذاكر المراد تخصيصها. (معرفات التذاكر المحددة أو جميع معرفات التذاكر المدرجة)",
            idAgentAssigned: "معرف الممثل المخصص",
            changesStatusSelectedTicket: "يغير حالة التذاكر المحددة",
            idTicketWhoseStatus:
                "معرفات التذاكر التي ستتغير حالتها. (معرفات التذاكر المحددة أو جميع معرفات التذاكر المدرجة)",
            newStatus: "حالة جديدة",
            selectedTicketsSucsUpdated: "تم تحديث حالة التذاكر المحددة بنجاح.",
            errorWhileChangingStatus: "حدث خطأ أثناء تغيير حالة التذاكر.",
            thisPageVoiceAssistant: "تحتوي هذه الصفحة على مساعد صوتي",
            hello: "مرحباً!",
            voiceAssistantContent: `هل كنت تعلم أن هناك <strong>مساعد ذكاء صناعي</strong> يمكنه مساعدتك في هذه الصفحة؟
يمكنك تجربة استخدام المساعد بطرق التالية:`,
            commandHoldingDownTheKey: "يمكنك الضغط على مجموعة المفاتيح والاستمرار في التحدث لإعطاء الأوامر.",
            topRightContent: "في الزاوية العليا اليمنى",
            clickOnTheIcon: "يمكنك بدء المساعد بالنقر على الرمز.",
            sampleVoiceCommands: "نموذج الأوامر الصوتية:",
            showMyTickets: "إظهار تذاكري",
            showMeZeynepsOpenTicket: "إظهار تذاكر زينب المفتوحة اليوم",
            deleteTicketsScreen: "حذف التذاكر على الشاشة",
            assigntLastTicketAli: "تعيين التذكرة الأخيرة لعلي",
            changeStatusAllTicket: "تغيير حالة جميع التذاكر إلى تم.",
            setStatusTicketsScreen: "تعيين حالة التذاكر على الشاشة إلى .......",
            assigntUserTicketScreen: "تعيين التذاكر على الشاشة إلى المستخدم .....",
            assigntFirstTicket: "تعيين التذكرة الأولى لي",
            showIgTickets: "عرض تذاكر الشهر الماضي على الشاشة",
            makeChoice: "إجراء الاختيار",
            makeAssignment: "إجراء التعيين",
            tickets: "تذاكر",
            instagramTickets: "تذاكر انستجرام",
            facebookTickets: "تذاكر فيسبوك",
            trendyolTickets: "تذاكر ترينديول",
            automationTickets: "تذاكر الأتمتة",
            supsisFormTickets: "تذاكر نموذج سوبسيس",
            columnSettings: "إعدادات العمود",
            ticketField: "منطقة التذاكر",
            contactPropertyFields: "الوصول إلى مناطق الملكية",
            ticketFilterList: {
                archivedRequests: "الطلبات المؤرشفة",
                comingFromFacebook: "قادم من فيسبوك",
                comingFromInstagram: "قادم من إنستغرام",
                unassignedOpenRequests: "الطلبات المفتوحة غير المخصصة",
                openRequests: "الطلبات المفتوحة",
                requestsOpenedThisWeek: "الطلبات المفتوحة هذا الأسبوع",
                specialList: "قائمة خاصة",
                creationDate: "تاريخ الإنشاء",
                supsisFromTheForm: "سوبسيس من ذا فورم",
                fromTrendyol: "من ترينديول",
                comesWithAutomation: "يأتي من الأتمتة",
                label: "التسمية",
                status: "الحالة",
                subject: "الموضوع",
                email: "البريد الإلكتروني",
                name: "الاسم",
                phone: "الهاتف",
                type: "النوع",
                assignedUser: "المستخدم المعين",
            },
            appointingRepresentative: "عيّن ممثلًا",
            ticketTagFilter: "علامة تصفية التذاكر",
            ticketEmails: "قائمة البريد الإلكتروني لإعادة توجيه التذاكر",
            save: "يحفظ",
            delete: "يمسح",
            transactions: "خيارات",
            noEmailTicketNotifications: "ليس هنالك معلومات",
            emailIsNotValid: "البريد الإلكتروني غير صالح",
            emailNotificationDeleted: "تم حذف العنصر بنجاح",
            emailNotificationDeleteError: "حدث خطأ",
            tagFilterRequired: "علامة مرشح التذاكر المطلوبة ، استخدم *(Wildcard) علامة لجميع التذاكر",
            emailsRequired: "يجب ألا يكون إعادة توجيه رسائل البريد الإلكتروني لاغية",
            emailNotificationCreated: "تم إنشاء قاعدة التذاكر",
            emailNotificationCreateError: "حدث خطأ",
            ticketForwarding: "إعادة توجيه البريد الإلكتروني التذاكر",
            ticketTagFilterDesc:
                'يستخدم موضوعات التذاكر التي استخدمتها في تصميم chatbot لتصفية التذاكر. يمكنك كتابة علامة مختلفة واضغط على Enter لإضافتها. إذا قمت بتحديد علامة "*" ، فسيتم تحديد جميع التذاكر',
            ticketEmailsDesc:
                "قائمة البريد الإلكتروني التي سيتم إعادة توجيه التذاكر إليها. يمكنك إضافة عناوين الممثلين في النظام عن طريق اختيارها. يمكنك أيضًا إضافة بريد إلكتروني غير نظام/ق.",
            ticketList: "قواعد إعادة توجيه التذاكر",
            ticketTagFilterPlaceHolder: 'مرشح التذاكر ، حدد "*" للجميع',
            ticketEmailsPlaceHolder: "إعادة توجيه قائمة البريد الإلكتروني",
        },
        theme: {
            opacity: "الغضب",
            headerColor1: "لون قسم هادر 1",
            headerColor1A: "قسم هادر عتامة 1",
            headerColor2: "رأس قسم الرأس 2",
            headerColor2A: "رأس قسم العتامة 2",
            backgroundColor: "لون الخلفية 1",
            backgroundColorA: "عتامة الخلفية 1",
            backgroundColor2: "لون الخلفية 2",
            backgroundColor2A: "عتامة الخلفية 2",
            textColor: "لون الخط",
            errorTheme: "لون الخطأ",
            bubbleBackground: "تمثيلي لون الفقاعة",
            bubbleVisitorBackground: "لون فقاعة العملاء",
            bubbleBackgroundA: "تمثيلية الفقاعة العتامة",
            bubbleVisitorBackgroundA: "عتامة فقاعة العملاء",
            bubbleText: "لون النص التمثيلي",
            bubbleVisitorText: "لون نص العميل",
            textFormColor: "شكل اللون",
            selectCustom: "حدد موضوع مخصص",
            headerColorSecond: "رأس اللون العلوي",
            headerColorFirst: "لون أسفل العنوان",
            backgroundColorFirst: "لون الخلفية العلوي",
            formColor: "لون نص النموذج",
            buttonColor: "لون الزر",
            backgroundColorSecond: "لون الخلفية السفلي",
            chatBotButtonText: "لون زر Chatbot",
            chatBotButtonColor: "لون زر Chatbot",
        },
        billing: {
            billingContactInfo: "تم تحديث معلومات جهة اتصال الفوترة بنجاح.",
            defaultRootEmail: "افتراضي: البريد الإلكتروني الأساسي",
            invoiceEmailAddress: "عنوان البريد الإلكتروني للفاتورة",
            invoiceSettings: "إعدادات الفاتورة",
            updateChannelDesc6: "تحديث قناة واتساب للأعمال",
            newWabaChannel: "قناة واتساب للأعمال الجديدة",
            newWabaChannelDesc: "إنشاء قناة جديدة لواجهة برمجة تطبيقات واتساب للأعمال",
            popular: "مشهور",
            selectedPlan: "الخطة المحددة",
            editPlan: "تحرير الخطة",
            removePlan: "إزالة خطة",
            showPlan: "إظهار الخطة",
            hiddenPlan: "إخفاء الخطة",
            contactSales: "الاتصال بالمبيعات",
            showLess: "إظهار أقل",
            more: "المزيد",
            selectTransactionType: "اختر نوع المعاملة",
            walletLogs: "سجلات المحفظة",
            addBalance: "إضافة رصيد",
            availableBalance: "الرصيد المتاح",
            appsumoPack: "حزمة أبسومو",
            updatePlan: "تحديث الخطة",
            createPlan: "إنشاء خطة",
            freePack: "حزمة مجانية",
            instantFee: "سيتم فرض رسوم فورية",
            planSequence: "تسلسل الخطة",
            requiredCodes: "عدد الرموز المطلوبة",
            subHeading: "العنوان الفرعي",
            featureKey: "مفتاح الميزة",
            customerKey: "مفتاح العميل",
            monthlyPrice: "السعر الشهري",
            monthlyNonDiscounted: "السعر الشهري غير المخصوم (عرض غير وظيفي)",
            twoYearDiscount: "خصم سنتين",
            yearDiscount: "خصم سنوي",
            sixMonthDiscount: "خصم ستة أشهر",
            threeMonthDiscount: "خصم ثلاثة أشهر",
            areYouSoreRefundInvoice: "هل أنت متأكد من رغبتك في استرداد قيمة هذه الفاتورة؟",
            features: "خصائص",
            sessionCount: "عدد الجلسات",
            subType: "نوع الاشتراك",
            skipTrialVersion: "تخطي الإصدار التجريبي",
            skipTrialVersionDesc:
                "يمكنك تخطي الإصدار التجريبي والمتابعة عن طريق تحديد الحزمة المناسبة لنشاطك التجاري. إذا قمت بتخطي الإصدار التجريبي، لا يمكن التراجع عن هذا الإجراء.",
            skipStep: "تخطي هذه الخطوة",
            switchToPay: "التبديل إلى الدفع",
            forward: "إلى الأمام",
            pleaseFillInCard: "الرجاء ملء تفاصيل البطاقة!",
            fillInTheBillingAddress: "الرجاء ملء معلومات عنوان الفوترة!",
            cardNumberWrong: "رقم البطاقة خاطئ!",
            pleaseConfirmTheUser: "الرجاء تأكيد اتفاقية المستخدم!",
            pleaseCheckYourCard: "يرجى التحقق من بطاقتك وتفاصيلك.",
            site: "الموقع",
            period: "الفترة",
            billStatus: "حالة الفاتورة",
            totalPrice: "السعر الإجمالي + ضريبة القيمة المضافة",
            depotMoneyWallet: "الإيداع في المحفظة",
            threeMonthly: "٣ شهرياً",
            sixMonthly: "٦ شهرياً",
            twoYearly: "٢ سنة",
            forever: "إلى الأبد",
            extraPackage: "الحزمة الإضافية",
            teamPackage: "حزم الفريق",
            adventPackage: "الحزم المميزة",
            cupponError: "رمز القسيمة غير صحيح أو منتهي الصلاحية",
            enterYourCard: "الرجاء إدخال بطاقتك الائتمانية",
            invalidCard: "بطاقة ائتمان غير صالحة، لم يتم استلام الدفع",
            calculateThis: "احسب لـ:",
            adventageousPackage: "خصومات الباقة المميزة!",
            cupponApplied: "تم تطبيق القسيمة بنجاح",
            subStart: "تم بدء الاشتراك",
            subSuccessStart: "بدأ اشتراكك بنجاح",
            success: "ناجح",
            succesDesc: "تم إنشاء الاشتراك بنجاح",
            successDesc: "تم تفعيل الميزة الخاصة بك بنجاح.",
            maxNumber: "الحد الأقصى لعدد الممثلين الذين سيتحدثون",
            currentAmountDetails: "تفاصيل المبلغ الحالي",
            endOfMonthForecastDetails: "تفاصيل توقعات نهاية الشهر",
            totalAmount: "إجمالي المبلغ",
            vatAmount: "مبلغ ضريبة القيمة المضافة (20%)",
            totalAmountIncludingVAT: "إجمالي المبلغ شاملاً ضريبة القيمة المضافة",
            hideDetails: "إخفاء التفاصيل",
            createInvoice: "إنشاء فاتورة",
            reimbursementMade: "تم السداد",
            invalidInvoice: "فاتورة غير صالحة",
            balanceTopUp: "تعبئة الرصيد",
            paidSuccesfully: "تم دفع الفاتورة بنجاح",
            paymentFailed: "فشلت عملية دفع الفاتورة.",
            areYouSurePaid: "هل تريد بالتأكيد وضع علامة مدفوعة على هذه الفاتورة؟",
            invoiceMarkedPaid: "تم وضع علامة على الفاتورة على أنها مدفوعة.",
            invoiceMarkedFailed: "حدث خطأ وتعذر وضع علامة مدفوعة على الفاتورة.",
            areYouSureRefundInvoice: "هل أنت متأكد من أنك تريد معالجة استرداد الأموال لهذه الفاتورة؟",
            youMustFillInEmpty: "يجب عليك ملء جميع المساحات الفارغة.",
            createdNewInvoice: "تم إنشاء فاتورة جديدة بنجاح.",
            createdNewInvoiceFailed: "حدث خطأ أثناء إنشاء الفاتورة.",
            invoiceUpdated: "تم تحديث مبلغ الفاتورة بنجاح...",
            invoiceUpdatedFailed: "حدثت مشكلة أثناء تحديث الفاتورة.",
            plans: "الخطط",
            companyName: "اسم الشركة",
            compony: "شركة",
            person: "شخص",
            invoiceAddressInfo: "معلومات عنوان الفاتورة",
            idNo: "معرف تركي",
            taxOffice: "مكتب الضرائب",
            taxNumber: "رقم الضريبة",
            packageCanNotDownSupsis:
                "لا يمكن تخفيض رتبة الحزمة الخاصة بك. يُرجى إزالة أو تعطيل العديد من وكلائك لخفض ترقية الحزمة الخاصة بك.",
            packageCanNotDownWp:
                "لا يمكن تخفيض رتبة الحزمة الخاصة بك. يُرجى حذف العديد من قنوات الواتس آب الخاصة بك لتخفيض رتبة الحزمة الخاصة بك.",
            packageCanNotDownWPBussiness:
                "لا يمكن تخفيض رتبة الحزمة الخاصة بك. يُرجى حذف العديد من قنوات واتساب التجارية الخاصة بك لخفض رتبة باقتك.",
            chooseYourPlan: "اختر خطتك.",
            numberOfRepresentatives: "عدد الممثلين",
            numberOfChannels: "عدد القنوات",
            wpNumberOfChannels: "عدد قنوات الواتساب",
            igNumberOfChannels: "عدد قنوات الإنستغرام",
            msNumberOfChannels: "عدد قنوات المسنجر",
            cancelIt: "إلغاء",
            activePlan: "خطة نشطة",
            activate: "تنشيط",
            noTransition: "لا انتقال",
            daysLater: "اليوم التالي",
            payBack: "إعادة الدفع",
            paid: "مدفوع",
            unPaid: "غير مدفوعة",
            editPrice: "تحرير السعر",
            payNow: "ادفع الآن",
            youAreCurrentlyOnTrial: "أنت حاليًا قيد التجربة. يمكنك تخطي الفترة التجريبية الآن لمشاهدة الباقات الحصرية.",
            youAreCurrentlyLimited: "أنت مقيد حاليًا من قبل النظام لأن باقاتك لا تستوفي الشروط.",
            youHaveOneRepresentative: "لديك ممثل واحد.",
            deactivateOrDeleteYourPiece: "قم بإلغاء تنشيط أو حذف ممثل قطعتك أو شراء ممثل.",
            youHaveOneWhatsAppQRChannel: "لديك قناة واتساب QR واحدة.",
            deleteYourWhatsAppQR: "احذف قناة واتساب QR الخاصة بك أو اشترِ قناة.",
            youHaveAWhatsAppBusiness: "لديك قناة واتساب واحدة للأعمال.",
            deleteYourWhatsApp: "احذف قناة واتساب للأعمال أو اشترِ قناة.",
            youHaveAnInstagram: "لديك قناة على Instagram.",
            deleteYourInstagram: "احذف قناتك على Instagram أو اشترِ قناة.",
            youHaveAMessenger: "لديك قناة على الماسنجر.",
            deleteYourMessenger: "احذف قناتك على الماسنجر أو اشترِ قناة.",
            additionalPackages: "حزم إضافية",
            availablePackages: "الباقات المتاحة",
            buyNow: "شراء الآن",
            invoiceInformation: "معلومات الفاتورة",
            invoiceAddress: "عنوان الفاتورة",
            invoiceType: "نوع الفاتورة",
            review: "مراجعة",
            viewDetails: "عرض التفاصيل",
            addNewAddress: "إضافة عنوان جديد",
            enterYourBillingAddress: "أدخل عنوان الفاتورة الخاص بك",
            selectPlan: "اختر الخطة",
            paymentStatus: "حالة الدفع",
            amount: "المبلغ",
            invoiceID: "معرف الفاتورة",
            expected: "متوقع...",
            currentAmount: "المبلغ الحالي",
            monthlyEstimatedAmount: "المبلغ التقديري الشهري",
            creationDate: "تاريخ الإنشاء",
            invoiceStatus: "حالة الفاتورة",
            invoicePeriod: "فترة الفاتورة",
            newPaymentMethod: "طريقة دفع جديدة",
            channelCount: "عدد القنوات",
            remainingTime: "الوقت المتبقي",
            chatbotLimit: "حد الدردشة الآلية",
            free: "مجاني",
            maxChatbotSession: "الحد الأقصى لجلسات الدردشة الآلية",
            buyIt: "اشترِ",
            renewalDate: "تاريخ التجديد",
            monthly: "شهرياً",
            yearly: "سنوياً",
            packagePeriod: "فترة الحزمة",
            packageType: "نوع الحزمة",
            packageManagement: "إدارة الحزم",
            invoiceManagement: "إدارة الفواتير",
            futureInvoice: "الفاتورة المستقبلية",
            pastInvoices: "الفواتير السابقة",
            creditCard: "بطاقة الائتمان",
            invoice: "فاتورة",
            mustBeUpgradePlanForChatBot: "لتفعيل ميزة chatbot ، يجب عليك التبديل إلى خطة Pro!",
            cardInfo: "معلومات البطاقة",
            billingDetails: "تفاصيل الفاتورة",
            addCardIyzico:
                "ليس لديك بطاقة مسجلة. من أجل دفع رسوم الاستخدام الشهرية ، تحتاج إلى إضافة بطاقة. يتم توفير نظام الدفع بواسطة Iyzico.",
            billingPlanSettings: "فاتورة الفواتير",
            startWith: "{cardFamily} تبدأ بطاقة {binNumber}",
            paymentMethod: "طريقة الدفع او السداد",
            billingDate: "تاريخ الفواتير",
            isPaid: "مدفوع؟",
            markPaid: "مارك كما دفعت",
            paymentDate: "تاريخ الدفع",
            pay: "يدفع",
            newInvoice: "إنشاء فاتورة",
            updateBilling: "تحديث تفاصيل الفواتير",
            updateCard: "تغيير بطاقة الائتمان",
            paymentBilling: "طريقة الدفع وتفاصيل الفواتير",
            price: "سعر",
            billingAddress: "عنوان وصول الفواتير",
            billingCity: "مدينة",
            billingCountry: "دولة",
            contactName: "اسم الاتصال الفواتير",
            expireMonth: "تنتهي صلاحية الشهر",
            expireYear: "تنتهي صلاحيتها",
            cardNumber: "رقم البطاقة",
            cardHolderName: "إسم صاحب البطاقة",
            cardAlias: "اسم الاسم المستعار",
            identityNumber: "رقم الهوية",
            name: "اسم",
            surname: "اسم العائلة",
            email: "بريد إلكتروني",
            addCard: "إضافة بطاقة",
            update: "تحديث",
            cancel: "يلغي",
            save: "يحفظ",
            saving: "إنقاذ",
            noInvoiceFound: "لا توجد فاتورة",
            year: "سنة",
            updating: "تحديث ...",
            newInvoiceForm: "فاتورة جديدة إنشاء نموذج",
            error: "خطأ",
            transactions: "خيارات",
            paymentMethodAdded: "تمت إضافة طريقة الدفع بنجاح",
            paymentMethodAddError: "لم يتم إضافة طريقة الدفع ، حدث خطأ",
            creditCardChanged: "لقد تغيرت بطاقة الائتمان بنجاح",
            errorOccurred: "حدث خطأ ، حاول مرة أخرى",
            billingDetailUpdated: "تم تحديث تفاصيل الفواتير بنجاح",
            invoiceCreated: "تم إنشاء الفاتورة بنجاح",
            paymentSuccess: "الدفع بنجاح ، شكرا لك",
            paymentFail: "فشل الدفع ، حاول مرة أخرى",
            billingAddressChanged: "لقد تغير عنوان الفواتير بنجاح",
            hidePlan: "إخفاء الخطة",
            informationShopping:
                "يتم التحكم في معلومات الدفع الخاصة بك ومعلومات الفواتير ومعلومات بطاقة الائتمان بواسطة Shopify.",
            trialTimeInformation:
                "تنتهي المحاكمة {dayCount} بعد أيام. إذا لم تقم بإدخال طريقة الدفع حتى انتهاء هذه الفترة ، فسيتم تبديلك تلقائيًا إلى الخطة المجانية من قبل النظام.",
            trialTimeInformationShort: "التجربة: يوم آخر {dayCount}",
            currentPlanLabel: "الخطة الحالية: {planName} ({agentCount} Agent)",
            changeCancelPlan: "خطة تغيير/إلغاء",
            oneAgent: "عامل",
            agent: "عامل",
            yourCurrentPlan: "الخطة الحالية",
            month: "شهر",
            billedMonthToMonth: "(فواتير من شهر إلى شهر)",
            selectAgentCount: "حدد عدد الوكيل",
            selectFreePlan: "حدد خطة مجانية",
            planDetails: "تخطيط التفاصيل",
            multiAgent: "(وكيل متعدد)",
            selectProPlan: "حدد خطة Pro",
            foreverFree: "مجاني للابد",
            websiteIntegration: "تكامل الموقع",
            websiteIntegrationUnlimited: "تكامل الموقع",
            ChatBotUnlimited: "chatbot",
            videoCallUnlimited: "مكالمة فيديو",
            multiAgentUpTo: "وكيل متعدد (تصل إلى {agentCount} Agent)",
            audioCallUnlimited: "مكالمة صوتية",
            screenSharingUnlimited: "مشاركة الشاشة",
            fileTransferUnlimited: "نقل الملف",
            autoChatAssignerUnlimited: "محال الدردشة التلقائي",
            multiLanguageTranslationUnlimited: "ترجمة السيارات",
            detailedReporting: "الإبلاغ",
            days30TrialsAvailable: "30 يوم تجارب متاحة",
            limitedArchiveLookupLastMo: "البحث المحدود أرشيف (آخر {monthCount} -mo)",
            fullCustomizationUnlimited: "التخصيص",
            planUpdated: "رائع ، تم تحديث خطتك.",
            planUpdating: "خطتك يتم تحديث ...",
            planUpdatingDescription: "يرجى الانتظار أثناء تحديث خطتك",
            done: "منتهي",
            freePlanUpdated: "تم تحديث خطتك كخطة مجانية. (Max Agent Credit: 1)",
            proPlanUpdated: "تم تحديث خطتك كخطة محترفة. (Max Agent Credit: {AgentCount})",
            canNotDwnGrade:
                "لا يمكن تخفيض خطتك من Pro {agentCountSecond} Agent (s) إلى {valNewPlnToUppr} {agentCountFirst}. ائتمانات وكيلك قيد الاستخدام.",
            deleteWarning: "يجب عليك حذف أو تعطيل {valDif} الوكيل (s)",
            warnMessage: "يجب أن تكون الخطة المحددة مختلفة عن الخطة الحالية",
            add: "يضيف",
            cancelYourPlan: "إلغاء خطتك",
            upgradeYourPlan: "ترقية خطتك",
            downgradeYourPlan: "خفض خطتك",
            agree: "يوافق",
            disagree: "تعارض",
            invoices: "فواتير",
            priceIntervals: "الفاصل الزمني للسعر",
            selectSiteAlias: "حدد أو أدخل اسم الموقع",
            selectPriceInterval: "حدد أو أدخل الفاصل الزمني للسعر",
            isRefunded: "هل يتم استرداده؟",
            invoiceId: "رقم الفاتورة",
            siteId: "الموقع لا",
            createdDate: "تاريخ الإنشاء",
            failCount: "عدد محاولات جلب الدفع الفاشلة",
            failDate: "تاريخ الدفع الفاشل",
            Dashboard: "لوحة القيادة",
            Agents: "عملاء",
            Integration: "اندماج",
            Settings: "إعدادات",
            Contacts: "جهات الاتصال",
            Domain: "اِختِصاص",
            lastActivity: "النشاط الاخير",
            basePrice: "السعر الأساسي",
            packagePrice: "سعر الطرد",
            whatsappPrice: "سعر whatsapp",
            realtimeVisitorCount: "زائر الوقت الحقيقي",
            suspend: "تعليق",
            partner: "شريك",
            plan: "يخطط",
            trialDay: "أيام المحاكمة",
            mobile: "متحرك",
            webSite: "موقع إلكتروني",
            websiteOrigins: "أصل موقع الويب",
            ownerName: "اسم المالك",
            ownerEmailAddress: "البريد الإلكتروني للمالك",
            discount: "تخفيض",
            daysLeft: "ايام متبقية",
            newTrialPopUp: "كم يوما يجب أن تكون الفترة التجريبية الجديدة؟",
            newWpPricePopUp: "كم هي رسوم WhatsApp الجديدة؟",
            newIGPricePopUp: "كم هي رسوم Instagram الجديدة؟",
            newBasePricePopUp: "كم هو سعر الأساس الجديد؟",
            siteInfoUpdated: "معلومات الموقع المحدثة",
            siteInfoNotUpdated: "معلومات الموقع لم يتم تحديثها",
            siteInfoNotUpdatedErr: "حدث خطأ! معلومات الموقع لم يتم تحديثها.",
        },
        tour: {
            closeChat: "وثيق الدردشة",
            ticket: "تذكرة",
            formStep: "خطوة الشكل",
            menuStep: "خطوة القائمة",
            contentStep: "خطوة المحتوى",
            menuTitle: "عنوان القائمة",
            messageContent: "محتوى الرسالة",
            goToLive: "Connect stistative",
            stats: "لوحة الإحصاء",
            settings: "إعدادات",
            status: "حالة",
            prevStep: "خطوة سابقة",
            nextStep: "الخطوة التالية",
            finish: "ينهي",
            skip: "يتخطى",
            skip2: "تخطي ، أعرف النظام",
            startTour: "بدء جولة",
            firstTimeIntro: "أنت تدخل النظام لأول مرة ، أريد تقديم التطبيق إذا سمحت",
            hi: "أهلاً",
            welcomeTo: "مرحبًا بك في دعم Supsis Live",
            statsPanel: "إنه شريط الحالة الذي يوضح أرقام الدردشة الكلية والنشطة التي تنتظر على الفور مع النظام ..",
            sidebarMenu: "قائمة طعام",
            sidebarMenuContent: "يمكنك التبديل بين الصفحات هنا.",
            representativePrivateMessage: "لوحة محادثة بين التمثيل",
            representativePrivateMessageContent: "يمكنك رؤية المحادثات الخاصة بين الوكلاء هنا.",
            helpMenu: "قائمة المساعدة",
            helpMenuContent: "يمكنك العثور على معلومات مساعدة حول النظام هنا ..",
            settingsMenu: "قائمة الإعدادات",
            settingsMenuContent: "يمكنك القيام باللغة والوضع الليلي وخطوات تكبير الشاشة هنا ..",
            startChat: "ابدأ الدردشة",
            profileMenu: "قائمة ملف التعريف",
            profileMenuContent: "يمكنك تغيير توافرك وتعيين إعدادات الوكيل هنا ..",
            visitorsTab: "الزائرين",
            visitorsTabContent: "يمكنك رؤية الزوار هنا.",
            visitorTabHistory: "تاريخ الزوار",
            visitorTabHistoryContent: "يمكنك رؤية تاريخ الزائر هنا.",
            representativeTab: "مندوب",
            representativeTabContent: "يمكنك رؤية الممثلين هنا.",
            liveSupport: "الدعم المباشر",
            liveSupportContent: "يمكنك رؤية عدد العملاء الذين يتلقون الدعم المباشر هنا ..",
            siteVisitors: "زوار الموقع",
            siteVisitorsContent: "يمكنك رؤية عدد زوار الموقع هنا.",
            tableSettings: "إعدادات الجدول",
            tableSettingsContent: "يمكنك إظهار أو إخفاء الأعمدة في الجدول هنا.",
            watchModeButton: "زر العارض",
            watchModeContent: "يمكنك الانضمام هنا كوضع للعارض ويمكنك فقط عرض ما يتم نشره.",
            popoverInfo: "تفاصيل الزائر",
            popoverInfoContent: "يعطي معلومات حول الزائر.",
            popoverButton: "إعدادات الدردشة المتقدمة",
            popoverButtonContent: "يمكنك فتح المحادثة ، وإرسال رسالة مباشرة إلى الممثل أو حظر الزائر.",
            openChat: "انضم إلى زر المحادثة",
            openChatContent: "يمكنك فتح المحادثة هنا",
            pagination: "قائمة الترحيل.",
            paginationContent: "يمكنك زيادة عدد الصفحات هنا.",
            changeLang: "يمكن تغيير لغة النظام",
            changeTheme: "يمكن تبديل المظلمة والخفيفة",
            changeStatus: "يمكن أن تغير حالة توافرك",
            logout: "يمكن نظام تسجيل الدخول من هنا",
            chatwindow: {
                chatWindowActionButtons: "أزرار عمل نافذة الدردشة",
                chatPanelActions: "إجراءات لوحة الدردشة",
                otherPanels: "لوحات أخرى",
                chatColorButton: "إظهار معنى ألوان شريط الدردشة",
                keyboardShortcutButton: "إظهار وظائف اختصارات KeyBpard",
                hideButton: "قلل من الدردشة الحالية دون خروج",
                closeButton: "إغلاق القوة والخروج من الدردشة الحالية",
                ellipsisButton: "المزيد من إجراءات الدردشة. تقليل ، إغلاق ، حظر الزائر ، إرسال رسالة خاصة ، تعيين ممثل",
                userInfoWidget: "إظهار تفاصيل زائر المالك لمستخدم الدردشة الحالي",
                preparedContentWidget:
                    "عنصر واجهة مستخدمة رسائل معدّة ، يمكنك تحديد إدخال قالب رسالة إلى الدردشة الحالية",
                chatHistoryWidget: "إذا كان هناك بعض تاريخ الدردشة للزوار الحالي ، فبإمكانه مشاهدتها",
                chatWindowSettingsButtons: "زر إعدادات نافذة الحديث",
                settingsButton: "يمكنك حظر المحادثة ، والتقدم ، والرسالة السرية وتعيين المندوبين.",
                chatBarButton: "هنا يمكنك منع محادثة نشطة ، وإرسال رسالة خاصة إلى الوكيل وترك المحادثة ..",
            },
        },
        adminUser: {
            newAdminUserForm: "نموذج تسجيل مستخدم المسؤول الجديد",
            updateAdminUserForm: "نموذج تحديث مستخدم المسؤول",
            adminUsers: "مستخدمي المسؤول",
            newAdminUser: "مستخدم مسؤول جديد",
            noAdminUser: "لا يوجد مستخدمين للمسؤول حتى الآن",
            adminUserName: "اسم مستخدم المسؤول",
        },
        report: {
            incomingMessages: "الرسائل الواردة",
            outgoingMessages: "الرسائل الصادرة",
            customerCount: "عدد العملاء",
            mailCount: "عدد البريد",
            answered: "تمت الإجابة",
            unanswered: "لم يتم الرد عليها",
            selectaChannel: "تحديد قناة",
            sentMails: "الرسائل المرسلة",
            sentMailCount: "عدد الرسائل المرسلة",
            eventCount: "عدد الأحداث",
            ticketDistribution: "توزيع التذاكر",
            selectWorkflow: "تحديد سير العمل الخاص بك",
            distributionOfTasks: "توزيع المهام",
            mostMissioned: "أكثر المهام",
            leastTask: "أقل المهام",
            totalNumberTasks: "إجمالي عدد المهام",
            erorFetchingTask: "خطأ في تلقي بيانات المهمة:",
            pipelinePhase: "مرحلة خط الأنابيب",
            status: "الحالة",
            numberOfTasks: "عدد المهام",
            insufficientData: "بيانات غير كافية",
            hourly: "(ساعيا)",
            hourlyAverage: "متوسط ساعي",
            hourlyMax: "الحد الأقصى الساعي",
            hourlyMin: "الحد الأدنى الساعي",
            totalAmount: "المبلغ الإجمالي",
            averageAmount: "المبلغ المتوسط",
            minAmount: "المبلغ الأدنى",
            maxAmount: "المبلغ الأقصى",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "سلاسل زمنية للقنوات",
            channelPies: "فطائر القنوات",
            pieView: "رسم بياني دائري",
            topVisitorCountry: "البلد الذي يأتي منه أكبر عدد من الزوار",
            websiteTrafficByCountry: "حركة مرور الموقع حسب البلد",
            visitorCount: "عدد الزوار",
            websiteVisitorTraffic: "حركة زوار الموقع",
            websiteTraffic: "حركة مرور الموقع",
            author: "المؤلف",
            topWorstComments: "أسوأ التعليقات",
            topBestComments: "أفضل التعليقات",
            topComments: "أفضل التعليقات",
            noComment: "لا توجد تعليقات بعد",
            minWaitingTime: "أقل وقت انتظار",
            maxWaitingTime: "أقصى وقت انتظار",
            averageWaitTime: "متوسط ​​وقت الانتظار",
            waitTime: "وقت الانتظار (ثواني)",
            agentWaitDurationTitle: "رسم بياني لمدة انتظار الوكيل",
            incomingMessage: "رسالة (رسائل) واردة",
            outgoingMessage: "رسالة (رسائل) صادرة",
            totalSpent: "إجمالي الإنفاق",
            avgSpent: "متوسط الإنفاق",
            totalPayment: "إجمالي الدفع",
            walletStatus: "حالة المحفظة",
            walletBalanceStatus: "حالة رصيد المحفظة",
            messageTraffic: "حركة الرسائل",
            breakCount: "عدد الفترات",
            agentBreakTime: "عدد فترات استراحة الوكلاء ☕",
            agentStatusHour: "ساعة حالة الوكيل",
            agentWorkTimeCalendar: "تقويم وقت عمل الوكيل",
            agentActivity: "نشاط الوكيل",
            noEnoughtData: "لا توجد بيانات كافية",
            averageFirstResponse: "متوسط ​​زمن الاستجابة الأولى",
            slowestResponser: "الأبطأ في الرد",
            fastestResponder: "الأسرع في الرد",
            firstAnswerTimeSec: "وقت الرسالة الأولى (بالثواني)",
            firstAnswerByAgent: "وقت الرسالة الأولى بواسطة الوكيل",
            averageSolutionTime: "متوسط ​​وقت الحل",
            slowestSolver: "أبطأ محلل",
            fastestSolver: "أسرع محلل",
            averageChat: "متوسط الدردشة",
            leastChatReceiver: "أقل مستقبل للدردشة",
            mostChatRecipients: "أكبر عدد من المستقبلين للدردشة",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "وقت الحل (دق)",
            resolveTimeByUser: "وقت حل الدردشة من قبل المستخدم (بالدقائق)",
            chatResolveTimeByAgent: "وقت حل الدردشة من قبل الوكلاء",
            chatDistByHandleType: "توزيع الدردشات حسب المعالج",
            chatDistByHandDesc: "كم عدد الدردشات التي تم التعامل معها من قبل الوكلاء والروبوتات الدردشة والهجينة؟",
            chatCountsByHandleType: "عدد الدردشات حسب نوع المعالجة",
            missed: "تم التفويت",
            chatDistByAnsDesc: "كم عدد المحادثات التي تم الرد عليها أو تم تفويتها؟",
            chatCountsByAns: "عدد الدردشات حسب الإجابة",
            chatCountByPlatform: "عدد الدردشات حسب المنصة",
            chatDistByPDesc: "كم دردشة وصلت إلى أي منصة؟",
            chatDistByPlatform: "توزيع الدردشة حسب المنصة",
            ticketCountByUser: "عدد التذاكر حسب الوكلاء",
            ticketCountByStatus: "عدد التذاكر حسب حالة الاستجابة",
            user: "مستخدم",
            saveAsImage: "حفظ كصورة",
            fullScreen: "ملء الشاشة",
            download: "تحميل",
            tableView: "عرض الجدول",
            chartView: "عرض الرسم البياني",
            chatDistByUsers: "توزيع المحادثات حسب المستخدمين",
            chatCountsByUsers: "عدد المحادثات حسب المستخدمين",
            minDuration: "الحد الأدنى من المدة",
            maxDuration: "الحد الأقصى للمدة",
            totalDurationByAgent: "إجمالي مدة الجلسة حسب الوكيل",
            averageDurationByAgent: "المدة المتوسطة للجلسة حسب الوكيل",
            totalDurationByCB: "إجمالي مدة الجلسة حسب الدردشة الآلية",
            averageDurationByCB: "المدة المتوسطة للجلسة حسب الدردشة الآلية",
            viewUnitAs: "عرض الوحدة كـ",
            hybrid: "هجين",
            handledBy: "تمت المعالجة بواسطة",
            sessionDurationOverall: "مدة الجلسة الإجمالية",
            allChannels: "جميع القنوات",
            sessionsDurationOverall: "مدة الجلسات الإجمالية",
            sessionsOverall: "جلسات بشكل عام",
            calendarEvents: "أحداث التقويم",
            reservationEvents: "أحداث الحجز",
            incomingMails: "رسائل البريد الواردة",
            incomingMailCount: "عدد رسائل البريد الواردة",
            reservation: "حجز",
            event: "حدث",
            reservationEventCount: "عدد أحداث الحجز",
            channelBreakdown: "توزيع القنوات",
            websiteAnalysis: "تحليل الموقع الإلكتروني",
            customerSatisfaction: "رضا العملاء",
            teamBreakAnalysis: "تحليل فواصل الفريق",
            dailyAgentActivity: "نشاط الوكيل اليومي",
            agentPerformance: "أداء الوكيل",
            chatDistributions: "توزيع المحادثات",
            users: "المستخدمين",
            segmentTimeseries: "سلسلة زمنية للقطاع",
            segmentsOverall: "القطاعات بشكل عام",
            unmatchRatio: "نسبة عدم التطابق",
            totalMatchCount: "إجمالي عدد التطابقات",
            totalUnmatchCount: "إجمالي عدم التطابق",
            matchRatio: "نسبة التطابق",
            matched: "مطابق",
            trainingOverall: "التدريب الشامل",
            trainingStatusTimeseries: "سلسلة زمنية لحالة التدريب",
            duration: "المدة",
            totalSessionDuration: "مدة الجلسة الإجمالية",
            averageSessionDuration: "متوسط مدة الجلسة",
            second: "ثانية",
            minute: "دقيقة",
            hour: "ساعة",
            aggregateAs: "تجميع كـ",
            chatbotSessionDurationOverall: "مدة جلسة الدردشة الآلية بشكل عام",
            ratingTimeSeries: "رسم بياني زمني للتقييمات",
            chatCountTimeseries: "سلسلة زمنية لعدد الدردشات",
            notRated: "غير مقيّم",
            totalRatingCount: "إجمالي عدد التقييمات",
            averageRating: "متوسط التقييم",
            weightedAverageRating: "متوسط التقييم المرجح",
            rate: "تقييم",
            ratingOverall: "تقييمات العملاء بشكل عام",
            session: "جلسة",
            total: "المجموع",
            average: "متوسط",
            max: "الحد الأقصى",
            min: "الحد الأدنى",
            sessionCount: "عدد الجلسات",
            uniqueUsers: "مستخدمون فريدون",
            viewAs: "عرض كـ",
            overall: "عام",
            detailReport: "تقرير مفصل",
            dailyReports: "التقارير اليومية",
            pointBasedReports: "التقارير القائمة على نقطة",
            personDateBasedPointReport: "تقرير النقطة القائمة على الشخص والتاريخ",
            personDateBasedReport: "التقرير القائم على الشخص والتاريخ",
            personBasedReport: "التقارير القائمة على الشخص",
            personAndDateBasedGraph: "الرسم البياني القائم على الشخص والتاريخ",
            noReport: "لايوجد تقرير",
            reports: "التقارير",
            totalBar: "المجموع",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: "عدد جميع الدردشات المفتوحة",
            active: "عدد الدردشة النشطة المعينة لك",
            waiting: "عدد الزوار في انتظار دخول ممثل",
            late: "عدد الزوار ينتظرون أكثر من فترة معينة",
            free: "عدد الزوار المجانيين الذين ينتظرون للممثل الجديد للدخول",
            pco: "[معدل استخدام السعة] معدل حمل العمل في قدرة الدردشة التمثيلية النشطة",
            maxCapacity: "الحد الأقصى لعدد الدردشة التي يمكن للنظام تعيين ممثلين دون الانتظار",
            chatbot: "عدد الدردشة النشطة مع Chatbot",
        },
        time: {
            lastYear: "العام الماضي",
            thisYear: "هذا العام",
            last3Months: "آخر 3 أشهر",
            last7: "آخر 7 أيام",
            today: "اليوم",
            yesterday: "أمس",
            lastWeek: "الأسبوع الماضي",
            currentWeek: "هذا الاسبوع",
            currentMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            last30Day: "آخر 30 يومًا",
            allTime: "كل الأوقات",
            custom: "موعد مخصص",
        },
        fastWizard: {
            generalColors: "الألوان العامة",
            tellUsMore: "أخبرنا أكثر ، حتى نتمكن من تخصيص تجربتك",
            moreInfo: "مزيد من المعلومات",
            display: "عرض",
            availability: "توافر",
            preview: "معاينة",
            installCode: "تثبيت رمز",
            previous: "سابق",
            setupSupsisLiveChat: "الإعداد Supsis الدردشة المباشرة",
            continue: "الخطوة التالية",
            completeInitialize: "الإعداد الكامل",
            completedMessage: "Supsis Live Chat Setup قد اكتمل بنجاح.",
            websiteIntegration: "عنوان موقع الويب الخاص بك لدمج الدردشة المباشرة Supsis",
            customizeLiveChat: "تخصيص الدردشة المباشرة الخاصة بك",
            createBrandedExperience: "قم بإنشاء تجربة دردشة ذات علامة تجارية لزوارك.",
            chatColor: "لون الدردشة",
            chooseChatColor: "اختر لون لهجة.",
            chatBubble: "فقاعة الدردشة",
            selectBubble: "حدد فقاعة الدردشة",
            chatBubbleColor: "لون فقاعة الدردشة",
            selectChatBubbleColor: "حدد لون فقاعة الدردشة",
            customSelection: "الاختيار المخصص:",
            chatAvailability: "توافر الدردشة",
            onlineSupportVisitorTime: "متى تكون على الإنترنت لدعم زوارك؟",
            channelAvailability: "توافر القناة",
            availability724: "الدردشة متوفرة 7/24",
            basedOnTeam: "بناءً على حالة عضو الفريق",
            basedOnTeamExplanation: "ستظهر الدردشة عبر الإنترنت عندما يتم تعيين عضو واحد على الأقل إلى متاح",
            customHours: "ساعات عمل مخصصة",
            customHoursExplanation: "تكوين ساعات عملك",
            customHoursTimezone: "وحدة زمنية:",
            customHoursFrom: "من:",
            customHoursTo: "ل:",
            customHoursAddHours: "+إضافة ساعات",
            previewDesktop: "سطح المكتب",
            previewIpad: "اى باد",
            installationAndInstructions: "تعليمات التحميل",
            installationTrackingCode: "قم بتثبيت رمز التتبع على موقع الويب الخاص بك",
            installationTrackingCodePlease:
                "يرجى لصق الرمز وفقًا للتعليمات أدناه ، قبل نهاية علامة {bodyTag} في أي صفحة تريد تمكين الدردشة المباشرة Supsis.",
            installationInstructionsJavascript: "الصق رمز التكامل الوارد أعلاه في علامة {bodyTag} قبل الإغلاق مباشرة.",
            installationInstructionsCopy: "ينسخ",
            installationInstructionsCoppyMessage: "تم نسخ البرنامج النصي للتكامل إلى الحافظة",
            installationInstructionsShopify1: "1. تسجيل الدخول إلى لوحة Shopify الخاصة بك",
            installationInstructionsShopify2:
                "2. انتقل إلى المتجر عبر الإنترنت> الموضوعات> القائمة المنسدلة الإجراءات ضمن السمة الحالية> تحرير الرمز> السمة. liquid",
            installationInstructionsShopify3:
                "3. ضع لصق رمز التكامل المذكور أعلاه قبل علامة {bodyTag} مباشرة في نهاية البرنامج النصي.",
            installationInstructionsIdeaSoft1: "1. تسجيل الدخول إلى لوحة الوكيل الخاصة بك.",
            installationInstructionsIdeaSoft2: "2. انتقل إلى الإعدادات -> SEO -> خدمات محرك البحث.",
            installationInstructionsIdeaSoft3: '3. حدد "التحقق من الموقع باستخدام علامة التعريف" من قسم رمز التتبع.',
            installationInstructionsIdeaSoft4: "4. نسخ ولصق رمز التكامل أعلاه في المربع المفتوح وحفظ.",
            installationInstructionsIdeaSoft5:
                '5. داخل الإعدادات -> ، انقر على زر "مسح ذاكرة التخزين المؤقت". وبالتالي اكتمل التكامل.',
            installationInstructionsWordPress1: "1. تسجيل الدخول إلى لوحة مسؤول WordPress الخاص بك",
            installationInstructionsWordPress2: "2. اذهب إلى المظهر> محرر السمة",
            installationInstructionsWordPress3:
                "3. ضمن ملفات السمة (أقصى اليمين) ، ابحث عن تذييل السمة (footer.php) وحدده",
            installationInstructionsWordPress4: "4. قم بتعبير رمز التكامل أعلاه قبل علامة {bodyTag} في الأسفل.",
            installationInstructionsWordPress5: "5. انقر فوق تحديث الملف لحفظ التغييرات",
            installationInstructionsOpenCart1: "1. تسجيل الدخول إلى لوحة مسؤول OpenCart",
            installationInstructionsOpenCart2: "2. انتقل إلى التصميم> محرر السمة",
            installationInstructionsOpenCart3: '3. حدد ملف "مشترك" وفتح "ملف Header.twig".',
            installationInstructionsOpenCart4: "4. قم بتعبئة رمز التكامل أعلاه قبل علامة {headTag} في الأسفل.",
            installationInstructionsOpenCart5: "5. انقر فوق زر حفظ.",
            installationInstructionsTicimax1: "1. تسجيل الدخول إلى لوحة إدارة Ticimax الخاصة بك",
            installationInstructionsTicimax2: "2. تصميم مفتوح> تصميم> إعدادات تصميم تذييل الرأس",
            installationInstructionsTicimax3: '3. انقر فوق الزر "المصدر" في قسم تصميم الشعار.',
            installationInstructionsTicimax4: "4. الصق رمز التكامل أعلاه أسفل رمز HTML.",
            installationInstructionsEticaretteyim1: "1. تسجيل الدخول إلى لوحة إدارة التجارة الإلكترونية الخاصة بك",
            installationInstructionsEticaretteyim2: "2. قم ببساطة بتسمية SUPSIS من الإضافات> إنشاء HTML> وانسخ الكود.",
            installationInstructions: "تعليمات",
            installationVerify: "تحقق من تثبيت موقع الويب الخاص بك من supsis",
            installationVerifyChecking: "تدقيق",
            installationVerifyCheck: "يفحص",
            installationVerifyCheckingStatus: "التحقق من حالة تكامل SUPSIS على {website}",
            installationCheckingStatusMessageYes: "رائع ، تم دمج supsis في موقع {website} !!",
            installationCheckingStatusMessageNo:
                "SUPSIS غير مدمج حاليًا مع موقع الويب {website}. يمكنك إكمال عملية الاندماج الخاصة بك الآن أو في وقت لاحق.",
            vtippyPreferredLanguage: "اللغة المفضلة",
        },
        akinon: {
            typeOrSelectSKU: "اكتب أو حدد SKU",
            akinonUserId: "معرف المستخدم AKINON",
            userEmail: "البريد الالكتروني للمستخدم",
            userEmailDesc: "اكتب أو حدد بريد إلكتروني المستخدم ...",
            send: "يرسل",
            selectCity: "اختر مدينة",
            city: "مدينة",
            selectState: "اختر ولايه",
            state: "ولاية",
            useMap: "استخدم الخريطة",
            chooseAddress: "اختر العنوان",
            selectCountry: "حدد الدولة",
            country: "دولة",
            productIdDesc: "اكتب أو حدد المنتج ...",
            productId: "معرف المنتج",
            userIdDesc: "اكتب معرف المستخدم Akinon ...",
            productSKU: "منتج SKU",
            latitudeDesc: "اكتب أو حدد خط عرض الموقع الهدف ...",
            longitudeDesc: "اكتب أو حدد خط الطول المستهدف ...",
            orderNumber: "رقم طلبك",
            orderDesc: "اكتب رقم الطلب ...",
            longitude: "خط الطول",
            latitude: "خط العرض",
        },
        headBar: {
            source: "المصدر",
            label: "التسمية",
            completed: "اكتمل؟",
            email: "بريد إلكتروني",
            phone: "هاتف",
            name: "اسم",
            date: "تاريخ",
            subject: "موضوع",
            situation: "حالة",
            representative: "ممثل",
            transactions: "المعاملات",
        },
        login: {
            loginTitle1: "SUPSIS",
            loginTitle2: "مرحبا بكم في",
            email: "عنوان البريد الإلكتروني الخاص بك",
            emailPlaceholder: "الرجاء إدخال عنوان البريد الإلكتروني الخاص بك.",
            emailError: "الرجاء إدخال بريد إلكتروني صحيح",
            password: "كلمة السر خاصتك",
            passwordLogin: "كلمة مرور مجانية تسجيل الدخول",
            passwordAndLogin: "تسجيل الدخول باستخدام كلمة المرور",
            passwordNew: "إعادة تعيين كلمة المرور الخاصة بي",
            loginAnd: "أو",
            passwordPlaceholder: "من فضلك أدخل رقمك السري.",
            loginMemory: "تذكر هذا الجهاز",
            passwordForget: "لقد نسيت كلمة المرور",
            passwordNewAgain: "كلمة سر جديدة",
            passwordNewAgainTwo: "كرر كلمة المرور الجديدة",
            passwordNewAgainPlaceholder: "الرجاء إدخال كلمة المرور الجديدة الخاصة بك.",
            passwordNewAgainPlaceholderTwo: "الرجاء إعادة إدخال كلمة المرور الجديدة الخاصة بك.",
            login: "تسجيل الدخول",
            loginFooter: "أو قم بتسجيل الدخول باستخدام البريد الإلكتروني",
            emailLogin: "تسجيل الدخول باستخدام البريد الإلكتروني",
        },
        settings: {
            ipAddress: "عنوان IP الخاص بي",
            whiteList: "قائمة عناوين IP الآمنة",
            whiteListAdd: "إضافة عنوان IP آمن",
            whiteListDeletedSuccessfully: "تم حذف قائمة الوصول بنجاح",
            whiteListDeletedFailed: "تم حذف قائمة الوصول بنجاح",
            whiteListAddedSuccessfully: "تم حذف قائمة الوصول بنجاح",
            whiteListAddedFailed: "تم حذف قائمة الوصول بنجاح",
            deleteWhiteListTitle: "هل أنت متأكد أنك تريد حذف هذا القائمة البيضاء؟",
            talkSettings: "إعدادات الكلام",
            talkSubtitles: "إدارة إعدادات الكلام الخاصة بك",
            changeSettings: "تغيير إعدادات تعيين الدردشة التلقائية",
            dateAndTime: "التاريخ والوقت",
            action: "الممثل",
            event: "حدث",
            accessControl: "التحكم في الوصول",
            organizationLongName: "الاسم الطويل للمؤسسة",
            visitorNewDesc: "يمكنك استخدام الإصدار الجديد من سمة الزائر",
            transactionType: "نوع المعاملة",
            priorBalance: "الرصيد السابق",
            nextBalance: "الرصيد التالي",
            amount: "المبلغ",
            phoneNumber: "رقم الهاتف",
            profileInfoRemoved: "تمت إزالة معلومات الملف الشخصي",
            newValueUpdated: "تم تحديث القيمة الجديدة",
            ballanceToTransferred: "الرصيد المراد تحويله",
            availableBalance: "الرصيد المتاح",
            balanceReceived: "الرصيد المستلم",
            totalBalance: "إجمالي الرصيد",
            paymentCard: "بطاقة الدفع",
            wpPhoneNumber: "رقم هاتف واتساب",
            wpSendingMessage: "إرسال رسالة واتساب الأولى",
            auditlogs: "سجلات التدقيق",
            myaccount: "حسابي",
            notifications: "الإشعارات",
            company: "شركة",
            features: "الميزات",
            general: "جنرال لواء",
            chat: "دردشة",
            timings: "توقيت",
            wallet: "محفظة",
            language: "لغة",
            "bubble-settings": "إعدادات الفقاعة",
            "bubble-actions": "إجراءات الفقاعة",
            "theme-settings": "إعدادات الموضوع",
            visitorLoginForm: "نموذج تسجيل الدخول للزائر",
            visitorAttribute: "معلومات ملف تعريف الزائر",
            timing_settings: "إعدادات التوقيت",
            auto_assign: "تعيين الدردشة التلقائية",
            availability: "توفر",
            "website-integration": "تكامل الموقع",
            General: "جنرال لواء",
            Chat: "دردشة",
            Timings: "توقيت",
            Integration: "تكامل",
            developer: "مطور",
            visitorNew: "زائر جديد",
            companySubtitles: "إدارة شركتك.",
            featuresSubtitles: "إدارة ميزات شركتك.",
            languageSubtitles: "إدارة لغة شركتك.",
            bubbleSettings: "إعدادات الفقاعة",
            bubbleSettingsSubtitles: "إدارة إعدادات الفقاعة الخاصة بشركتك.",
            bubbleActionsSubtitles: "إدارة إجراءات الفقاعة الخاصة بشركتك.",
            chatThemeSettingsSubtitles: "إدارة إعدادات موضوع الدردشة الخاصة بشركتك.",
            visitorLoginFormSubtitles: "إدارة نموذج تسجيل الدخول للزائر الخاص بشركتك.",
            chatTimingSettingsSubtitles: "إدارة إعدادات توقيت الدردشة الخاصة بشركتك.",
            webSiteIntegrationSubtitles: "إدارة إعدادات تكامل موقع الويب الخاصة بشركتك.",
            apiAccessTitle: "وصول API",
            apiAccessSubtitles: "إدارة وصول API الخاص بشركتك.",
            youTubeActionForm: "أضف قناتك على YouTube",
            linkedinActionForm: "أضف حساب لينكد إن الخاص بك",
            telegramActionForm: "أضف حساب Telegram",
            facebookActionForm: "أضف صفحتك على Facebook",
            tiwitterActionForm: "أضف صفحتك على Twitter",
            instagramActionForm: "أضف صفحتك على Instagram",
            liveSupportDescription: "دعم العملاء على موقع الويب الخاص بك",
            ticketDescription: "إدارة تذاكر العملاء",
            whatsappDescription: "دعم العملاء على WhatsApp",
            phoneDescription: "دعم العملاء على الهاتف",
            emailDescription: "دعم العملاء عبر البريد الإلكتروني",
            facebookDescription: "دعم العملاء على Facebook",
            twitterDescription: "دعم العملاء على Twitter",
            instagramDescription: "دعم العملاء على Instagram",
            youtubeDescription: "دعم العملاء على YouTube",
            linkedinDescription: "اسمح لعملائك بالوصول إليك عبر LinkedIn",
            telegramDescription: "اسمح لعملائك بالوصول إلى الحجم باستخدام Telegram",
            whatsappModalTitle: "نموذج إجراء WhatsApp",
            whatsappModalDescription: "يرجى ملء النموذج أدناه لإضافة رقم WhatsApp الخاص بك.",
            phoneModalTitle: "نموذج إجراء الهاتف",
            phoneModalDescription: "يرجى ملء النموذج أدناه لإضافة رقم هاتفك.",
            emailModalTitle: "نموذج إجراء البريد الإلكتروني",
            emailModalDescription: "يرجى ملء النموذج أدناه لإضافة عنوان بريدك الإلكتروني.",
            facebookModalTitle: "نموذج إجراء Facebook",
            facebookModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Facebook الخاصة بك.",
            twitterModalTitle: "نموذج إجراء Twitter",
            twitterModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Twitter الخاصة بك.",
            instagramModalTitle: "نموذج إجراء Instagram",
            instagramModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Instagram الخاصة بك.",
            youtubeModalTitle: "نموذج إجراء YouTube",
            youtubeModalDescription: "يرجى ملء النموذج أدناه لإضافة قناة YouTube الخاصة بك.",
            linkedinModalTitle: "نموذج معاملة LinkeIn",
            linkedinModalDescription: "يرجى ملء النموذج أدناه لربط حسابك على LinkedIn.",
            telegramModalTitle: "نموذج معاملة Telegram",
            telegramModalDescription:
                "أدخل رابط ملف تعريف Telegram الخاص بك في النموذج أدناه لربط حساب Telegram الخاص بك",
            instagramAlertTitle: "التكامل مع Instagram مطلوب",
            instagramAlertDesc: "عذرًا، سيتم تنشيط الصفحة التي زرتها عند تكامل Instagram الخاص بك.",
            instagramActivateText: "لنذهب، دمج Instagram",
            remove: "إزالة",
            edit: "تصحيح",
            connected: "متصل",
            add: "أضف",
            themeDescription: "إدارة موضوع شركتك.",
            fontDescription: "إدارة الخط الخاص بشركتك.",
            isFabsAsIcon: "إظهار نصوص رمز القائمة.",
            chatBubbleTextSetting: "إعداد نص فقاعة الدردشة",
            textOnChatBubble: "يمكنك ضبط إعدادات النص التي ستظهر في فقاعة الدردشة.",
            textToAppearOnChatBubble: "نص للظهور في فقاعة الدردشة",
            newVisitorProfileInformation: "معلومات ملف تعريف الزائر الجديد",
            newVisitorProfileInformationDescription: "يضيف قيمة جديدة لمعلومات ملف تعريف الزائر",
            create: "يخلق",
            newAdd: "اضف جديد",
            toInform: "لكي يعلم",
            toInformDescription: "يمكنك مطابقة القيم التي تضيفها في هذه الصفحة مع نموذج تسجيل دخول الزائر..",
            showVisitor: "إظهار الزائر",
            label: "تذكرة",
            text: "كتابة",
            email: "بريد إلكتروني",
            phone: "هاتف",
            number: "رقم",
            url: "URL",
            date: "وقت",
            dropdown: "اختيار",
            languageTimeZone: "اللغة والمنطقة",
            timeZoneTitle: "المنطقة والمنطقة الزمنية",
            timeZoneDescription: "إعدادات المنطقة الزمنية والمنطقة الزمنية",
        },
        userInfoWidget: {
            userInformation: "معلومات المستخدم",
            fullName: "الاسم الكنية",
            newValue: "قيمة جديدة",
            newProfileInfo: "معلومات الملف الشخصي الجديدة",
            affiliatedRepresentatives: "مندوب",
            preferredAgents: "الوكيل (الوكلاء) المفضل",
            labels: "تسميات",
            agentNotes: "ملاحظات الوكيل",
            newNote: "ملاحظة جديدة",
            note: "ملحوظة",
            available: "هناك ملاحظات متوفرة.",
            systemInformation: "معلومات النظام",
            speechID: "معرف الكلام",
            customerVersion: "معرف الكلام",
            IPAddress: "عنوان IP",
            pageVisited: "تمت زيارة الصفحة",
            systemAndBrowser: "نظام التشغيل والمتصفح",
            countryAndLanguage: "البلد واللغة",
            clickToEdit: "تحرير انقر داخل المنشور",
            adsYouAreInterestedIn: "الإعلانات التي تهتم بها",
            detail: "التفاصيل",
            adsTitle: "العنوان",
            adUrl: "رابط الإعلان",
            sourceID: "معرّف المصدر",
            resourceType: "نوع المصدر",
            adsBody: "المحتوى",
            adsCreateDate: "تاريخ الإنشاء",
            adsUpdateDate: "تاريخ التحديث",
        },
        newWizartV2: {
            generalSettings: "الاعدادات العامة",
            themeSettings: "إعدادات الموضوع",
            representativeWorkingHours: "ساعات عمل الممثل",
            preview: "معاينة",
            setup: "يثبت",
            formStepTitle: "قدم لنا المزيد من المعلومات حتى نتمكن من تخصيص تجربتك",
            supsisEntergation: "أين ستستخدم Supsis على موقع الويب الخاص بك؟",
            goToNextStep: "خذ الخطوة التالية",
            readytemplate: "استخدم قالب ألوان جاهز",
            customSettings: "إعدادات مخصصة",
            customerMessageView: "عرض رسالة العميل",
            backcgroundColor: "لون الخلفية",
            textColor: "لون الخط",
            agentMessageView: "عرض رسالة الوكيل",
            workingHours: "ما الفترات الزمنية التي تقدم فيها الخدمات للزائرين؟",
            continuousService: "الخدمة المستمرة",
            continuousServiceDescription: "فقاعة الدردشة نشطة دائمًا. حتى لو لم تكن في النظام.",
            vote: "قم باختيارك",
            representativeWorking: "ساعات عمل الممثل",
            representativeWorkingDescription:
                "تظهر الدردشة على الإنترنت عندما يكون هناك وكيل واحد على الأقل متصلاً بالإنترنت. إذا لم يكن هناك ممثل عبر الإنترنت ، فسيظهر على أنه غير متصل.",
            computer: "حاسوب",
            tablet: "لوح",
            uploadTrackingCodeToYourWebsite: "تحميل رمز التتبع على موقع الويب الخاص بك",
            password: "تعيين كلمة مرور جديدة",
        },
        whatsappChannel: {
            whatsappTitleV1: "قنوات Whatsapp V1 (QR)",
            whatsappTitleV2: "قنوات Whatsapp V2 (QR)",
            channelName: "اسم القناة",
            phoneNumber: "رقم الهاتف",
            forwardToChatbot: "إعادة توجيه إلى الروبوت الدردشة",
            forwardingChatbotOrLiveAgent: "إعادة توجيه (روبوت الدردشة أو وكيل مباشر)",
            addChannel: "إضافة قناة",
            newWhatsappChannel: "قناة جديدة على واتساب",
            newWhatsappChannelDescription: "أنشئ قناة واتساب جديدة عن طريق مسح رمز الاستجابة السريعة (QR)",
            editWhatsappChannel: "تحرير قناة واتساب",
            editWhatsappChannelDescription: "تحرير قناة واتساب",
            whatsappChannel: "قناة واتساب",
            deleteWhatsappChannelDescription: "هل أنت متأكد أنك تريد حذف هذه القناة؟",
            whatsappIntegration: "تكامل واتساب",
            deleteChannel: "حذف القناة",
            restartChannel: "إعادة تشغيل القناة",
            wantRestartChannel: "هل ترغب في إعادة تشغيل القناة؟",
            deleteSMSChannelDescription: "هل أنت متأكد أنك تريد حذف قناة الرسائل القصيرة؟",
            smsChannel: "قناة الرسائل القصيرة",
            maxChannelCount: "لا يمكنك إنشاء أكثر من قناة رسائل نصية واحدة!",
            smsModalText:
                "إن تكاملنا مع حلول الاتصالات الحديثة يمنحك الفرصة لإرسال الرسائل القصيرة بسهولة وفعالية. قم بإزالة الحدود في التواصل، وتواصل مباشرة مع عملائك!",
            smsModalBtn: "انقر لفتح قناة الرسائل القصيرة...",
            postaCellDetail: "تفاصيل قناة PostaCell",
        },
        noPermission: "ليس لديك إذن لأداء هذه العملية.",
        mail_integration_detail: {
            title: "تفاصيل البريد",
            integration: "التكامل",
            sender: "بريد المرسل",
            signature: "توقيع",
            inbox: "صندوق الوارد",
            medias: "وسائط",
            visibility: "الرؤية",
            settings_group: "الإعدادات",
            contacts: "جهات الاتصال",
        },
        whatsapp_business_api: {
            userVisibility: "رؤية المستخدم",
            userVisibilityDesc:
                "تعتمد القنوات التي يمكن للمستخدمين الوصول إليها على دورهم وإعدادات الرؤية الخاصة بالقناة. يمكن للمستخدمين الذين لديهم دور المسؤول الكامل أو الدور الجذر رؤية جميع القنوات. إذا كانت إعدادات رؤية القناة فارغة، تكون القناة عامة. ومع ذلك، إذا كانت القناة محددة لمستخدمين أو أقسام محددة، فيمكن لهؤلاء المستخدمين أو أعضاء الأقسام فقط رؤية القناة.",
            searchTemplate: "قالب البحث...",
            forwardToChatbot: "إعادة التوجيه إلى روبوت المحادثة",
            forwarding: "إعادة التوجيه (إلى روبوت المحادثة أو الوكيل المباشر)",
            forwardLiveAgents: "إعادة التوجيه إلى الدعم المباشر",
            forwardingToDepartment: "إعادة التوجيه إلى القسم",
            selectDepartment: "تحديد قسم",
            createWbChannel:
                "لإنشاء قناة واتساب للأعمال، يجب عليك شراء باقة واتساب للأعمال. يمكنك الوصول إلى باقات بأسعار معقولة على الفور.",
            wbCreateChannelMax: "لقد وصلت إلى الحد الأقصى لإنشاء قنوات واتساب للأعمال. الحد الأقصى",
            wbContinue:
                "يمكنك إنشاء قناة واتساب للأعمال. للمتابعة، قم بترقية باقتك أو احذف بعض قنوات واتساب للأعمال الخاصة بك.",
            chatInitiatorTemplate: "قالب بادئ الدردشة",
            selectChatInitiatorTemplate: "حدد قالب بادئ الدردشة الخاص بك.",
            dailyUsageReport: "تقرير الاستخدام اليومي",
            freeChat: "دردشة مجانية",
            paidChat: "دردشة مدفوعة",
            templateMessage: "قالب الرسالة",
            outgoingSession: "الجلسة الصادرة",
            incomingSession: "الجلسة الواردة",
            totalCost: "التكلفة الإجمالية",
            allOptNumbers: "جميع أرقام الاشتراك",
            startChat: "بدء الدردشة",
            lastMessageDate: "تاريخ آخر رسالة",
            sureDeleteTemplate: "هل أنت متأكد أنك تريد حذف هذا القالب؟",
            manageWhoChannelChat: "إدارة من يمكنه رؤية دردشات القناة هذه",
            profileImageDesc: "ستكون هذه لقطة شاشة واتساب لنشاطك التجاري.",
            businessDescription: "وصف نشاطك التجاري.",
            descOfWork: "وصف نشاطك التجاري ببضع كلمات (بحد أقصى 512 حرفًا).",
            accountStatus: "حالة الحساب.",
            dockerStatus: "حالة الإرساء.",
            phoneQuality: "جودة الهاتف.",
            customersOrDay: "يوم العملاء.",
            messagingLimit: "حد المراسلة.",
            canSendMessage: "يمكن إرسال رسالة.",
            officialDetails: "التفاصيل الرسمية.",
            officialDetailsDesc:
                "ستظهر هذه العناوين دائمًا في قسم الملف الشخصي للمستخدمين الذين يدردشون معك على واتساب. بعد التعديل، سنرسلها إلى واتساب للموافقة عليها.",
            addressLine: "سطر العنوان.",
            stateIfApplic: "الولاية (إن وجدت).",
            zipCodeOrPostCode: "الرمز البريدي/ الرمز البريدي.",
            selectCountry: "تحديد البلد.",
            selectBussVertical: "تحديد منطقة العمل.",
            saveInfo: "حفظ المعلومات.",
            active: "نشط.",
            banned: "محظور.",
            low: "منخفض.",
            medium: "متوسط.",
            high: "مرتفع.",
            connected: "متصل.",
            disConnected: "غير متصل.",
            flagged: "تم وضع علامة.",
            pending: "معلق.",
            restricted: "مقيد.",
            unknown: "غير معروف.",
            available: "متاح.",
            limited: "محدود.",
            blocked: "محظور.",
            success: "نجاح.",
            successDesc: "تم تحديث معلومات ملفك الشخصي بنجاح.",
            wabaOverview: "نظرة عامة على صحة WABA.",
            manageChannelDetail: "إدارة معلومات قناتك.",
            wpBussChannelDetail: "تفاصيل قناة واتساب للأعمال.",
            manageWpBussChannel: "إدارة قناة واتساب للأعمال الخاصة بك.",
            channelName: "اسم القناة.",
            phoneNumberE164: "رقم الهاتف (تنسيق E164).",
            phoneNumberE164Place: "رقم الهاتف (بتنسيق E164). على سبيل المثال 908501234455.",
            channelUpdatedSucs: "تم تحديث القناة بنجاح.",
            faieldUpdateChannel: "فشل تحديث القناة.",
            title: "قنوات واتساب Business API",
            integration: "التكامل",
            detail: "تفاصيل",
            visibility: "رؤية",
            templates: "جميع رسائل القوالب",
            settings_group: "إعدادات",
            template_message_group: "رسائل القوالب",
            chat_initiator_template: "قالب بدء الدردشة",
            contacts: "جهات الاتصال",
            numbers: "الأرقام",
            all_contacts: "كل الاتصالات",
            new_template: "إنشاء قالب جديد",
            broadcast_group: "بث",
            broadcast_requests: "طلبات البث",
            customer_groups: "مجموعات العملاء",
            businessChannelDetail: "تفاصيل قناة واتساب الأعمال",
            wallet: "Wallet",
            postacellMessage: "إرسال رسالة نصية",
            postacellAllMessage: "إرسال رسائل نصية جماعية",
            message_group: "رسالة",
            createNewTemplate: "إنشاء رسالة قالب جديدة",
            templateName: "اسم القالب",
            templateNameDesc: "قدم اسمًا لقالب الرسالة الخاص بك.",
            templateInfo: "معلومات القالب",
            viewTemplates: "عرض القوالب",
            templateNameRules: "اسم القالب يمكن أن يحتوي فقط على حروف صغيرة وأرقام وشرطات سفلية.",
            category: "الفئة",
            categoryDesc: "حدد نوع القالب الذي تريد إنشاءه",
            categoryUtility: "الأداة",
            categoryUtilityDesc: "أرسل معلومات مفيدة مثل تحديثات الحساب، تحديثات الطلبات، التنبيهات وأكثر.",
            categoryMarketing: "تسويق",
            categoryMarketingDesc: "أرسل عروض ترويجية، عروض منتجات، وأكثر لزيادة الوعي والمشاركة.",
            categoryAuth: "المصادقة",
            categoryAuthDesc: "أرسل رموزًا لعملائك للوصول إلى حساباتهم.",
            optional: "اختياري",
            languageDesc: "حدد اللغة التي سيتم إرسال رسالتك النموذجية بها",
            header: "عنوان",
            headerRules: "أضف عنوانًا يتكون من 60 حرفًا إلى رسالتك. يتم دعم متغير واحد فقط في العنوان.",
            headerOptionMedia: "وسائط",
            headerOptionText: "نص",
            none: "لا شيء",
            headerType: "نوع العنوان",
            headerText: "نص العنوان",
            body: "الجسم",
            bodyRules: "أدخل النص باللغة التي اخترتها لرسالتك",
            addVariable: "إضافة متغير",
            variables: "المتغيرات",
            variable: "متغير",
            defaultVariableName: "اسم المتغير الافتراضي",
            defaultVariableToolTip:
                "تظهر متغيراتك في القالب بهذا الاسم. <br><br> بالإضافة إلى ذلك ، يتم إرسال هذا القيمة كقيمة افتراضية في حالة وجود حالات أخرى.",
            selectATemplate: "اختر قالب الرسالة",
            variableSettings: "إعدادات المتغيرات",
            example: "مثال",
            footer: "تذييل",
            footerDesc: "أضف تذييلًا بطول 60 حرفًا إلى رسالتك. لا يتم دعم المتغيرات في التذييل.",
            buttons: "أزرار",
            buttonType: "نوع الزر",
            buttonTypeReply: "الرد",
            submit: "حفظ",
            submitting: "جاري الإرسال",
            addButton: "إضافة زر",
            rejectWhatsapp: "تم رفضها من قبل واتساب.",
            approvedWhatsapp: "تمت الموافقة عليها من قبل واتساب.",
            pendingWhatsapp: "قيد الانتظار للموافقة",
            daily_usages: "الاستخدامات اليومية",
        },
        multi_whatsapp_api: {
            profile: "الملف الشخصي",
            integration: "التكامل",
            detail: "التفاصيل",
            visibility: "الرؤية",
            templates: "جميع رسائل القوالب",
            settings_group: "الإعدادات",
            template_message_group: "رسائل القالب",
            new_template: "إنشاء قالب جديد",
            broadcast_group: "رسالة مجمعة",
            broadcast_requests: "إرسال رسائل مجمعة",
            customer_groups: "مجموعات العملاء",
            chat_initiator_template: "قالب بادئ الدردشة",
            contacts: "جهات الاتصال",
            numbers: "أرقام",
            all_contacts: "جميع جهات الاتصال",
        },
        archive: {
            destroyedBy: {
                agent: "الوكيل",
                visitor: "الزائر",
                system: "النظام",
                chatbot: "روبوت الدردشة",
            },
        },
        upgradeMessages: {
            ticket: "حتى عند عدم اتصالك بالإنترنت، تأكد من تسجيل طلباتك فورًا باستخدام الذكاء الاصطناعي والروبوتات. حافظ على رضا عملائك دائمًا!",
            tasks: "قم بإدارة مهامك ومشاريعك بسهولة. تعاون مع فريقك بسلاسة وسلم المشاريع في الوقت المحدد!",
            calendar: "خطط مواعيدك واجتماعاتك بسهولة. كن متزامنًا مع فريقك وأدر وقتك بكفاءة!",
            mail_integration: "قم بإدارة رسائل البريد الإلكتروني بسهولة. عزز تواصلك مع العملاء وحسن التعاون!",
            team_integration:
                "تواصل بشكل أسرع وأكثر فعالية مع فريقك. عزز التعاون واضمن تسليم المشاريع في الوقت المحدد!",
            webhook_integration: "قم بربط تطبيقاتك من خلال تكامل Webhook وسهل تبادل البيانات!",
            whatsapp_v2: "حسّن تواصلك مع عملائك من خلال تكامل WhatsApp لتجربة أسرع وأكثر كفاءة!",
            whatsapp: "قم بتحسين التواصل مع عملائك باستخدام تكامل WhatsApp لتحقيق تواصل أسرع وأكثر فعالية!",
            whatsapp_business_api: "استفد من واجهة WhatsApp Business API للتواصل مع عملائك بشكل أكثر فعالية وكفاءة!",
            instagram: "تفاعل مع عملائك بشكل أكثر كفاءة باستخدام تكامل Instagram!",
            messenger: "تواصل مع عملائك بسهولة من خلال تكامل Messenger!",
            sms_postacell: "تواصل مع عملائك بسرعة وفعالية من خلال تكامل الرسائل النصية القصيرة (SMS)!",
            ready_contents: "تساعدك المحتويات الجاهزة على التواصل مع عملائك بسرعة وفعالية.",
            automation: "قم بأتمتة سير عملك لتوفير الوقت وإدارة المهام بكفاءة!",
            form: "استخدم منشئ النماذج لتبسيط التفاعل مع العملاء، وجمع المعلومات القيمة، وتعزيز التعاون!",
            customer_tables: "قم بإنشاء جداول مخصصة وإدارة معلومات العملاء بكفاءة!",
            trendyol: "عزز تواصلك مع العملاء من خلال تكامل Trendyol لتحقيق تواصل سلس!",
            access_control: "احمِ بياناتك وامنع الوصول غير المصرح به باستخدام ميزات التحكم في الوصول!",
            upgrade: "ترقية اشتراكي",
            upgradeFeature: "اشترِ حزمة إضافية",
            featureNotAvailable: "الميزة غير متوفرة.",
            usageLimitExceeded: "تم تجاوز حد الاستخدام.",
            maxAgentCount: "قم بترقية خطتك لخدمة المزيد من العملاء عن طريق إضافة وكلاء إضافيين.",
            maxTriggerCount: "قم بترقية خطتك لإنشاء المزيد من التفاعلات عن طريق إضافة المزيد من المحفزات.",
            visitorStartChat: "قم بترقية خطتك لبدء المحادثات مع الزوار الذين لم يتفاعلوا من قبل.",
            voiceCalling: "قم بترقية خطتك للتواصل بشكل أكثر فاعلية مع العملاء من خلال المكالمات الصوتية.",
            videoCalling: "قم بترقية خطتك للتواصل بشكل أكثر فاعلية مع العملاء من خلال المكالمات المرئية.",
            fileAndVoiceMessage: "قم بترقية خطتك لإرسال الملفات والرسائل الصوتية لعملائك.",
            autoTranslation: "قم بترقية خطتك لخدمة المزيد من العملاء باستخدام الترجمة التلقائية للرسائل.",
            telegramEntegration: "قم بترقية خطتك لتمكين التكامل مع تيليجرام.",
            chatCopilot: "قم بترقية خطتك لتوفير خدمة أفضل باستخدام مساعد الدردشة المدعوم بالذكاء الاصطناعي.",
            calenderEntegration: "قم بترقية خطتك لمزامنة تقويمك مع التطبيقات الأخرى.",
            mailEntegration: "قم بترقية خطتك لإدارة البريد الإلكتروني بشكل أكثر فاعلية وتحسين التواصل مع العملاء.",
            smsEntegration: "قم بترقية خطتك للوصول إلى عملائك بشكل أسرع من خلال تكامل الرسائل القصيرة.",
            ticketSystem: "قم بترقية خطتك لإدارة طلبات العملاء بشكل أكثر كفاءة من خلال نظام التذاكر.",
            taskManagementEntegration: "قم بترقية خطتك لتحسين تدفق العمل من خلال تكامل إدارة المهام.",
            webhookEntegration: "قم بترقية خطتك لمزامنة التطبيقات الأخرى من خلال تكامل webhook.",
            readyContents: "قم بترقية خطتك لتعزيز التواصل مع العملاء من خلال المحتوى الجاهز.",
            automationEntegration: "قم بترقية خطتك لتحسين تدفق العمل باستخدام تكامل الأتمتة.",
            customerTablesEntegration: "قم بترقية خطتك لإدارة بيانات العملاء بشكل أكثر فعالية باستخدام جداول العملاء.",
            formEntegration: "قم بترقية خطتك لإدارة طلبات العملاء بشكل أكثر فعالية باستخدام النماذج.",
            maxFormLimit: "قم بترقية خطتك لإنشاء المزيد من النماذج وإدارة طلبات العملاء بشكل أفضل.",
            maxFormFieldLimit: "قم بترقية خطتك لإضافة المزيد من الحقول إلى النماذج وتحسين إدارة طلبات العملاء.",
            maxCustomerTableCount: "قم بترقية خطتك لإضافة المزيد من جداول العملاء.",
            maxCustomerTableFieldCount: "قم بترقية خطتك لإضافة المزيد من الحقول إلى جداول العملاء.",
            maxCustomerTableViewCount: "قم بترقية خطتك لحفظ المزيد من عرض جداول العملاء.",
            maxCustomerTableRecordCount: "قم بترقية خطتك لإضافة المزيد من السجلات إلى جداول العملاء.",
            maxAutomationButton: "قم بترقية خطتك لإضافة المزيد من كتل الأتمتة.",
            automationTimerBase: "قم بترقية خطتك لاستخدام مؤقتات الأتمتة.",
            automationEventBase: "قم بترقية خطتك لاستخدام أحداث الأتمتة.",
            automationWebhookBase: "قم بترقية خطتك لاستخدام webhooks للأتمتة.",
            automationButtonBase: "قم بترقية خطتك لاستخدام أزرار الأتمتة.",
            liveScore: "قم بترقية خطتك لتمكين ميزة المراقبة الحية.",
            multipleChatWindow: "قم بترقية خطتك لفتح عدة نوافذ للدردشة في نفس الوقت.",
            maxTaskWorkflowLimit: "قم بترقية خطتك لإضافة المزيد من تدفقات العمل المهام.",
            maxTaskColumnLimit: "قم بترقية خطتك لإضافة المزيد من الأعمدة في المهام.",
            maxTaskRowLimit: "قم بترقية خطتك لإضافة المزيد من الصفوف في المهام.",
            maxDepartmentLimit: "قم بترقية خطتك لإضافة المزيد من الأقسام.",
            maxRoleLimit: "قم بترقية خطتك لإضافة المزيد من الأدوار.",
            maxReadyContentsLimit: "قم بترقية خطتك لإضافة المزيد من المحتويات الجاهزة.",
            excelDownload: "قم بترقية خطتك لتمكين ميزة تنزيل ملفات Excel.",
            customerGroup: "قم بترقية خطتك لاستخدام ميزة مجموعات العملاء.",
            maxMailCount: "قم بترقية خطتك لإرسال المزيد من الرسائل الإلكترونية.",
            maxWhatsappChannel: "قم بترقية خطتك لإضافة المزيد من قنوات واتساب.",
            maxBusinessWhatsappChannel: "قم بترقية خطتك لإضافة المزيد من قنوات واتساب للأعمال.",
            maxInstagramChannel: "قم بترقية خطتك لإضافة المزيد من قنوات إنستاجرام.",
            maxMessengerChannel: "قم بترقية خطتك لإضافة المزيد من قنوات ماسنجر.",
            maxTelegramChannel: "قم بترقية خطتك لإضافة المزيد من قنوات تيليجرام.",
            maxTrendyolChannel: "قم بترقية خطتك لإضافة المزيد من قنوات ترينديول.",
            maxMetaLeadChannel: "قم بترقية خطتك لإضافة المزيد من قنوات ميتا ليد.",
        },
    },
};

export default messagesAR;
